// // import React, { useEffect, useRef, useState } from "react";
// // import {
// //   Box,
// //   Button,
// //   MenuItem,
// //   Typography,
// //   TableContainer,
// //   Table,
// //   TableHead,
// //   TableBody,
// //   Dialog,
// //   DialogActions,
// //   DialogContent,
// //   IconButton,
// //   List,
// //   ListItem,
// //   ListItemText,
// //   Autocomplete,
// //   TableRow,
// //   TableCell,
// //   TextField,
// //   Paper,
// // } from "@mui/material";
// // import Grid from "@mui/material/Grid";
// // import { useForm } from "react-hook-form";
// // import { useLocation, useNavigate } from "react-router-dom";
// // import styles from "../../../styles.module.css";
// // import {
// //   Breadcrumb,
// //   CTSinput,
// // } from "../../reusableComponent/Reusables";
// // import EditIcon from "@mui/icons-material/Edit";
// // import SaveIcon from "@mui/icons-material/Save";
// // import AddIcon from "@mui/icons-material/Add";
// // import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// // import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// // import SearchIcon from "@mui/icons-material/Search";
// // import CancelIcon from "@mui/icons-material/Cancel";
// // import { useDispatch } from "react-redux";
// // import dayjs from "dayjs";
// // import emptyCylinderInspectionService from "../../../services/emptyCylinderInspection.Service";
// // import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";
// // import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
// // import plantMasterService from "../../../services/masters/plantMaster.Service";
// // import depotMasterService from "../../../services/masters/depotMaster.Service";
// // import CameraAltSharpIcon from "@mui/icons-material/CameraAltSharp";
// // import { Html5Qrcode } from "html5-qrcode";
// // import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// // import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// // import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// // import CustomPagination from "../../reusableComponent/CustomPagination";
// // // ── Shared styles matching PlantAdd ──────────────────────────────────────────

// // const pageSx = {
// //   background: "#F4F7FB",
// //   minHeight: "100vh",
// //   padding: "20px 24px 40px",
// //   fontFamily: "'Inter', Arial, sans-serif",
// // };

// // const breadcrumbSx = {
// //   fontSize: "12px",
// //   color: "#718096",
// //   mb: 2,
// //   display: "flex",
// //   alignItems: "center",
// //   gap: "6px",
// // };

// // const pageHeaderSx = {
// //   display: "flex",
// //   alignItems: "center",
// //   justifyContent: "space-between",
// //   mb: 2.5,
// // };

// // const pageTitleSx = {
// //   fontSize: "16px",
// //   fontWeight: 700,
// //   color: "#000000",
// //   display: "flex",
// //   alignItems: "center",
// //   gap: "10px",
// // };

// // const backBtnSx = {
// //   display: "flex",
// //   alignItems: "center",
// //   gap: "6px",
// //   fontSize: "13px",
// //   fontWeight: 600,
// //   color: "#2B6CB0",
// //   padding: "7px 14px",
// //   border: "1.5px solid #2B6CB0",
// //   borderRadius: "7px",
// //   background: "#fff",
// //   cursor: "pointer",
// //   textTransform: "none",
// //   "&:hover": { background: "#E6F1FB" },
// // };

// // const formCardSx = {
// //   background: "#fff",
  
// //   border: "1px solid #E2E8F0",
// //   overflow: "hidden",
// //   mb: 2,
// // };

// // const sectionHeaderSx = {
// //   background: "#1C3A5E",
// //   padding: "12px 22px",
// //   display: "flex",
// //   alignItems: "center",
// //   gap: "10px",
// // };

// // const sectionHeaderTitleSx = {
// //   fontSize: "13px",
// //   fontWeight: 600,
// //   color: "#fff",
// //   letterSpacing: "0.3px",
// // };

// // const formBodySx = { padding: "22px 24px" };

// // const fieldLabelSx = {
// //   fontSize: "12px",
// //   fontWeight: 600,
// //   color: "#2063b6",
// //   mb: "4px",
// //   display: "flex",
// //   alignItems: "center",
// //   gap: "4px",
// // };

// // const inputSx = {
// //   "& .MuiOutlinedInput-root": {
// //     borderRadius: "8px",
// //     fontSize: "13px",
// //     fontFamily: "'Inter', Arial, sans-serif",
// //     background: "#fafafa",
// //     height: "38px",
// //     "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
// //     "&:hover fieldset": { borderColor: "#CBD5E0" },
// //     "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
// //     "&.Mui-focused": { background: "#fff" },
// //     "&.Mui-disabled": { background: "#F8FAFC" },
// //   },
// //   "& input": {
// //     color: "#1A202C",
// //     fontSize: "13px",
// //     fontFamily: "'Inter', Arial, sans-serif",
// //     "&::placeholder": { color: "#A0AEC0", opacity: 1 },
// //   },
// //   "& .MuiInputLabel-root": { display: "none" },
// // };

// // const readonlyInputSx = {
// //   ...inputSx,
// //   "& .MuiOutlinedInput-root": {
// //     ...inputSx["& .MuiOutlinedInput-root"],
// //     background: "#F0F4F8",
// //   },
// // };

// // const okInputSx = {
// //   ...inputSx,
// //   "& .MuiOutlinedInput-root": {
// //     ...inputSx["& .MuiOutlinedInput-root"],
// //     "& fieldset": { borderColor: "#38A169", borderWidth: "1.5px" },
// //     "&:hover fieldset": { borderColor: "#2F855A" },
// //     "&.Mui-focused fieldset": { borderColor: "#2F855A", borderWidth: "2px" },
// //   },
// //   "& .MuiSelect-select": { color: "#2F855A !important" },
// // };

// // const notOkInputSx = {
// //   ...inputSx,
// //   "& .MuiOutlinedInput-root": {
// //     ...inputSx["& .MuiOutlinedInput-root"],
// //     "& fieldset": { borderColor: "#E53E3E", borderWidth: "1.5px" },
// //     "&:hover fieldset": { borderColor: "#C53030" },
// //     "&.Mui-focused fieldset": { borderColor: "#C53030", borderWidth: "2px" },
// //   },
// //   "& .MuiSelect-select": { color: "#E53E3E !important" },
// // };

// // const formFooterSx = {
// //   padding: "18px 24px",
// //   background: "#F8FAFC",
// //   borderTop: "1px solid #E2E8F0",
// //   display: "flex",
// //   alignItems: "center",
// //   justifyContent: "flex-end",
// //   gap: "10px",
// // };

// // const saveBtnSx = {
// //   display: "flex",
// //   alignItems: "center",
// //   gap: "7px",
// //   padding: "0 22px",
// //   height: "40px",
// //   background: "#4CAF50",
// //   color: "#fff",
// //   border: "none",
// //   fontSize: "14px",
// //   fontWeight: 600,
// //   textTransform: "none",
// //   borderRadius: "8px",
// //   fontFamily: "'Inter', Arial, sans-serif",
// //   "&:hover": { background: "#028b19", transform: "translateY(-1px)" },
// //   "&:active": { transform: "translateY(0)" },
// //   transition: "all 0.15s ease",
// // };

// // const cancelBtnSx = {
// //   display: "flex",
// //   alignItems: "center",
// //   gap: "7px",
// //   padding: "0 22px",
// //   height: "40px",
// //   background: "#E53E3E",
// //   color: "#ffffff",
// //   border: "none",
// //   "&:hover": { background: "#971f16", transform: "translateY(-1px)" },
// //   fontSize: "14px",
// //   fontWeight: 600,
// //   borderRadius: "8px",
// //   textTransform: "none",
// // };

// // const menuItemSx = { fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" };

// // // ── Helpers ───────────────────────────────────────────────────────────────────




// // const getResultColor = (value) => {
// //   if (value === "Ok") return "#2F855A";
// //   if (value === "Not Ok") return "#E53E3E";
// //   return "#A0AEC0";
// // };

// // const normalizeResult = (value) => {
// //   if (!value) return "";
// //   const v = value.trim().replace(/\s+/g, " ").toLowerCase();
// //   if (v === "ok") return "Ok";
// //   if (v === "not ok") return "Not Ok";
// //   return value === "Ok" || value === "Not Ok" ? value : "";
// // };

// // const getStatusSx = (value) => (value === "Not Ok" ? notOkInputSx : okInputSx);

// // // ─────────────────────────────────────────────────────────────────────────────

// // const EmptyCylinderInspectionAdd = () => {
// //   const dispatch = useDispatch();
// //   const { handleSubmit } = useForm();
// //   const urlLocation = useLocation();
// //   const editInfo = urlLocation.state;
// //   const editData = editInfo && editInfo;
// //   const navigate = useNavigate();
// //   const login_details = sessionStorage.getItem("loginUser");
// //   const userD = JSON.parse(login_details);
// //   const userInfo = userD.result.userInfo;
// //   const depot_id = userInfo.depot_id;
// //   const plant_id = userInfo.plant_id;
// //   const unit_id = userInfo.depot_id || userInfo.plant_id;
// //   const short_code = userInfo.depot_short_code || userInfo.plant_short_code;

// //   const [data, setData] = useState({
// //      acetone_used: editData ? editData.acetone_used : "0.00",
// //     cyl_id: editData ? editData.cyl_id : "",
// //     inspection_id: editData ? editData.inspection_id : "",
// //     entry_no: editData ? editData.entry_no : "",
// //     entry_date: editData?.entry_date ? dayjs(editData.entry_date).format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD"),
// //     cylinder_no: editData ? editData.cylinder_no : "",
// //     valve_condition: editData ? normalizeResult(editData.valve_condition) : "Ok",
// //     fusible_plug: editData ? normalizeResult(editData.fusible_plug) : "Ok",
// //     painting: editData ? normalizeResult(editData.painting) : "Ok",
// //     cyl_cap_avl: editData ? normalizeResult(editData.cyl_cap_avl) : "Ok",
// //     eci_result: editData ? normalizeResult(editData.eci_result) : "OK",
// //     current_tare_wt: editData ? editData.current_tare_wt : "",
// //     actual_tare_wt: editData ? editData.actual_tare_wt : "",
// //     actual_tare_wt_aft_sol: editData ? editData.actual_tare_wt_aft_sol : "",
// //     qty_solvent: editData ? editData.qty_solvent : "",
// //     acetone_drum_tag_no: editData ? editData.acetone_drum_tag_no : "",
// //     from_depot: editData ? editData.from_depot : "",
// //     from_plant_id: unit_id,
// //     to_plant_id: unit_id,
// //     shift: editData ? editData.shift : "shift1",
// //     shift_time: editData ? editData.shift_time : "08:00",
// //     done_by: userInfo.plant_id || "",
// //     fin_year: editData ? editData.fin_year : dayjs().month() >= 3 ? `${dayjs().year()}-${dayjs().year() + 1}` : `${dayjs().year() - 1}-${dayjs().year()}`,
// //     unit_id: editData ? editData.unit_id : 1,
// //     modified_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
// //     modified_by: editData ? userInfo.user_id : null,
// //     created_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
// //     created_by: editData ? editData.created_by : userInfo.user_id,
// //   });

// //   const [cylinder, setCylinder] = useState([]);
// //   const [plant, setPlant] = useState([]);
// //   const [depot, setDepot] = useState([]);
// //   const [ecimap, setEcimap] = useState([]);
// //   const [tagMap, setTagMap] = useState({});
// //   const [openDialog, setOpenDialog] = useState(false);
// //   const [isMultiDialog, setIsMultiDialog] = useState(false);
// //   const [tableData, setTableData] = useState([]);
// //   const [dialogData, setDialogData] = useState({
// //     cylinder_no: "", cyl_id: "", tag_no: "",
// //     valve_condition: "Ok", fusible_plug: "Ok", painting: "Ok", cyl_cap_avl: "Ok", eci_result: "OK",
// //     current_tare_wt: "", actual_tare_wt: "", actual_tare_wt_aft_sol: "", qty_solvent: "",
// //     acetone_drum_tag_no: "", from_plant: "", to_plant: "", shift_time: "", shift: "", done_by: "",
// //   });
// //   const [multiDialogData, setMultiDialogData] = useState({ cylinder_nos: "" });
// //   const [editIndex, setEditIndex] = useState(null);
// //   const [successMessage, setSuccessMessage] = useState(null);
// //   const [controller, setController] = useState({ page: 0, rowsPerPage: 10 });
// // const total_count = tableData.length;

// // const handleChangePage = (event, newPage) => {
// //   setController(prev => ({ ...prev, page: newPage }));
// // };

// // const paginatedTableData = tableData.slice(
// //   controller.page * controller.rowsPerPage,
// //   controller.page * controller.rowsPerPage + controller.rowsPerPage
// // );
// //   const [isScannerOpen, setIsScannerOpen] = useState(false);
// //   const [scanResults, setScanResults] = useState([]);
// //   const [openSnackbar, setOpenSnackbar] = useState(false);
// //   const qrCodeRegionId = "qr-reader";
// //   const html5QrCodeRef = useRef(null);
// //   const scannerStateRef = useRef({ isStarting: false, isStopping: false });
// //   const lastScanTimeRef = useRef(0);
// //   const debounceDelay = 500;
// //   const [singleCylinderInput, setSingleCylinderInput] = useState("");
// //   const [singleCylinderDetails, setSingleCylinderDetails] = useState(null);
// //   const [multiCylinders, setMultiCylinders] = useState([]);

// //   const handleChange = ({ target }) => {
// //     const { name, value } = target;
// //     if (name === "entry_date") {
// //       const formattedDate = dayjs(value).isValid() ? dayjs(value).format("YYYY-MM-DD") : "";
// //       const financialYear = formattedDate ? dayjs(formattedDate).month() >= 3 ? `${dayjs(formattedDate).year()}-${dayjs(formattedDate).year() + 1}` : `${dayjs(formattedDate).year() - 1}-${dayjs(formattedDate).year()}` : "";
// //       setData(prev => ({ ...prev, entry_date: formattedDate, fin_year: financialYear }));
// //     } else {
// //       setData(prev => ({ ...prev, [name]: value }));
// //     }
// //   };

// // useEffect(() => {
// //   const total = tableData.reduce((sum, row) => {
// //     return sum + (parseFloat(row.qty_solvent) || 0);
// //   }, 0);
// //   setData(prev => ({ ...prev, acetone_used: total > 0 ? total.toFixed(2) : "0.00" }));
// // }, [tableData]);

// //   const handleDialogChange = async ({ target }) => {
// //     const { name, value } = target;
// //     let normalizedValue = value;
// //     if (["valve_condition", "fusible_plug", "painting", "cyl_cap_avl", "eci_result"].includes(name)) {
// //       normalizedValue = normalizeResult(value);
// //     }
// //     let newDialogData = { ...dialogData };
// //     if (["current_tare_wt", "actual_tare_wt", "actual_tare_wt_aft_sol"].includes(name)) {
// //       normalizedValue = parseFloat(value) || 0;
// //       newDialogData = { ...dialogData, [name]: normalizedValue };
// //       const tare = name === "current_tare_wt" ? normalizedValue : parseFloat(dialogData.current_tare_wt);
// //       const aftSol = name === "actual_tare_wt_aft_sol" ? normalizedValue : parseFloat(dialogData.actual_tare_wt_aft_sol);
// //       newDialogData.qty_solvent = aftSol - tare;
// //     } else if (name === "qty_solvent") {
// //       normalizedValue = parseFloat(value);
// //       newDialogData = { ...dialogData, qty_solvent: normalizedValue };
// //     } else if (name === "cylinder_no") {
// //       const selectedCylinder = cylinder.find(cyl => cyl.tag_no === value);
// //       let cylinderCode = selectedCylinder ? selectedCylinder.cylinder_no : "";
// //       if (!cylinderCode && value) {
// //         try {
// //           const cylinderData = await cylinderMasterService.getCylinderList(value);
// //           cylinderCode = cylinderData.cylinder_no || "";
// //         } catch (error) { console.error("Error fetching cylinder_no:", error); }
// //       }
// //       newDialogData = { ...dialogData, cylinder_no: value, cyl_id: selectedCylinder ? selectedCylinder.cyl_id : "", tag_no: selectedCylinder ? selectedCylinder.cylinder_no : "", eci_result: normalizeResult(selectedCylinder?.note) || dialogData.eci_result, actual_tare_wt: selectedCylinder?.tare_wt ? selectedCylinder.tare_wt : dialogData.actual_tare_wt };
// //     } else {
// //       newDialogData = { ...dialogData, [name]: normalizedValue };
// //     }
// //     setDialogData(newDialogData);
// //   };

// //   const handleMultiDialogChange = ({ target }) => setMultiDialogData({ cylinder_nos: target.value });

// //   const handleOpenDialog = () => {
// //     setDialogData({ cylinder_no: "", cyl_id: "", tag_no: "", valve_condition: "Ok", fusible_plug: "Ok", painting: "Ok", cyl_cap_avl: "Ok", eci_result: "OK", current_tare_wt: "", actual_tare_wt: "", actual_tare_wt_aft_sol: "", qty_solvent: "", acetone_drum_tag_no: "", from_plant: "", to_plant: "", done_by: "" });
// //     setEditIndex(null); setIsMultiDialog(false); setOpenDialog(true); setScanResults([]);
// //   };

// //   const handleOpenmulDialog = () => {
// //     setMultiDialogData({ cylinder_nos: "" });
// //     setEditIndex(null); setIsMultiDialog(true); setOpenDialog(true); setScanResults([]);
// //   };

// //   const handleEditRow = (index) => {
// //     setDialogData({ ...tableData[index], eci_result: normalizeResult(tableData[index].eci_result) || "Ok" });
// //     setEditIndex(index); setIsMultiDialog(false); setOpenDialog(true); setScanResults([]);
// //   };

// //   const handleCloseDialog = () => { stopScanner(); setOpenDialog(false); setScanResults([]); };

// //   const handleDialogSubmit = () => {
// //     if (isMultiDialog) {
// //       if (!multiCylinders.length) { setSuccessMessage("Please enter at least one valid cylinder"); setOpenSnackbar(true); return; }
// //       const newRows = multiCylinders.filter(cyl => !tableData.some((row, idx) => idx !== editIndex && row.cyl_id === cyl.cyl_id)).map(cyl => ({ cylinder_no: cyl.cylinder_no, cyl_id: cyl.cyl_id, tag_no: cyl.tag_no, valve_condition: "Ok", fusible_plug: "Ok", painting: "Ok", cyl_cap_avl: "Ok", eci_result: "", current_tare_wt: 0, actual_tare_wt: cyl.tare_wt || 0, actual_tare_wt_aft_sol: 0, qty_solvent: 0, acetone_drum_tag_no: "", from_plant: "", to_plant: "", shift_time: data.shift_time, shift: data.shift, done_by: data.done_by }));
// //       if (!newRows.length) { setSuccessMessage("All cylinders already added"); setOpenSnackbar(true); return; }
// //       setTableData(prev => [...prev, ...newRows]);
// //       setMultiCylinders([]); setMultiDialogData({ cylinder_nos: "" }); setOpenDialog(false); stopScanner();
// //       setSuccessMessage("Cylinders added successfully"); setOpenSnackbar(true);
// //     } else {
// //       const requiredFields = [{ key: "cylinder_no", name: "Cylinder Number" }, { key: "valve_condition", name: "Valve Condition" }, { key: "fusible_plug", name: "Fusible Plug" }, { key: "painting", name: "Painting" }, { key: "cyl_cap_avl", name: "Cylinder Cap Availability" }, { key: "eci_result", name: "ECI Result" }];
// //       const missingFields = requiredFields.filter(field => !dialogData[field.key]);
// //       if (missingFields.length > 0) { setSuccessMessage(`Please fill: ${missingFields.map(f => f.name).join(", ")}`); setOpenSnackbar(true); return; }
// //       if (tableData.some((row, idx) => idx !== editIndex && row.cyl_id === dialogData.cyl_id)) { setSuccessMessage("Cylinder already added"); setOpenSnackbar(true); return; }
// //       const normalizedDialogData = { ...dialogData, valve_condition: normalizeResult(dialogData.valve_condition), fusible_plug: normalizeResult(dialogData.fusible_plug), painting: normalizeResult(dialogData.painting), cyl_cap_avl: normalizeResult(dialogData.cyl_cap_avl), eci_result: normalizeResult(dialogData.eci_result), remarks: dialogData.eci_result === "Not Ok" ? dialogData.remarks || "" : "", current_tare_wt: dialogData.current_tare_wt ? Number(dialogData.current_tare_wt) || 0 : 0, actual_tare_wt: dialogData.actual_tare_wt ? Number(dialogData.actual_tare_wt) || 0 : 0, actual_tare_wt_aft_sol: dialogData.actual_tare_wt_aft_sol ? Number(dialogData.actual_tare_wt_aft_sol) || 0 : 0, qty_solvent: dialogData.qty_solvent ? Number(dialogData.qty_solvent) || 0 : 0, acetone_drum_tag_no: dialogData.acetone_drum_tag_no || "" };
// //       if (urlLocation.state?.openDialog) { setSuccessMessage("Inspection details saved"); setOpenSnackbar(true); setOpenDialog(false); stopScanner(); }
// //       else {
// //         if (editIndex !== null) setTableData(prev => { const n = [...prev]; n[editIndex] = normalizedDialogData; return n; });
// //         else setTableData(prev => [...prev, normalizedDialogData]);
// //         setSuccessMessage("Cylinder details saved"); setOpenSnackbar(true); setOpenDialog(false); stopScanner();
// //       }
// //     }
// //   };

// //   const handleRemoveRow = (index) => setTableData(prev => prev.filter((_, i) => i !== index));

// //   const startScanner = () => {
// //     if (scannerStateRef.current.isStarting || isScannerOpen) return;
// //     scannerStateRef.current.isStarting = true;
// //     setIsScannerOpen(true);
// //   };

// //   const stopScanner = () => {
// //     if (scannerStateRef.current.isStopping || !html5QrCodeRef.current) { setIsScannerOpen(false); return; }
// //     if (!html5QrCodeRef.current.isScanning) { setIsScannerOpen(false); return; }
// //     scannerStateRef.current.isStopping = true;
// //     html5QrCodeRef.current.stop().then(() => { html5QrCodeRef.current.clear(); setIsScannerOpen(false); scannerStateRef.current.isStopping = false; }).catch(err => { setIsScannerOpen(false); scannerStateRef.current.isStopping = false; });
// //   };

// //   const findCylinderByNoOrTag = (input, cylinderList) => {
// //     if (!input) return null;
// //     const val = input.trim().toLowerCase();
// //     return cylinderList.find(cyl => (cyl.cylinder_no && cyl.cylinder_no.toLowerCase() === val) || (cyl.tag_no && cyl.tag_no.toLowerCase() === val));
// //   };

// //   const fetchSingleCylinderDetails = (input) => {
// //     if (!input) { setSingleCylinderDetails(null); return; }
// //     const match = findCylinderByNoOrTag(input, cylinder);
// //     if (match) {
// //       setSingleCylinderDetails(match);
// //       setDialogData(prev => ({ ...prev, cylinder_no: match.tag_no, tag_no: match.cylinder_no, owner: match.owner, cyl_id: match.cyl_id, actual_tare_wt: match.tare_wt, eci_result: prev.eci_result }));
// //       setSuccessMessage("Cylinder found"); setOpenSnackbar(true); setSingleCylinderInput("");
// //     } else { setSingleCylinderDetails(null); setSuccessMessage("No cylinder found"); setOpenSnackbar(true); }
// //   };

// //   const addMultiCylinder = (input) => {
// //     if (!input) return;
// //     const match = findCylinderByNoOrTag(input, cylinder);
// //     if (match) {
// //       setMultiCylinders(prev => {
// //         if (prev.some(c => c.cyl_id === match.cyl_id)) { setSuccessMessage("Already added"); setOpenSnackbar(true); return prev; }
// //         setSuccessMessage("Cylinder added"); setOpenSnackbar(true);
// //         return [...prev, match];
// //       });
// //     } else { setSuccessMessage("No cylinder found"); setOpenSnackbar(true); }
// //   };

// //   useEffect(() => {
// //     async function fetchData() {
// //       try {
// //         const [cylinderData, plantData, depotData, ecimapData, RelatedCylinder] = await Promise.all([
          
// //           cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: "" }),
// //           plantMasterService.getPlantList({ page: 0, size: 999, searchKey: "" }),
// //           depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
// //           emptyCylinderInspectionService.getEciList({ page: 0, size: 999, searchKey: "" }),
// //           emptyCylinderInspectionService.getCylinders(plant_id),
// //         ]);
// //         if (!Array.isArray(RelatedCylinder)) throw new Error("cylinderData is not an array");
// //         setCylinder(RelatedCylinder); setPlant(plantData); setDepot(depotData); setEcimap(ecimapData);
// //         if (!editData) {
// //   const lastRaw = ecimapData?.[0]?.lastECIEntryNo ?? "";
// //   const parts = String(lastRaw).split("/");
// //   const lastSeq = parseInt(parts[parts.length - 1]) || 0;
// //   const nextSeq = lastSeq + 1;

// //   const yr = dayjs();
// //   const finYear = yr.month() >= 3
// //     ? `${yr.year()}-${String(yr.year() + 1).slice(-2)}`
// //     : `${yr.year() - 1}-${String(yr.year()).slice(-2)}`;

// //   const formattedEntryNo = `${short_code}/${finYear}/${String(nextSeq).padStart(4, "0")}`;
// //   setData(prev => ({ ...prev, entry_no: formattedEntryNo }));
// // }
// //         const tagMapping = {};
// //         cylinderData.forEach(item => {
// //           if (!item.is_deleted) {
// //             if (item.cylinder_no?.trim()) tagMapping[item.cylinder_no.trim().toLowerCase()] = { cylinder_no: item.tag_no, cyl_id: item.cyl_id, tag_no: item.cylinder_no };
// //             if (item.tag_no?.trim()) tagMapping[item.tag_no.trim().toLowerCase()] = { cylinder_no: item.tag_no, cyl_id: item.cyl_id, tag_no: item.cylinder_no };
// //           }
// //         });
// //         setTagMap(tagMapping);
// //         const userPlant = plantData.find(p => p.plant_id === plant_id);
// //         if (userPlant) { setData(prev => ({ ...prev, from_plant: userPlant.plant_name, done_by: userPlant.plant_name })); setDialogData(prev => ({ ...prev, from_plant: userPlant.plant_name, done_by: userPlant.plant_name })); }
// //       } catch (error) { console.error("Error fetching data:", error); }
// //     }
// //     fetchData();
// //   }, [plant_id]);

// //   useEffect(() => {
// //     if (editData && typeof editData.tableData === "string") {
// //       try {
// //         const parsed = JSON.parse(editData.tableData);
// //         setTableData(parsed.map(row => ({ ...row, valve_condition: normalizeResult(row.valve_condition), fusible_plug: normalizeResult(row.fusible_plug), painting: normalizeResult(row.painting), cyl_cap_avl: normalizeResult(row.cyl_cap_avl), eci_result: normalizeResult(row.eci_result), actual_tare_wt: row.actual_tare_wt || "" })));
// //       } catch (e) { setTableData([]); }
// //     }
// //   }, [editData]);

// //   useEffect(() => {
// //     if (!isScannerOpen || !openDialog) { if (html5QrCodeRef.current?.isScanning) stopScanner(); return; }
// //     const element = document.getElementById(qrCodeRegionId);
// //     if (!element) { setIsScannerOpen(false); scannerStateRef.current.isStarting = false; return; }
// //     if (html5QrCodeRef.current?.isScanning) { scannerStateRef.current.isStarting = false; return; }
// //     html5QrCodeRef.current = new Html5Qrcode(qrCodeRegionId);
// //     const onQrScanSuccess = (decodedText) => {
// //       const now = Date.now();
// //       if (now - lastScanTimeRef.current < debounceDelay) return;
// //       lastScanTimeRef.current = now;
// //       if (isMultiDialog) { setMultiDialogData({ cylinder_nos: decodedText }); addMultiCylinder(decodedText); setTimeout(() => setMultiDialogData({ cylinder_nos: "" }), 1000); }
// //       else { fetchSingleCylinderDetails(decodedText); stopScanner(); }
// //       setScanResults(prev => [...prev, decodedText]);
// //     };
// //     html5QrCodeRef.current.start({ facingMode: "environment" }, { fps: 10, qrbox: 250 }, onQrScanSuccess, () => {}).then(() => { scannerStateRef.current.isStarting = false; }).catch(err => { setIsScannerOpen(false); scannerStateRef.current.isStarting = false; });
// //     return () => { if (html5QrCodeRef.current?.isScanning && !scannerStateRef.current.isStopping) { try { html5QrCodeRef.current.stop(); html5QrCodeRef.current.clear(); } catch {} } };
// //   }, [isScannerOpen, openDialog, isMultiDialog, tagMap, cylinder, depot, depot_id, tableData, editIndex]);

// //   useEffect(() => {
// //     if (urlLocation.state?.openDialog && urlLocation.state?.rowData) {
// //       const row = urlLocation.state.rowData;
// //       setSingleCylinderDetails({ cylinder_no: row.cylinder_no || "", tag_no: row.tag_no || "", cyl_id: row.cyl_id || "", owner: row.owner || "N/A", cust_name: row.cust_name || "" });
// //       setDialogData({ cylinder_no: row.cylinder_no || "", cyl_id: row.cyl_id || "", tag_no: row.tag_no || "", owner: row.owner || "", valve_condition: normalizeResult(row.valve_condition) || "Ok", fusible_plug: normalizeResult(row.fusible_plug) || "Ok", painting: normalizeResult(row.painting) || "Ok", cyl_cap_avl: normalizeResult(row.cyl_cap_avl) || "Ok", eci_result: normalizeResult(row.eci_result) || "Ok", current_tare_wt: row.current_tare_wt || "", actual_tare_wt: row.actual_tare_wt || "", actual_tare_wt_aft_sol: row.actual_tare_wt_aft_sol || "", qty_solvent: row.qty_solvent || "", acetone_drum_tag_no: row.acetone_drum_tag_no || "", from_plant: row.from_plant || data.from_plant || "", to_plant: row.to_plant || "", shift_time: row.shift_time || data.shift_time || "08:00", shift: row.shift || data.shift || "shift1", done_by: row.done_by || data.done_by || "" });
// //       setSingleCylinderInput(row.cylinder_no || ""); setEditIndex(null); setIsMultiDialog(false); setOpenDialog(true);
// //     }
// //   }, [urlLocation.state, data.from_plant, data.shift, data.shift_time, data.done_by]);

// //   useEffect(() => {
// //     async function fetchAndMapCylinders() {
// //       try {
// //         const cylinderData = await emptyCylinderInspectionService.getCylinders(plant_id);
// //         if (!Array.isArray(cylinderData)) throw new Error("Not an array");
// //         setTableData(cylinderData.map(cyl => ({ cylinder_no: cyl.cylinder_no || "", cyl_id: cyl.cyl_id || "", tag_no: cyl.tag_no || "", owner: cyl.owner || "", valve_condition: "Ok", fusible_plug: "Ok", painting: "Ok", cyl_cap_avl: "Ok", eci_result: "", current_tare_wt: "", actual_tare_wt: cyl.tare_wt ? Number(cyl.tare_wt) : "", actual_tare_wt_aft_sol: "", qty_solvent: "", acetone_drum_tag_no: "", from_plant: data.from_plant || "", to_plant: "", shift: data.shift || "shift1", shift_time: data.shift_time || "08:00", done_by: data.done_by || "" })));
// //       } catch (error) { setTableData([]); }
// //     }
// //     fetchAndMapCylinders();
// //   }, [plant_id, data.from_plant, data.shift, data.shift_time, data.done_by]);

// //   const onSubmit = async () => {
// //     if (!data || Object.keys(data).length === 0 || tableData.length === 0) { setSuccessMessage("Please fill required fields"); setOpenSnackbar(true); return; }
// //     const validTableData = tableData.filter(row => row.eci_result === "Ok" || row.eci_result === "Not Ok");
// //     if (validTableData.length === 0) { setSuccessMessage("No record to save"); setOpenSnackbar(true); return; }
// //     const eciData = { ...data, entry_date: dayjs(data.entry_date).format("YYYY-MM-DD"), tableData: validTableData, modified_at: dayjs().format("YYYY-MM-DD HH:mm:ss"), created_at: dayjs().format("YYYY-MM-DD HH:mm:ss"), changedUpdatedValue: "edit", short_code, unit_id };
// //     try {
// //       if (editData) await emptyCylinderInspectionService.editDeleteEci(eciData);
// //       else await emptyCylinderInspectionService.addEci(eciData);
// //       setSuccessMessage(editData ? "Updated successfully" : "Saved successfully");
// //       setOpenSnackbar(true);
// //       setTimeout(() => { setOpenSnackbar(false); navigate(-1); }, 3000);
// //     } catch (error) { setSuccessMessage("Error occurred during save"); setOpenSnackbar(true); }
// //   };

// //   const shiftOptions = [{ label: "Shift 1", value: "shift1" }, { label: "Shift 2", value: "shift2" }, { label: "Shift 3", value: "shift3" }];

// //   // Status pill for table
// //   const StatusPill = ({ value }) => {
// //     const isOk = value === "Ok";
// //     const isNotOk = value === "Not Ok";
// //     const isPassed = value === "Ok";
// //     return (
// //       <Box sx={{ display: "inline-flex", alignItems: "center", px: 1.5, py: 0.3, borderRadius: "20px", fontSize: "11px", fontWeight: 600, background: isOk ? "#F0FFF4" : isNotOk ? "#FFF5F5" : "#F7FAFC", color: isOk ? "#2F855A" : isNotOk ? "#E53E3E" : "#A0AEC0" }}>
// //         {value || "—"}
// //       </Box>
// //     );
// //   };

// //   return (
// //     <LocalizationProvider dateAdapter={AdapterDayjs}>
// //       <Box sx={pageSx}>
// //         {/* Breadcrumb */}
// //         <Box sx={breadcrumbSx}>
// //           <span>Dashboard</span> / <span style={{ color: "#2B6CB0", fontWeight: 600 }}>Empty Cylinder Inspection</span>
// //         </Box>

// //         {/* Page Header */}
// //         <Box sx={pageHeaderSx}>
// //           <Box sx={pageTitleSx}>
// //             <SearchIcon sx={{ fontSize: 20, color: "#1C3A5E" }} />
// //             {editData ? "UPDATE" : "CREATE"} INSPECTION
// //           </Box>
// //           <Button onClick={() => navigate(-1)} sx={backBtnSx}>
// //             <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
// //           </Button>
// //         </Box>

// //         {/* Last Entry */}
// //         {!editData && (
// //           <Box sx={{ textAlign: "right", fontSize: "12px", color: "#718096", mb: 1.5 }}>
// //             Last Entry No: {ecimap?.[0]?.lastScheduleEntryNo ?? 0}
// //           </Box>
// //         )}

// //         <form onSubmit={handleSubmit(onSubmit)}>
// //           {/* ── Section 1: Inspection Details ────────────────────────── */}
// //           {/* ── Section 1: Inspection Details ────────────────────────── */}
// // <Box sx={formCardSx}>
// //   <Box sx={sectionHeaderSx}>
// //     <SearchIcon sx={{ fontSize: 18, color: "#fff" }} />
// //     <Typography sx={sectionHeaderTitleSx}>Inspection Details</Typography>
// //   </Box>
// //   <Box sx={formBodySx}>

// //     {/* Two-column layout matching ProductionEntryAdd */}
// //     <Grid container sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>

// //       {/* LEFT COLUMN — empty / logo / decorative */}
// //       <Grid
// //         item xs={12} md={6}
// //         sx={{
// //           p: 2.5,
        
// //           borderBottom: { xs: "2px dashed #CBD5E0", md: "none" },
// //           display: "flex",
// //           alignItems: "center",
// //           justifyContent: "center",
// //           minHeight: 200,
// //         }}
// //       >
// //         {/* Aap yahan logo ya kuch aur rakh sakte ho, ya blank chhod do */}
// //         {/* <Typography sx={{ fontSize: "13px", color: "#A0AEC0" }}>
// //           — Inspection Summary —
// //         </Typography> */}
// //       </Grid>

// //       {/* RIGHT COLUMN — all fields */}
// //       <Grid item xs={12} md={6} sx={{ p: 2.5, background: "#FAFBFC", pl: 3.5 }}>
// //         <Grid container spacing={1.5}>

// //           {/* Entry No */}
// //           <Grid item xs={12} sm={6}>
// //             <Typography sx={fieldLabelSx}>Entry No</Typography>
// //             <TextField
// //               size="small" fullWidth name="entry_no"
// //               value={data.entry_no} sx={readonlyInputSx}
// //               InputProps={{ readOnly: true }} placeholder="Auto-generated"
// //             />
// //           </Grid>

// //           {/* Entry Date */}
// //           <Grid item xs={12} sm={6}>
// //             <Typography sx={fieldLabelSx}>
// //               Entry Date <span style={{ color: "#E53E3E" }}>*</span>
// //             </Typography>
// //             <DatePicker
// //               format="DD/MM/YYYY"
// //               value={data.entry_date ? dayjs(data.entry_date) : null}
// //               onChange={nv => handleChange({ target: { name: "entry_date", value: nv ? nv.format("YYYY-MM-DD") : "" } })}
// //               slotProps={{ textField: { size: "small", fullWidth: true, required: true, sx: inputSx } }}
// //             />
// //           </Grid>

// //           {/* Shift */}
// //           <Grid item xs={12} sm={6}>
// //             <Typography sx={fieldLabelSx}>Shift</Typography>
// //             <Autocomplete
// //               options={shiftOptions} fullWidth
// //               getOptionLabel={o => typeof o === "string" ? o : o.label}
// //               value={shiftOptions.find(s => s.value === data.shift) || null}
// //               onChange={(e, nv) => handleChange({ target: { name: "shift", value: nv ? nv.value : "" } })}
// //               isOptionEqualToValue={(o, v) => o.value === v.value}
// //               renderOption={(props, option) => <MenuItem {...props} sx={menuItemSx}>{option.label}</MenuItem>}
// //               renderInput={(params) => <TextField {...params} size="small" fullWidth sx={inputSx} placeholder="Select shift" />}
// //             />
// //           </Grid>

// //           {/* Shift Time */}
// //           <Grid item xs={12} sm={6}>
// //             <Typography sx={fieldLabelSx}>Shift Time</Typography>
// //             <TextField
// //               type="time" size="small" fullWidth
// //               name="shift_time" value={data.shift_time}
// //               onChange={handleChange} sx={inputSx}
// //             />
// //           </Grid>

// //           {/* Done By */}
// //           <Grid item xs={12} sm={6}>
// //             <Typography sx={fieldLabelSx}>Inspection Done By</Typography>
// //             <TextField
// //               type="text" size="small" fullWidth
// //               name="done_by" value={data.done_by}
// //               onChange={handleChange} sx={inputSx}
// //               placeholder="Enter name"
// //             />
// //           </Grid>
// //           {/* Acetone Used (KG) */}
// // <Grid item xs={12} sm={6}>
// //   <Typography sx={fieldLabelSx}>Acetone Used (KG)</Typography>
// //   <TextField
// //     size="small" fullWidth
// //     value={data.acetone_used}
// //     sx={readonlyInputSx}
// //     InputProps={{ readOnly: true }}
// //     placeholder="Auto-calculated"
// //   />
// // </Grid>

// //         </Grid>
// //       </Grid>

// //     </Grid>
// //   </Box>
// // </Box>
// //           {/* ── Section 2: Cylinder Inspection Table ─────────────────── */}
// //           <Box sx={formCardSx}>
// //             {/* <Box sx={sectionHeaderSx}>
// //               <SearchIcon sx={{ fontSize: 18, color: "#fff" }} />
// //               <Typography sx={sectionHeaderTitleSx}>Cylinder Inspection List</Typography>
// //             </Box> */}

// //             <TableContainer>
// //               <Table size="small" stickyHeader>
// //                 <TableHead>
// //                   <tr>
// //                     {[
// //   { label: "Sr No", align: "center" },
// //   { label: "Cyl No", align: "left" },
// //   { label: "Tag No", align: "left" },
// //   { label: "Valve", align: "left" },
// //   { label: "Fusible Plug", align: "left" },
// //   { label: "Painting", align: "left" },
// //   { label: "Cap Avl", align: "left" },
// //   { label: "Result", align: "left" },
// //   { label: "Actual Tare Wt", align: "right" },
// //   { label: "Current Wt", align: "right" },
// //   { label: "Wt After Solvent", align: "right" },
// //   { label: "Qty Solvent", align: "right" },
// //   { label: "Acetone Drum Tag", align: "left" },
// //   { label: "Action", align: "center" },
// // ].map(({ label, align }) => (
// //   <th key={label} style={{
// //     background: "#1C3A5E", color: "#fff", fontSize: "11px", fontWeight: 600,
// //     fontFamily: "'Inter', Arial, sans-serif", padding: "10px 10px",
// //     borderRight: "1px solid rgba(255,255,255,0.1)", whiteSpace: "nowrap",
// //     textAlign: align,
// //   }}>{label}</th>
// // ))}
// //                   </tr>
// //                 </TableHead>
// //                 <TableBody>
// //                 {paginatedTableData.map((row, index) => (
// //   <tr
// //     key={index}
// //     onClick={() => handleEditRow(controller.page * controller.rowsPerPage + index)}
// //     style={{ background: index % 2 === 0 ? "#fff" : "#F8FAFC", cursor: "pointer", borderBottom: "1px solid #E2E8F0" }}
// //     onMouseEnter={e => e.currentTarget.style.background = "#EBF4FF"}
// //     onMouseLeave={e => e.currentTarget.style.background = index % 2 === 0 ? "#fff" : "#F8FAFC"}
// //   >
// //     {/* Sr No */}
// //     <td style={{ padding: "8px 10px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", textAlign: "center" }}>
// //       {controller.page * controller.rowsPerPage + index + 1}
// //     </td>
// //     {/* Cyl No */}
// //     <td style={{ padding: "8px 10px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", textAlign: "left" }}>
// //       {row.cylinder_no}
// //     </td>
// //     {/* Tag No */}
// //     <td style={{ padding: "8px 10px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", textAlign: "left" }}>
// //       {row.tag_no}
// //     </td>
// //     {/* Valve, Fusible Plug, Painting, Cap Avl */}
// //     {["valve_condition", "fusible_plug", "painting", "cyl_cap_avl"].map(field => (
// //       <td key={field} style={{ padding: "8px 10px", textAlign: "left" }}>
// //         <StatusPill value={row[field]} />
// //       </td>
// //     ))}
// //     {/* Result */}
// //     <td style={{ padding: "8px 10px", textAlign: "left" }}>
// //       <Box sx={{ display: "inline-flex", alignItems: "center", px: 1.5, py: 0.3, borderRadius: "20px", fontSize: "11px", fontWeight: 700, background: row.eci_result === "Ok" ? "#F0FFF4" : row.eci_result === "Not Ok" ? "#FFF5F5" : "#F7FAFC", color: row.eci_result === "Ok" ? "#2F855A" : row.eci_result === "Not Ok" ? "#E53E3E" : "#A0AEC0" }}>
// //         {row.eci_result === "Ok" ? "Passed" : row.eci_result === "Not Ok" ? "Not Passed" : row.eci_result || "—"}
// //       </Box>
// //     </td>
// //     {/* Actual Tare Wt, Current Wt, Wt After Solvent */}
// //     {[row.actual_tare_wt, row.current_tare_wt, row.actual_tare_wt_aft_sol].map((val, i) => (
// //       <td key={i} style={{ padding: "8px 10px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", textAlign: "right" }}>
// //         {val}
// //       </td>
// //     ))}
// //     {/* Qty Solvent */}
// //     <td style={{ padding: "8px 10px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", textAlign: "right" }}>
// //       {Number(row.qty_solvent).toFixed(2)}
// //     </td>
// //     {/* Acetone Drum Tag */}
// //     <td style={{ padding: "8px 10px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", textAlign: "left" }}>
// //       {row.acetone_drum_tag_no}
// //     </td>
// //     {/* Action */}
// //     <td style={{ padding: "8px 10px", textAlign: "center" }} onClick={e => e.stopPropagation()}>
// //       <Box sx={{ display: "flex", justifyContent: "center", gap: 0.5 }}>
// //         <IconButton size="small" onClick={() => handleEditRow(controller.page * controller.rowsPerPage + index)} sx={{ color: "#2063b6", "&:hover": { background: "#EBF4FF" }, borderRadius: "6px" }}>
// //           <EditIcon sx={{ fontSize: "15px" }} />
// //         </IconButton>
// //         <IconButton size="small" onClick={e => { e.stopPropagation(); handleRemoveRow(controller.page * controller.rowsPerPage + index); }} sx={{ color: "#E53E3E", "&:hover": { background: "#FFF5F5" }, borderRadius: "6px" }}>
// //           <DeleteForeverIcon sx={{ fontSize: "16px" }} />
// //         </IconButton>
// //       </Box>
// //     </td>
// //   </tr>
// // ))}
// //                   {tableData.length === 0 && (
// //                     <tr>
// //                       <td colSpan={14} style={{ padding: "32px", textAlign: "center", color: "#A0AEC0", fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" }}>
// //                         No cylinders loaded yet. Cylinders will appear here.
// //                       </td>
// //                     </tr>
// //                   )}
// //                 </TableBody>
// //               </Table>
// //             </TableContainer>

// //               <CustomPagination
// //   page={controller.page}
// //   rowsPerPage={controller.rowsPerPage}
// //   totalCount={total_count || 0}
// //   onPageChange={(newPage) => handleChangePage(null, newPage)}
// // />

// //             {/* Footer Buttons */}
// //             <Box sx={formFooterSx}>
// //               <Button sx={cancelBtnSx} onClick={() => navigate(-1)}>Cancel</Button>
// //               <Button type="submit" sx={saveBtnSx}>
// //                 <SaveIcon sx={{ fontSize: 18 }} />
// //                 {editData ? "Update" : "Save"}
// //               </Button>
// //             </Box>
// //           </Box>
// //         </form>

// //         {/* ── Inspection Dialog ─────────────────────────────────────── */}
// //         <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: "14px", border: "1px solid #E2E8F0" } }}>
// //           {/* Dialog Header */}
// //           <Box sx={{ background: "#1C3A5E", padding: "14px 22px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
// //             <Box>
// //               {editIndex !== null ? (
// //                 <Box sx={{ display: "flex", gap: 3 }}>
// //                   {[["Cyl No", dialogData.cylinder_no], ["Tag No", dialogData.tag_no], ["Owner", dialogData.owner]].map(([label, val]) => (
// //                     <Box key={label}>
// //                       <Typography sx={{ fontSize: "10px", color: "rgba(255,255,255,0.6)", fontFamily: "'Inter', Arial, sans-serif" }}>{label}</Typography>
// //                       <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#fff", fontFamily: "'Inter', Arial, sans-serif" }}>{val || "N/A"}</Typography>
// //                     </Box>
// //                   ))}
// //                 </Box>
// //               ) : (
// //                 <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#fff", fontFamily: "'Inter', Arial, sans-serif" }}>
// //                   {isMultiDialog ? "Add Multiple Cylinders" : "Cylinder Inspection"}
// //                 </Typography>
// //               )}
// //             </Box>
// //             <CancelIcon onClick={handleCloseDialog} sx={{ color: "rgba(255,255,255,0.7)", cursor: "pointer", fontSize: 20, "&:hover": { color: "#fff" } }} />
// //           </Box>

// //           <DialogContent sx={{ pt: 3, pb: 1 }}>
// //             {isMultiDialog ? (
// //               <Grid container spacing={2}>
// //                 {/* Multi entry */}
// //                 <Grid item xs={12}>
// //                   <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
// //                     <Typography sx={{ ...fieldLabelSx, mb: 0, minWidth: "120px" }}>Enter Cyl/Tag No</Typography>
// //                     <TextField
// //                       size="small" sx={{ ...inputSx, maxWidth: "200px" }}
// //                       value={multiDialogData.cylinder_nos}
// //                       onChange={e => setMultiDialogData({ cylinder_nos: e.target.value })}
// //                       onBlur={e => addMultiCylinder(e.target.value)}
// //                       onKeyDown={e => { if (e.key === "Enter") addMultiCylinder(e.target.value); }}
// //                       placeholder="Scan or type"
// //                     />
// //                     <Button
// //                       variant="contained"
// //                       onClick={() => {
// //                         setTableData(prev => [...prev, ...multiCylinders.map(cyl => ({ cylinder_no: cyl.cylinder_no, cyl_id: cyl.cyl_id, tag_no: cyl.tag_no, valve_condition: "Ok", fusible_plug: "Ok", painting: "Ok", cyl_cap_avl: "Ok", eci_result: "", current_tare_wt: "", actual_tare_wt: "", actual_tare_wt_aft_sol: "", qty_solvent: "", acetone_drum_tag_no: "", from_plant: "", to_plant: "", shift_time: data.shift_time, shift: data.shift, done_by: data.done_by }))]);
// //                         setMultiCylinders([]); setOpenDialog(false); setScanResults([]);
// //                       }}
// //                       sx={{ ...saveBtnSx, height: "38px", px: 2 }}
// //                     >
// //                       OK
// //                     </Button>
// //                   </Box>
// //                 </Grid>

// //                 {/* Scanner region */}
// //                 {isScannerOpen && (
// //                   <Grid item xs={12}>
// //                     <Box sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", p: 2, display: "flex", flexDirection: "column", alignItems: "center" }}>
// //                       <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#1C3A5E", mb: 1 }}>QR Scanner</Typography>
// //                       <div id={qrCodeRegionId} style={{ width: "100%", maxWidth: "380px", minHeight: "280px" }} />
// //                     </Box>
// //                   </Grid>
// //                 )}

// //                 {/* Added cylinders mini-table */}
// //                 {multiCylinders.length > 0 && (
// //                   <Grid item xs={12}>
// //                     <Box sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>
// //                       <Box sx={{ background: "#F8FAFC", px: 2, py: 1.5, borderBottom: "1px solid #E2E8F0" }}>
// //                         <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#2063b6" }}>{multiCylinders.length} Cylinders Ready</Typography>
// //                       </Box>
// //                       <Table size="small">
// //                         <TableHead>
// //                           <TableRow sx={{ background: "#1C3A5E" }}>
// //                             {["#", "Cylinder No", "Tag No", ""].map(h => <TableCell key={h} sx={{ color: "#fff", fontSize: "11px", fontWeight: 600, py: 1 }}>{h}</TableCell>)}
// //                           </TableRow>
// //                         </TableHead>
// //                         <TableBody>
// //                           {multiCylinders.map((row, idx) => (
// //                             <TableRow key={row.cyl_id} sx={{ "&:nth-of-type(even)": { background: "#F8FAFC" } }}>
// //                               <TableCell sx={{ fontSize: "12px" }}>{idx + 1}</TableCell>
// //                               <TableCell sx={{ fontSize: "12px" }}>{row.cylinder_no}</TableCell>
// //                               <TableCell sx={{ fontSize: "12px" }}>{row.tag_no}</TableCell>
// //                               <TableCell>
// //                                 <IconButton size="small" onClick={() => setMultiCylinders(prev => prev.filter(c => c.cyl_id !== row.cyl_id))} sx={{ color: "#E53E3E" }}>
// //                                   <DeleteForeverIcon sx={{ fontSize: "16px" }} />
// //                                 </IconButton>
// //                               </TableCell>
// //                             </TableRow>
// //                           ))}
// //                         </TableBody>
// //                       </Table>
// //                     </Box>
// //                   </Grid>
// //                 )}
// //               </Grid>
// //             ) : (
// //               <Grid container spacing={2.5}>
// //                 {/* QR scanner region */}
// //                 {isScannerOpen && (
// //                   <Grid item xs={12}>
// //                     <Box sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", p: 2, display: "flex", flexDirection: "column", alignItems: "center" }}>
// //                       <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#1C3A5E", mb: 1 }}>QR Scanner</Typography>
// //                       <div id={qrCodeRegionId} style={{ width: "100%", maxWidth: "380px", minHeight: "280px" }} />
// //                       {scanResults.map((result, idx) => {
// //                         const mappedCylinder = tagMap[result?.trim()];
// //                         return (
// //                           <ListItem key={idx} sx={{ py: 0.5 }}>
// //                             <ListItemText primary={`Tag: ${result}`} secondary={mappedCylinder ? `Cyl No: ${mappedCylinder.cylinder_no}` : "❌ Not found"} primaryTypographyProps={{ fontSize: "12px" }} secondaryTypographyProps={{ fontSize: "11px" }} />
// //                           </ListItem>
// //                         );
// //                       })}
// //                     </Box>
// //                   </Grid>
// //                 )}

// //                 {/* Divider */}
// //                 <Grid item xs={12}><Box sx={{ borderTop: "1px solid #E2E8F0" }} /></Grid>

// //                 {/* Inspection dropdowns */}
// //                 {[
// //                   { key: "valve_condition", label: "Valve Condition" },
// //                   { key: "fusible_plug", label: "Fusible Plug" },
// //                   { key: "painting", label: "Painting" },
// //                   { key: "cyl_cap_avl", label: "Cyl Cap Availability" },
// //                 ].map(({ key, label }) => (
// //                   <Grid item xs={12} sm={6} key={key}>
// //                     <Typography sx={fieldLabelSx}>{label}</Typography>
// //                     <TextField
// //                       select size="small" fullWidth name={key}
// //                       value={dialogData[key] || "Ok"}
// //                       onChange={handleDialogChange}
// //                       sx={getStatusSx(dialogData[key])}
// //                     >
// //                       <MenuItem value="Ok" sx={{ ...menuItemSx, color: "#2F855A" }}>Ok</MenuItem>
// //                       <MenuItem value="Not Ok" sx={{ ...menuItemSx, color: "#E53E3E" }}>Not Ok</MenuItem>
// //                     </TextField>
// //                   </Grid>
// //                 ))}

// //                 {/* Result */}
// //                 <Grid item xs={12} sm={6}>
// //                   <Typography sx={fieldLabelSx}>Result</Typography>
// //                   <TextField
// //                     select size="small" fullWidth name="eci_result"
// //                     value={dialogData.eci_result || "Ok"}
// //                     onChange={e => {
// //                       const val = e.target.value;
// //                       setDialogData(prev => ({ ...prev, eci_result: val, ...(val === "Not Ok" && { current_tare_wt: "", actual_tare_wt_aft_sol: "", qty_solvent: "", acetone_drum_tag_no: "" }) }));
// //                     }}
// //                     sx={getStatusSx(dialogData.eci_result)}
// //                   >
// //                     <MenuItem value="Ok" sx={{ ...menuItemSx, color: "#2F855A", fontWeight: 600 }}>Passed</MenuItem>
// //                     <MenuItem value="Not Ok" sx={{ ...menuItemSx, color: "#E53E3E", fontWeight: 600 }}>Not Passed</MenuItem>
// //                   </TextField>
// //                 </Grid>

// //                 {/* Weight fields */}
// //                 <Grid item xs={12} sm={6}>
// //                   <Typography sx={fieldLabelSx}>Actual Tare Weight</Typography>
// //                   <TextField size="small" fullWidth type="number" name="actual_tare_wt" value={dialogData.actual_tare_wt} onChange={handleDialogChange} sx={dialogData.eci_result === "Not Ok" ? readonlyInputSx : inputSx} InputProps={{ readOnly: dialogData.eci_result === "Not Ok" }} disabled={dialogData.eci_result === "Not Ok"} />
// //                 </Grid>
// //                 <Grid item xs={12} sm={6}>
// //                   <Typography sx={fieldLabelSx}>Current Weight</Typography>
// //                   <TextField size="small" fullWidth type="number" name="current_tare_wt" value={dialogData.current_tare_wt} onChange={handleDialogChange} sx={dialogData.eci_result === "Not Ok" ? readonlyInputSx : inputSx} disabled={dialogData.eci_result === "Not Ok"} />
// //                 </Grid>
// //                 <Grid item xs={12} sm={6}>
// //                   <Typography sx={fieldLabelSx}>Weight After Solvent</Typography>
// //                   <TextField size="small" fullWidth type="number" name="actual_tare_wt_aft_sol" value={dialogData.actual_tare_wt_aft_sol} onChange={handleDialogChange} sx={dialogData.eci_result === "Not Ok" ? readonlyInputSx : inputSx} disabled={dialogData.eci_result === "Not Ok"} />
// //                 </Grid>
// //                 <Grid item xs={12} sm={6}>
// //                   <Typography sx={fieldLabelSx}>Qty of Solvent</Typography>
// //                   <TextField size="small" fullWidth type="number" name="qty_solvent" value={Number(dialogData.qty_solvent).toFixed(2)} onChange={handleDialogChange} sx={readonlyInputSx} InputProps={{ readOnly: true }} disabled />
// //                 </Grid>
// //                 <Grid item xs={12} sm={6}>
// //                   <Typography sx={fieldLabelSx}>Acetone Drum Tag No</Typography>
// //                   <TextField size="small" fullWidth type="text" name="acetone_drum_tag_no" value={dialogData.acetone_drum_tag_no} onChange={handleDialogChange} sx={dialogData.eci_result === "Not Ok" ? readonlyInputSx : inputSx} disabled={dialogData.eci_result === "Not Ok"} placeholder="Enter tag number" />
// //                 </Grid>
// //                 <Grid item xs={12} sm={6}>
// //                   <Typography sx={fieldLabelSx}>Remarks</Typography>
// //                   <TextField type="text" size="small" fullWidth name="remarks" value={dialogData.remarks || ""} onChange={handleDialogChange} sx={inputSx} placeholder="Enter remarks" />
// //                 </Grid>
// //               </Grid>
// //             )}
// //           </DialogContent>

// //           <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
// //             <Button onClick={handleCloseDialog} sx={cancelBtnSx}>Cancel</Button>
// //             <Button onClick={handleDialogSubmit} sx={saveBtnSx}>Done</Button>
// //           </DialogActions>
// //         </Dialog>

// //         <ReusableSnackbar
// //           open={openSnackbar}
// //           onClose={(e, reason) => { if (reason !== "clickaway") setOpenSnackbar(false); }}
// //           message={successMessage}
// //           autoHideDuration={3000}
// //           vertical="top"
// //           horizontal="right"
// //         />
// //       </Box>
// //     </LocalizationProvider>
// //   );
// // };

// // export default EmptyCylinderInspectionAdd;

// import React, { useEffect, useRef, useState } from "react";
// import {
//   Box,
//   Button,
//   MenuItem,
//   Typography,
//   TableContainer,
//   Table,
//   TableHead,
//   TableBody,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   IconButton,
//   List,
//   ListItem,
//   ListItemText,
//   Autocomplete,
//   TableRow,
//   TableCell,
//   TextField,
//   Paper,
// } from "@mui/material";
// import Grid from "@mui/material/Grid";
// import { useForm } from "react-hook-form";
// import { useLocation, useNavigate } from "react-router-dom";
// import styles from "../../../styles.module.css";
// import {
//   Breadcrumb,
//   CTSinput,
// } from "../../reusableComponent/Reusables";
// import EditIcon from "@mui/icons-material/Edit";
// import SaveIcon from "@mui/icons-material/Save";
// import AddIcon from "@mui/icons-material/Add";
// import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import SearchIcon from "@mui/icons-material/Search";
// import CancelIcon from "@mui/icons-material/Cancel";
// import { useDispatch } from "react-redux";
// import dayjs from "dayjs";
// import emptyCylinderInspectionService from "../../../services/emptyCylinderInspection.Service";
// import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";
// import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
// import plantMasterService from "../../../services/masters/plantMaster.Service";
// import depotMasterService from "../../../services/masters/depotMaster.Service";
// import operatorMasterService from "../../../services/masters/operatorMaster.Service";
// import CameraAltSharpIcon from "@mui/icons-material/CameraAltSharp";
// import { Html5Qrcode } from "html5-qrcode";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import CustomPagination from "../../reusableComponent/CustomPagination";

// // ── Shared styles ─────────────────────────────────────────────────────────────
// const pageSx = {
//   background: "#F4F7FB",
//   minHeight: "100vh",
//   padding: "20px 24px 40px",
//   fontFamily: "'Inter', Arial, sans-serif",
// };
// const breadcrumbSx = {
//   fontSize: "12px",
//   color: "#718096",
//   mb: 2,
//   display: "flex",
//   alignItems: "center",
//   gap: "6px",
// };
// const pageHeaderSx = {
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "space-between",
//   mb: 2.5,
// };
// const pageTitleSx = {
//   fontSize: "16px",
//   fontWeight: 700,
//   color: "#000000",
//   display: "flex",
//   alignItems: "center",
//   gap: "10px",
// };
// const backBtnSx = {
//   display: "flex",
//   alignItems: "center",
//   gap: "6px",
//   fontSize: "13px",
//   fontWeight: 600,
//   color: "#2B6CB0",
//   padding: "7px 14px",
//   border: "1.5px solid #2B6CB0",
//   borderRadius: "7px",
//   background: "#fff",
//   cursor: "pointer",
//   textTransform: "none",
//   "&:hover": { background: "#E6F1FB" },
// };
// const formCardSx = {
//   background: "#fff",
//   border: "1px solid #E2E8F0",
//   overflow: "hidden",
//   mb: 2,
// };
// const sectionHeaderSx = {
//   background: "#1C3A5E",
//   padding: "12px 22px",
//   display: "flex",
//   alignItems: "center",
//   gap: "10px",
// };
// const sectionHeaderTitleSx = {
//   fontSize: "13px",
//   fontWeight: 600,
//   color: "#fff",
//   letterSpacing: "0.3px",
// };
// const formBodySx = { padding: "22px 24px" };
// const fieldLabelSx = {
//   fontSize: "12px",
//   fontWeight: 600,
//   color: "#2063b6",
//   mb: "4px",
//   display: "flex",
//   alignItems: "center",
//   gap: "4px",
// };
// const inputSx = {
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "8px",
//     fontSize: "13px",
//     fontFamily: "'Inter', Arial, sans-serif",
//     background: "#fafafa",
//     height: "38px",
//     "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
//     "&:hover fieldset": { borderColor: "#CBD5E0" },
//     "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
//     "&.Mui-focused": { background: "#fff" },
//     "&.Mui-disabled": { background: "#F8FAFC" },
//   },
//   "& input": {
//     color: "#1A202C",
//     fontSize: "13px",
//     fontFamily: "'Inter', Arial, sans-serif",
//     "&::placeholder": { color: "#A0AEC0", opacity: 1 },
//   },
//   "& .MuiInputLabel-root": { display: "none" },
// };
// const readonlyInputSx = {
//   ...inputSx,
//   "& .MuiOutlinedInput-root": {
//     ...inputSx["& .MuiOutlinedInput-root"],
//     background: "#F0F4F8",
//   },
// };
// const errorInputSx = {
//   ...inputSx,
//   "& .MuiOutlinedInput-root": {
//     ...inputSx["& .MuiOutlinedInput-root"],
//     "& fieldset": { borderColor: "#E53E3E", borderWidth: "1.5px" },
//     "&:hover fieldset": { borderColor: "#C53030" },
//     "&.Mui-focused fieldset": { borderColor: "#C53030", borderWidth: "2px" },
//   },
// };
// const okInputSx = {
//   ...inputSx,
//   "& .MuiOutlinedInput-root": {
//     ...inputSx["& .MuiOutlinedInput-root"],
//     "& fieldset": { borderColor: "#38A169", borderWidth: "1.5px" },
//     "&:hover fieldset": { borderColor: "#2F855A" },
//     "&.Mui-focused fieldset": { borderColor: "#2F855A", borderWidth: "2px" },
//   },
//   "& .MuiSelect-select": { color: "#2F855A !important" },
// };
// const notOkInputSx = {
//   ...inputSx,
//   "& .MuiOutlinedInput-root": {
//     ...inputSx["& .MuiOutlinedInput-root"],
//     "& fieldset": { borderColor: "#E53E3E", borderWidth: "1.5px" },
//     "&:hover fieldset": { borderColor: "#C53030" },
//     "&.Mui-focused fieldset": { borderColor: "#C53030", borderWidth: "2px" },
//   },
//   "& .MuiSelect-select": { color: "#E53E3E !important" },
// };
// const formFooterSx = {
//   padding: "18px 24px",
//   background: "#F8FAFC",
//   borderTop: "1px solid #E2E8F0",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-end",
//   gap: "10px",
// };
// const saveBtnSx = {
//   display: "flex",
//   alignItems: "center",
//   gap: "7px",
//   padding: "0 22px",
//   height: "40px",
//   background: "#4CAF50",
//   color: "#fff",
//   border: "none",
//   fontSize: "14px",
//   fontWeight: 600,
//   textTransform: "none",
//   borderRadius: "8px",
//   fontFamily: "'Inter', Arial, sans-serif",
//   "&:hover": { background: "#028b19", transform: "translateY(-1px)" },
//   "&:active": { transform: "translateY(0)" },
//   transition: "all 0.15s ease",
// };
// const cancelBtnSx = {
//   display: "flex",
//   alignItems: "center",
//   gap: "7px",
//   padding: "0 22px",
//   height: "40px",
//   background: "#E53E3E",
//   color: "#ffffff",
//   border: "none",
//   "&:hover": { background: "#971f16", transform: "translateY(-1px)" },
//   fontSize: "14px",
//   fontWeight: 600,
//   borderRadius: "8px",
//   textTransform: "none",
// };
// const menuItemSx = { fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" };

// // ── Helpers ───────────────────────────────────────────────────────────────────
// const getResultColor = (value) => {
//   if (value === "Ok") return "#2F855A";
//   if (value === "Not Ok") return "#E53E3E";
//   return "#A0AEC0";
// };
// const normalizeResult = (value) => {
//   if (!value) return "";
//   const v = value.trim().replace(/\s+/g, " ").toLowerCase();
//   if (v === "ok") return "Ok";
//   if (v === "not ok") return "Not Ok";
//   return value === "Ok" || value === "Not Ok" ? value : "";
// };
// const getStatusSx = (value) => (value === "Not Ok" ? notOkInputSx : okInputSx);

// // ─────────────────────────────────────────────────────────────────────────────

// const EmptyCylinderInspectionAdd = () => {
//   const dispatch = useDispatch();
//   const { handleSubmit } = useForm();
//   const urlLocation = useLocation();
//   const editInfo = urlLocation.state;
//   const editData = editInfo && editInfo;
//   const navigate = useNavigate();
//   const login_details = sessionStorage.getItem("loginUser");
//   const userD = JSON.parse(login_details);
//   const userInfo = userD.result.userInfo;
//   const depot_id = userInfo.depot_id;
//   const plant_id = userInfo.plant_id;
//   const unit_id = userInfo.depot_id || userInfo.plant_id;
//   const short_code = userInfo.depot_short_code || userInfo.plant_short_code;

//   const [filteredTableData, setFilteredTableData] = useState([]);
//   const [validationErrors, setValidationErrors] = useState({});

//   const [data, setData] = useState({
//     acetone_used: editData ? editData.acetone_used : "0.00",
//     inspection_done_by: editData ? editData.inspection_done_by : "",
//     cyl_id: editData ? editData.cyl_id : "",
//     inspection_id: editData ? editData.inspection_id : "",
//     entry_no: editData ? editData.entry_no : "",
//     entry_date: editData?.entry_date ? dayjs(editData.entry_date).format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD"),
//     cylinder_no: editData ? editData.cylinder_no : "",
//     valve_condition: editData ? normalizeResult(editData.valve_condition) : "Ok",
//     fusible_plug: editData ? normalizeResult(editData.fusible_plug) : "Ok",
//     painting: editData ? normalizeResult(editData.painting) : "Ok",
//     cyl_cap_avl: editData ? normalizeResult(editData.cyl_cap_avl) : "Ok",
//     eci_result: editData ? normalizeResult(editData.eci_result) : "OK",
//     current_tare_wt: editData ? editData.current_tare_wt : "",
//     actual_tare_wt: editData ? editData.actual_tare_wt : "",
//     actual_tare_wt_aft_sol: editData ? editData.actual_tare_wt_aft_sol : "",
//     qty_solvent: editData ? editData.qty_solvent : "",
//     acetone_drum_tag_no: editData ? editData.acetone_drum_tag_no : "",
//     from_depot: editData ? editData.from_depot : "",
//     from_plant_id: unit_id,
//     to_plant_id: unit_id,
//     shift: editData ? editData.shift : "shift1",
//     shift_time: editData ? editData.shift_time : "08:00",
//     done_by: editData ? editData.done_by : "",
//     fin_year: editData ? editData.fin_year : dayjs().month() >= 3 ? `${dayjs().year()}-${dayjs().year() + 1}` : `${dayjs().year() - 1}-${dayjs().year()}`,
//     unit_id: editData ? editData.unit_id : unit_id,
//     modified_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
//     modified_by: editData ? userInfo.user_id : null,
//     created_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
//     created_by: editData ? editData.created_by : userInfo.user_id,
//   });

//   const [cylinder, setCylinder] = useState([]);
//   const [plant, setPlant] = useState([]);
//   const [depot, setDepot] = useState([]);
//   const [ecimap, setEcimap] = useState([]);
//   const [operatorList, setOperatorList] = useState([]);
//   const [tagMap, setTagMap] = useState({});
//   const [openDialog, setOpenDialog] = useState(false);
//   const [isMultiDialog, setIsMultiDialog] = useState(false);
//   const [tableData, setTableData] = useState([]);
//   const [dialogData, setDialogData] = useState({
//     cylinder_no: "", cyl_id: "", tag_no: "",
//     valve_condition: "Ok", fusible_plug: "Ok", painting: "Ok", cyl_cap_avl: "Ok", eci_result: "OK",
//     current_tare_wt: "", actual_tare_wt: "", actual_tare_wt_aft_sol: "", qty_solvent: "",
//     acetone_drum_tag_no: "", from_plant: "", to_plant: "", shift_time: "", shift: "", done_by: "",
//   });
//   const [multiDialogData, setMultiDialogData] = useState({ cylinder_nos: "" });
//   const [editIndex, setEditIndex] = useState(null);
//   const [successMessage, setSuccessMessage] = useState(null);
//   const [controller, setController] = useState({ page: 0, rowsPerPage: 10 });
//   const total_count = filteredTableData.length;

//   const handleChangePage = (event, newPage) => {
//     setController(prev => ({ ...prev, page: newPage }));
//   };

//   const paginatedTableData = filteredTableData.slice(
//     controller.page * controller.rowsPerPage,
//     controller.page * controller.rowsPerPage + controller.rowsPerPage
//   );

//   const [isScannerOpen, setIsScannerOpen] = useState(false);
//   const [scanResults, setScanResults] = useState([]);
//   const [openSnackbar, setOpenSnackbar] = useState(false);
//   const qrCodeRegionId = "qr-reader";
//   const html5QrCodeRef = useRef(null);
//   const scannerStateRef = useRef({ isStarting: false, isStopping: false });
//   const lastScanTimeRef = useRef(0);
//   const debounceDelay = 500;
//   const [singleCylinderInput, setSingleCylinderInput] = useState("");
//   const [singleCylinderDetails, setSingleCylinderDetails] = useState(null);
//   const [multiCylinders, setMultiCylinders] = useState([]);

//   const handleChange = ({ target }) => {
//     const { name, value } = target;
//     if (name === "entry_date") {
//       const formattedDate = dayjs(value).isValid() ? dayjs(value).format("YYYY-MM-DD") : "";
//       const financialYear = formattedDate
//         ? dayjs(formattedDate).month() >= 3
//           ? `${dayjs(formattedDate).year()}-${dayjs(formattedDate).year() + 1}`
//           : `${dayjs(formattedDate).year() - 1}-${dayjs(formattedDate).year()}`
//         : "";
//       setData(prev => ({ ...prev, entry_date: formattedDate, fin_year: financialYear }));
//     } else {
//       setData(prev => ({ ...prev, [name]: value }));
//     }
//   };

//   useEffect(() => {
//     const total = tableData.reduce((sum, row) => sum + (parseFloat(row.qty_solvent) || 0), 0);
//     const totalFixed = total > 0 ? total.toFixed(2) : "0.00";
//     setData(prev => ({ ...prev, acetone_used: totalFixed }));
//   }, [tableData]);

//   useEffect(() => {
//     setFilteredTableData(tableData);
//   }, [tableData]);
// const [aftSolTouched, setAftSolTouched] = useState(false);
//   const handleDialogChange = async ({ target }) => {
//     const { name, value } = target;
//     let normalizedValue = value;
//     if (["valve_condition", "fusible_plug", "painting", "cyl_cap_avl", "eci_result"].includes(name)) {
//       normalizedValue = normalizeResult(value);
//     }
//     let newDialogData = { ...dialogData };
//  if (["current_tare_wt", "actual_tare_wt", "actual_tare_wt_aft_sol"].includes(name)) {
//   normalizedValue = value;
//   newDialogData = { ...dialogData, [name]: normalizedValue };

//   if (name === "actual_tare_wt_aft_sol") {
//     // user ne khud edit kiya — ab auto-sync band
//     setAftSolTouched(true);
//   }

//   if (name === "current_tare_wt" && !aftSolTouched) {
//     // jab tak user ne aft_sol manually edit nahi kiya, current wt ke sath sync rakho
//     newDialogData.actual_tare_wt_aft_sol = normalizedValue;
//   }

//   const actualTare = name === "actual_tare_wt" ? (parseFloat(normalizedValue) || 0) : (parseFloat(dialogData.actual_tare_wt) || 0);
//   const currentWt = name === "current_tare_wt" ? (parseFloat(normalizedValue) || 0) : (parseFloat(dialogData.current_tare_wt) || 0);
//   const aftSol = parseFloat(newDialogData.actual_tare_wt_aft_sol) || 0;

//   const errors = {};
//   if (currentWt > 0 && actualTare > 0 && currentWt > actualTare) {
//     errors.current_tare_wt = `Current Weight (${currentWt}) cannot be more than Actual Tare Weight (${actualTare})`;
//   }
//   if (aftSol > 0 && actualTare > 0 && aftSol > actualTare) {
//     errors.actual_tare_wt_aft_sol = `Weight After Solvent (${aftSol}) cannot be more than Actual Tare Weight (${actualTare})`;
//   } else if (aftSol > 0 && currentWt > 0 && aftSol < currentWt) {
//     errors.actual_tare_wt_aft_sol = `Weight After Solvent (${aftSol}) should not be less than Current Weight (${currentWt})`;
//   }
//   setValidationErrors(errors);

//   newDialogData.qty_solvent = (aftSol - currentWt).toFixed(2);
// } else if (name === "qty_solvent") {
//       normalizedValue = parseFloat(value);
//       newDialogData = { ...dialogData, qty_solvent: normalizedValue };
//     } else if (name === "cylinder_no") {
//       const selectedCylinder = cylinder.find(cyl => cyl.tag_no === value);
//       let cylinderCode = selectedCylinder ? selectedCylinder.cylinder_no : "";
//       if (!cylinderCode && value) {
//         try {
//           const cylinderData = await cylinderMasterService.getCylinderList(value);
//           cylinderCode = cylinderData.cylinder_no || "";
//         } catch (error) { console.error("Error fetching cylinder_no:", error); }
//       }
//       newDialogData = {
//         ...dialogData,
//         cylinder_no: value,
//         cyl_id: selectedCylinder ? selectedCylinder.cyl_id : "",
//         tag_no: selectedCylinder ? selectedCylinder.cylinder_no : "",
//         eci_result: normalizeResult(selectedCylinder?.level ?? selectedCylinder?.note) || dialogData.eci_result,
//         actual_tare_wt: selectedCylinder?.tare_wt ? selectedCylinder.tare_wt : dialogData.actual_tare_wt,
//       };
//     } else {
//       newDialogData = { ...dialogData, [name]: normalizedValue };
//     }
//     setDialogData(newDialogData);
//   };

//   const handleMultiDialogChange = ({ target }) => setMultiDialogData({ cylinder_nos: target.value });

//   const resetValidation = () => setValidationErrors({});

//   const handleOpenDialog = () => {
//     setDialogData({
//       cylinder_no: "", cyl_id: "", tag_no: "",
//       valve_condition: "Ok", fusible_plug: "Ok", painting: "Ok", cyl_cap_avl: "Ok", eci_result: "OK",
//       current_tare_wt: "", actual_tare_wt: "", actual_tare_wt_aft_sol: "", qty_solvent: "",
//       acetone_drum_tag_no: "", from_plant: "", to_plant: "", done_by: "",
//     });
//     resetValidation();
//      setAftSolTouched(false);  setEditIndex(null); setIsMultiDialog(false); setOpenDialog(true); setScanResults([]);
//   };

//   const handleOpenmulDialog = () => {
//     setMultiDialogData({ cylinder_nos: "" });
//     resetValidation();
//     setEditIndex(null); setIsMultiDialog(true); setOpenDialog(true); setScanResults([]);
//   };

//   const handleEditRow = (index) => {
//     setDialogData({ ...tableData[index], eci_result: normalizeResult(tableData[index].eci_result) || "Ok" });
//     resetValidation();
//     setEditIndex(index); setIsMultiDialog(false); setOpenDialog(true); setScanResults([]);
//   };

//   const handleCloseDialog = () => {
//     stopScanner();
//     resetValidation();
//     setOpenDialog(false);
//     setScanResults([]);
//   };

//   const handleDialogSubmit = () => {
//     if (isMultiDialog) {
//       if (!multiCylinders.length) { setSuccessMessage("Please enter at least one valid cylinder"); setOpenSnackbar(true); return; }
//       const newRows = multiCylinders
//         .filter(cyl => !tableData.some((row, idx) => idx !== editIndex && row.cyl_id === cyl.cyl_id))
//         .map(cyl => ({
//           cylinder_no: cyl.cylinder_no, cyl_id: cyl.cyl_id, tag_no: cyl.tag_no,
//           valve_condition: "Ok", fusible_plug: "Ok", painting: "Ok", cyl_cap_avl: "Ok", eci_result: "",
//           current_tare_wt: 0, actual_tare_wt: cyl.tare_wt || 0, actual_tare_wt_aft_sol: 0,
//           qty_solvent: 0, acetone_drum_tag_no: "", from_plant: "", to_plant: "",
//           shift_time: data.shift_time, shift: data.shift, done_by: data.done_by,
//         }));
//       if (!newRows.length) { setSuccessMessage("All cylinders already added"); setOpenSnackbar(true); return; }
//       setTableData(prev => [...prev, ...newRows]);
//       setMultiCylinders([]); setMultiDialogData({ cylinder_nos: "" }); setOpenDialog(false); stopScanner();
//       setSuccessMessage("Cylinders added successfully"); setOpenSnackbar(true);
//     } else {
//       const requiredFields = [
//         { key: "cylinder_no", name: "Cylinder Number" },
//         { key: "valve_condition", name: "Valve Condition" },
//         { key: "fusible_plug", name: "Fusible Plug" },
//         { key: "painting", name: "Painting" },
//         { key: "cyl_cap_avl", name: "Cylinder Cap Availability" },
//         { key: "eci_result", name: "ECI Result" },
//       ];
//       const missingFields = requiredFields.filter(field => !dialogData[field.key]);
//       if (missingFields.length > 0) { setSuccessMessage(`Please fill: ${missingFields.map(f => f.name).join(", ")}`); setOpenSnackbar(true); return; }

//       // Validation errors check
//       if (Object.keys(validationErrors).length > 0) {
//         setSuccessMessage(Object.values(validationErrors)[0]);
//         setOpenSnackbar(true);
//         return;
//       }

//       if (tableData.some((row, idx) => idx !== editIndex && row.cyl_id === dialogData.cyl_id)) { setSuccessMessage("Cylinder already added"); setOpenSnackbar(true); return; }
//       const normalizedDialogData = {
//         ...dialogData,
//         valve_condition: normalizeResult(dialogData.valve_condition),
//         fusible_plug: normalizeResult(dialogData.fusible_plug),
//         painting: normalizeResult(dialogData.painting),
//         cyl_cap_avl: normalizeResult(dialogData.cyl_cap_avl),
//         eci_result: normalizeResult(dialogData.eci_result),
//         remarks: dialogData.eci_result === "Not Ok" ? dialogData.remarks || "" : "",
//         current_tare_wt: dialogData.current_tare_wt ? Number(dialogData.current_tare_wt) || 0 : 0,
//         actual_tare_wt: dialogData.actual_tare_wt ? Number(dialogData.actual_tare_wt) || 0 : 0,
//         actual_tare_wt_aft_sol: dialogData.actual_tare_wt_aft_sol ? Number(dialogData.actual_tare_wt_aft_sol) || 0 : 0,
//         qty_solvent: dialogData.qty_solvent ? Number(dialogData.qty_solvent) || 0 : 0,
//         acetone_drum_tag_no: dialogData.acetone_drum_tag_no || "",
//       };
//       if (urlLocation.state?.openDialog) {
//         setSuccessMessage("Inspection details saved"); setOpenSnackbar(true); setOpenDialog(false); stopScanner();
//       } else {
//         if (editIndex !== null) setTableData(prev => { const n = [...prev]; n[editIndex] = normalizedDialogData; return n; });
//         else setTableData(prev => [...prev, normalizedDialogData]);
//         setSuccessMessage("Cylinder details saved"); setOpenSnackbar(true); setOpenDialog(false); stopScanner();
//       }
//     }
//   };

//   const handleRemoveRow = (index) => setTableData(prev => prev.filter((_, i) => i !== index));

//   const startScanner = () => {
//     if (scannerStateRef.current.isStarting || isScannerOpen) return;
//     scannerStateRef.current.isStarting = true;
//     setIsScannerOpen(true);
//   };

//   const stopScanner = () => {
//     if (scannerStateRef.current.isStopping || !html5QrCodeRef.current) { setIsScannerOpen(false); return; }
//     if (!html5QrCodeRef.current.isScanning) { setIsScannerOpen(false); return; }
//     scannerStateRef.current.isStopping = true;
//     html5QrCodeRef.current.stop()
//       .then(() => { html5QrCodeRef.current.clear(); setIsScannerOpen(false); scannerStateRef.current.isStopping = false; })
//       .catch(() => { setIsScannerOpen(false); scannerStateRef.current.isStopping = false; });
//   };

//   const findCylinderByNoOrTag = (input, cylinderList) => {
//     if (!input) return null;
//     const val = input.trim().toLowerCase();
//     return cylinderList.find(cyl =>
//       (cyl.cylinder_no && cyl.cylinder_no.toLowerCase() === val) ||
//       (cyl.tag_no && cyl.tag_no.toLowerCase() === val)
//     );
//   };

//   const fetchSingleCylinderDetails = (input) => {
//     if (!input) { setSingleCylinderDetails(null); return; }
//     const match = findCylinderByNoOrTag(input, cylinder);
//     if (match) {
//       setSingleCylinderDetails(match);
//       setDialogData(prev => ({
//         ...prev, cylinder_no: match.tag_no, tag_no: match.cylinder_no,
//         owner: match.owner, cyl_id: match.cyl_id, actual_tare_wt: match.tare_wt, eci_result: prev.eci_result,
//       }));
//       setSuccessMessage("Cylinder found"); setOpenSnackbar(true); setSingleCylinderInput("");
//     } else { setSingleCylinderDetails(null); setSuccessMessage("No cylinder found"); setOpenSnackbar(true); }
//   };

//   const addMultiCylinder = (input) => {
//     if (!input) return;
//     const match = findCylinderByNoOrTag(input, cylinder);
//     if (match) {
//       setMultiCylinders(prev => {
//         if (prev.some(c => c.cyl_id === match.cyl_id)) { setSuccessMessage("Already added"); setOpenSnackbar(true); return prev; }
//         setSuccessMessage("Cylinder added"); setOpenSnackbar(true);
//         return [...prev, match];
//       });
//     } else { setSuccessMessage("No cylinder found"); setOpenSnackbar(true); }
//   };

//   useEffect(() => {
//     async function fetchData() {
//       try {
//         const [cylinderData, plantData, depotData, ecimapData, RelatedCylinder, operatorData] =
//           await Promise.all([
//             cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: "" }),
//             plantMasterService.getPlantList({ page: 0, size: 999, searchKey: "" }),
//             depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
//             emptyCylinderInspectionService.getEciList({ page: 0, size: 999, searchKey: "" }),
//             emptyCylinderInspectionService.getCylinders(plant_id),
//             operatorMasterService.getOperatorList({ page: 0, size: 999, searchKey: "" }),
//           ]);

//         if (!Array.isArray(RelatedCylinder)) throw new Error("cylinderData is not an array");

//         setCylinder(RelatedCylinder);
//         setPlant(plantData);
//         setDepot(depotData);
//         setEcimap(ecimapData);
//         setOperatorList(Array.isArray(operatorData) ? operatorData : []);

//         if (!editData) {
//           const lastRaw = ecimapData?.[0]?.lastECIEntryNo ?? "";
//           const parts = String(lastRaw).split("/");
//           const lastSeq = parseInt(parts[parts.length - 1]) || 0;
//           const nextSeq = lastSeq + 1;
//           const yr = dayjs();
//           const finYear = yr.month() >= 3
//             ? `${yr.year()}-${String(yr.year() + 1).slice(-2)}`
//             : `${yr.year() - 1}-${String(yr.year()).slice(-2)}`;
//           const formattedEntryNo = `${short_code}/${finYear}/${String(nextSeq).padStart(4, "0")}`;
//           setData(prev => ({ ...prev, entry_no: formattedEntryNo }));
//         }

//         const tagMapping = {};
//         cylinderData.forEach(item => {
//           if (!item.is_deleted) {
//             if (item.cylinder_no?.trim()) tagMapping[item.cylinder_no.trim().toLowerCase()] = { cylinder_no: item.tag_no, cyl_id: item.cyl_id, tag_no: item.cylinder_no };
//             if (item.tag_no?.trim()) tagMapping[item.tag_no.trim().toLowerCase()] = { cylinder_no: item.tag_no, cyl_id: item.cyl_id, tag_no: item.cylinder_no };
//           }
//         });
//         setTagMap(tagMapping);

//         const userPlant = plantData.find(p => p.plant_id === plant_id);
//         if (userPlant) {
//           setData(prev => ({ ...prev, from_plant: userPlant.plant_name }));
//           setDialogData(prev => ({ ...prev, from_plant: userPlant.plant_name }));
//         }
//       } catch (error) { console.error("Error fetching data:", error); }
//     }
//     fetchData();
//   }, [plant_id]);

//   useEffect(() => {
//     if (editData && typeof editData.tableData === "string") {
//       try {
//         const parsed = JSON.parse(editData.tableData);
//         setTableData(parsed.map(row => ({
//           ...row,
//           valve_condition: normalizeResult(row.valve_condition),
//           fusible_plug: normalizeResult(row.fusible_plug),
//           painting: normalizeResult(row.painting),
//           cyl_cap_avl: normalizeResult(row.cyl_cap_avl),
//           eci_result: normalizeResult(row.eci_result),
//           actual_tare_wt: row.actual_tare_wt || "",
//         })));
//       } catch (e) { setTableData([]); }
//     }
//     if (editData) {
//       setData(prev => ({
//         ...prev,
//         inspection_done_by: editData.inspection_done_by || "",
//       }));
//     }
//   }, [editData]);

//   useEffect(() => {
//     if (!isScannerOpen || !openDialog) { if (html5QrCodeRef.current?.isScanning) stopScanner(); return; }
//     const element = document.getElementById(qrCodeRegionId);
//     if (!element) { setIsScannerOpen(false); scannerStateRef.current.isStarting = false; return; }
//     if (html5QrCodeRef.current?.isScanning) { scannerStateRef.current.isStarting = false; return; }
//     html5QrCodeRef.current = new Html5Qrcode(qrCodeRegionId);
//     const onQrScanSuccess = (decodedText) => {
//       const now = Date.now();
//       if (now - lastScanTimeRef.current < debounceDelay) return;
//       lastScanTimeRef.current = now;
//       if (isMultiDialog) {
//         setMultiDialogData({ cylinder_nos: decodedText });
//         addMultiCylinder(decodedText);
//         setTimeout(() => setMultiDialogData({ cylinder_nos: "" }), 1000);
//       } else { fetchSingleCylinderDetails(decodedText); stopScanner(); }
//       setScanResults(prev => [...prev, decodedText]);
//     };
//     html5QrCodeRef.current
//       .start({ facingMode: "environment" }, { fps: 10, qrbox: 250 }, onQrScanSuccess, () => {})
//       .then(() => { scannerStateRef.current.isStarting = false; })
//       .catch(() => { setIsScannerOpen(false); scannerStateRef.current.isStarting = false; });
//     return () => {
//       if (html5QrCodeRef.current?.isScanning && !scannerStateRef.current.isStopping) {
//         try { html5QrCodeRef.current.stop(); html5QrCodeRef.current.clear(); } catch {}
//       }
//     };
//   }, [isScannerOpen, openDialog, isMultiDialog, tagMap, cylinder, depot, depot_id, tableData, editIndex]);

//   useEffect(() => {
//     if (urlLocation.state?.openDialog && urlLocation.state?.rowData) {
//       const row = urlLocation.state.rowData;
//       setSingleCylinderDetails({
//         cylinder_no: row.cylinder_no || "", tag_no: row.tag_no || "",
//         cyl_id: row.cyl_id || "", owner: row.owner || "N/A", cust_name: row.cust_name || "",
//       });
//       setDialogData({
//         cylinder_no: row.cylinder_no || "", cyl_id: row.cyl_id || "", tag_no: row.tag_no || "",
//         owner: row.owner || "",
//         valve_condition: normalizeResult(row.valve_condition) || "Ok",
//         fusible_plug: normalizeResult(row.fusible_plug) || "Ok",
//         painting: normalizeResult(row.painting) || "Ok",
//         cyl_cap_avl: normalizeResult(row.cyl_cap_avl) || "Ok",
//         eci_result: normalizeResult(row.eci_result) || "Ok",
//         current_tare_wt: row.current_tare_wt || "", actual_tare_wt: row.actual_tare_wt || "",
//         actual_tare_wt_aft_sol: row.actual_tare_wt_aft_sol || "", qty_solvent: row.qty_solvent || "",
//         acetone_drum_tag_no: row.acetone_drum_tag_no || "",
//         from_plant: row.from_plant || data.from_plant || "", to_plant: row.to_plant || "",
//         shift_time: row.shift_time || data.shift_time || "08:00",
//         shift: row.shift || data.shift || "shift1",
//         done_by: row.done_by || data.done_by || "",
//       });
//       setSingleCylinderInput(row.cylinder_no || ""); setEditIndex(null); setIsMultiDialog(false); setOpenDialog(true);
//     }
//   }, [urlLocation.state, data.from_plant, data.shift, data.shift_time, data.done_by]);

//   useEffect(() => {
//     async function fetchAndMapCylinders() {
//       try {
//         const cylinderData = await emptyCylinderInspectionService.getCylinders(plant_id);
//         if (!Array.isArray(cylinderData)) throw new Error("Not an array");
//         setTableData(cylinderData.map(cyl => ({
//           cylinder_no: cyl.cylinder_no || "", cyl_id: cyl.cyl_id || "",
//           tag_no: cyl.tag_no || "", owner: cyl.owner || "",
//           valve_condition: "Ok", fusible_plug: "Ok", painting: "Ok", cyl_cap_avl: "Ok", eci_result: "",
//           current_tare_wt: "", actual_tare_wt: cyl.tare_wt ? Number(cyl.tare_wt) : "",
//           actual_tare_wt_aft_sol: "", qty_solvent: "", acetone_drum_tag_no: "",
//           from_plant: data.from_plant || "", to_plant: "",
//           shift: data.shift || "shift1", shift_time: data.shift_time || "08:00",
//           done_by: data.done_by || "",
//         })));
//       } catch (error) { setTableData([]); }
//     }
//     fetchAndMapCylinders();
//   }, [plant_id, data.from_plant, data.shift, data.shift_time, data.done_by]);

//   const onSubmit = async () => {
//     if (!data || Object.keys(data).length === 0 || tableData.length === 0) {
//       setSuccessMessage("Please fill required fields"); setOpenSnackbar(true); return;
//     }
//     const validTableData = tableData.filter(row => row.eci_result === "Ok" || row.eci_result === "Not Ok");
//     if (validTableData.length === 0) { setSuccessMessage("No record to save"); setOpenSnackbar(true); return; }

//     const entryDate = data.entry_date || dayjs().format("YYYY-MM-DD");
//     const existingData = JSON.parse(localStorage.getItem("inspectionAcetoneByDate") || "{}");
//     const previousValue = parseFloat(existingData[entryDate] || 0);
//     const currentValue = parseFloat(data.acetone_used || 0);
//     existingData[entryDate] = previousValue + currentValue;
//     localStorage.setItem("inspectionAcetoneByDate", JSON.stringify(existingData));

//     const eciData = {
//       ...data, inspection_done_by: data.inspection_done_by || "", entry_date: dayjs(data.entry_date).format("YYYY-MM-DD"),
//       tableData: validTableData, modified_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
//       created_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
//       changedUpdatedValue: "edit", short_code, unit_id,
//     };
//     try {
//       if (editData) await emptyCylinderInspectionService.editDeleteEci(eciData);
//       else await emptyCylinderInspectionService.addEci(eciData);
//       setSuccessMessage(editData ? "Updated successfully" : "Saved successfully");
//       setOpenSnackbar(true);
//       setTimeout(() => { setOpenSnackbar(false); navigate(-1); }, 3000);
//     } catch (error) { setSuccessMessage("Error occurred during save"); setOpenSnackbar(true); }
//   };

//   const shiftOptions = [
//     { label: "Shift 1", value: "shift1" },
//     { label: "Shift 2", value: "shift2" },
//     { label: "Shift 3", value: "shift3" },
//   ];

//   const StatusPill = ({ value }) => {
//     const isOk = value === "Ok";
//     const isNotOk = value === "Not Ok";
//     return (
//       <Box sx={{
//         display: "inline-flex", alignItems: "center", px: 1.5, py: 0.3,
//         borderRadius: "20px", fontSize: "11px", fontWeight: 600,
//         background: isOk ? "#F0FFF4" : isNotOk ? "#FFF5F5" : "#F7FAFC",
//         color: isOk ? "#2F855A" : isNotOk ? "#E53E3E" : "#A0AEC0",
//       }}>
//         {value || "—"}
//       </Box>
//     );
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={pageSx}>
//         {/* Breadcrumb */}
//         <Box sx={breadcrumbSx}>
//           <span>Dashboard</span> / <span style={{ color: "#2B6CB0", fontWeight: 600 }}>Empty Cylinder Inspection</span>
//         </Box>

//         {/* Page Header */}
//         <Box sx={pageHeaderSx}>
//           <Box sx={pageTitleSx}>
//             <SearchIcon sx={{ fontSize: 20, color: "#1C3A5E" }} />
//             {editData ? "UPDATE" : "CREATE"} INSPECTION
//           </Box>
//           <Button onClick={() => navigate(-1)} sx={backBtnSx}>
//             <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
//           </Button>
//         </Box>

//         {/* Last Entry */}
//         {!editData && (
//           <Box sx={{ textAlign: "right", fontSize: "12px", color: "#718096", mb: 1.5 }}>
//             Last Entry No: {ecimap?.[0]?.lastScheduleEntryNo ?? 0}
//           </Box>
//         )}

//         <form onSubmit={handleSubmit(onSubmit)}>
//           {/* ── Section 1: Inspection Details ────────────────────────── */}
//           <Box sx={formCardSx}>
//             <Box sx={sectionHeaderSx}>
//               <SearchIcon sx={{ fontSize: 18, color: "#fff" }} />
//               <Typography sx={sectionHeaderTitleSx}>Inspection Details</Typography>
//             </Box>
//             <Box sx={formBodySx}>
//               <Grid container sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>

//                 {/* LEFT COLUMN - Search */}
//                 <Grid item xs={12} md={6} sx={{
//                   p: 2.5,
//                   borderBottom: { xs: "2px dashed #CBD5E0", md: "none" },
//                   display: "flex", alignItems: "flex-end", justifyContent: "flex-start", minHeight: 200,
//                 }}>
//                   <Box sx={{ width: "100%", maxWidth: "360px" }}>
//                     <Typography sx={fieldLabelSx}>Search Cylinder</Typography>
//                     <TextField
//                       size="small"
//                       fullWidth
//                       placeholder="Search by Cyl No or Tag No"
//                       sx={inputSx}
//                       onChange={(e) => {
//                         const val = e.target.value.trim().toLowerCase();
//                         if (!val) { setFilteredTableData(tableData); return; }
//                         setFilteredTableData(
//                           tableData.filter(row =>
//                             row.cylinder_no?.toLowerCase().includes(val) ||
//                             row.tag_no?.toLowerCase().includes(val)
//                           )
//                         );
//                       }}
//                       InputProps={{
//                         startAdornment: (
//                           <Box sx={{
//                             display: "flex", alignItems: "center", justifyContent: "center",
//                             background: "#1C3A5E", borderRadius: "6px",
//                             padding: "4px 8px", mr: 1, ml: "-8px",
//                           }}>
//                             <SearchIcon sx={{ fontSize: 16, color: "#fff" }} />
//                           </Box>
//                         ),
//                       }}
//                     />
//                   </Box>
//                 </Grid>

//                 {/* RIGHT COLUMN */}
//                 <Grid item xs={12} md={6} sx={{ p: 2.5, background: "#FAFBFC", pl: 3.5 }}>
//                   <Grid container spacing={1.5}>
//                     <Grid item xs={12} sm={6}>
//                       <Typography sx={fieldLabelSx}>Entry No</Typography>
//                       <TextField size="small" fullWidth name="entry_no" value={data.entry_no} sx={readonlyInputSx} InputProps={{ readOnly: true }} placeholder="Auto-generated" />
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <Typography sx={fieldLabelSx}>Entry Date <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                       <DatePicker
//                         format="DD/MM/YYYY"
//                         value={data.entry_date ? dayjs(data.entry_date) : null}
//                         onChange={nv => handleChange({ target: { name: "entry_date", value: nv ? nv.format("YYYY-MM-DD") : "" } })}
//                         slotProps={{ textField: { size: "small", fullWidth: true, required: true, sx: inputSx } }}
//                       />
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <Typography sx={fieldLabelSx}>Shift</Typography>
//                       <Autocomplete
//                         options={shiftOptions} fullWidth
//                         getOptionLabel={o => typeof o === "string" ? o : o.label}
//                         value={shiftOptions.find(s => s.value === data.shift) || null}
//                         onChange={(e, nv) => handleChange({ target: { name: "shift", value: nv ? nv.value : "" } })}
//                         isOptionEqualToValue={(o, v) => o.value === v.value}
//                         renderOption={(props, option) => <MenuItem {...props} sx={menuItemSx}>{option.label}</MenuItem>}
//                         renderInput={(params) => <TextField {...params} size="small" fullWidth sx={inputSx} placeholder="Select shift" />}
//                       />
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <Typography sx={fieldLabelSx}>Shift Time</Typography>
//                       <TextField type="time" size="small" fullWidth name="shift_time" value={data.shift_time} onChange={handleChange} sx={inputSx} />
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <Typography sx={fieldLabelSx}>Inspection Done By</Typography>
//                       <TextField select size="small" fullWidth name="inspection_done_by" value={data.inspection_done_by || ""} onChange={handleChange} sx={inputSx} displayEmpty>
//                         <MenuItem value="" sx={menuItemSx}><em style={{ color: "#A0AEC0" }}>Select Operator</em></MenuItem>
//                         {operatorList.map((op) => (
//                           <MenuItem key={op.operator_id} value={op.operator_name} sx={menuItemSx}>{op.operator_name}</MenuItem>
//                         ))}
//                       </TextField>
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <Typography sx={fieldLabelSx}>Acetone Used (KG)</Typography>
//                       <TextField size="small" fullWidth value={data.acetone_used} sx={readonlyInputSx} InputProps={{ readOnly: true }} placeholder="Auto-calculated" />
//                     </Grid>
//                   </Grid>
//                 </Grid>
//               </Grid>
//             </Box>
//           </Box>

//           {/* ── Section 2: Cylinder Inspection Table ─────────────────── */}
//           <Box sx={formCardSx}>
//             <TableContainer>
//               <Table size="small" stickyHeader>
//                 <TableHead>
//                   <tr>
//                     {[
//                       { label: "Sr No", align: "center" },
//                       { label: "Cyl No", align: "left" },
//                       { label: "Tag No", align: "left" },
//                       { label: "Valve", align: "left" },
//                       { label: "Fusible Plug", align: "left" },
//                       { label: "Painting", align: "left" },
//                       { label: "Cap Avl", align: "left" },
//                       { label: "Result", align: "left" },
//                       { label: "Actual Tare Wt", align: "right" },
//                       { label: "Current Wt", align: "right" },
//                       { label: "Wt After Solvent", align: "right" },
//                       { label: "Qty Solvent", align: "right" },
//                       { label: "Acetone Drum Tag", align: "left" },
//                       { label: "Action", align: "center" },
//                     ].map(({ label, align }) => (
//                       <th key={label} style={{
//                         background: "#1C3A5E", color: "#fff", fontSize: "11px", fontWeight: 600,
//                         fontFamily: "'Inter', Arial, sans-serif", padding: "10px 10px",
//                         borderRight: "1px solid rgba(255,255,255,0.1)", whiteSpace: "nowrap", textAlign: align,
//                       }}>{label}</th>
//                     ))}
//                   </tr>
//                 </TableHead>
//                 <TableBody>
//                   {paginatedTableData.map((row, index) => (
//                     <tr
//                       key={index}
//                       onClick={() => handleEditRow(controller.page * controller.rowsPerPage + index)}
//                       style={{ background: index % 2 === 0 ? "#fff" : "#F8FAFC", cursor: "pointer", borderBottom: "1px solid #E2E8F0" }}
//                       onMouseEnter={e => e.currentTarget.style.background = "#EBF4FF"}
//                       onMouseLeave={e => e.currentTarget.style.background = index % 2 === 0 ? "#fff" : "#F8FAFC"}
//                     >
//                       <td style={{ padding: "8px 10px", fontSize: "12px", fontFamily: "'Inter'", color: "#2D3748", textAlign: "center" }}>
//                         {controller.page * controller.rowsPerPage + index + 1}
//                       </td>
//                       <td style={{ padding: "8px 10px", fontSize: "12px", fontFamily: "'Inter'", color: "#2D3748" }}>{row.cylinder_no}</td>
//                       <td style={{ padding: "8px 10px", fontSize: "12px", fontFamily: "'Inter'", color: "#2D3748" }}>{row.tag_no}</td>
//                       {["valve_condition", "fusible_plug", "painting", "cyl_cap_avl"].map(field => (
//                         <td key={field} style={{ padding: "8px 10px", textAlign: "left" }}>
//                           <StatusPill value={row[field]} />
//                         </td>
//                       ))}
//                       <td style={{ padding: "8px 10px", textAlign: "left" }}>
//                         <Box sx={{
//                           display: "inline-flex", alignItems: "center", px: 1.5, py: 0.3,
//                           borderRadius: "20px", fontSize: "11px", fontWeight: 700,
//                           background: row.eci_result === "Ok" ? "#F0FFF4" : row.eci_result === "Not Ok" ? "#FFF5F5" : "#F7FAFC",
//                           color: row.eci_result === "Ok" ? "#2F855A" : row.eci_result === "Not Ok" ? "#E53E3E" : "#A0AEC0",
//                         }}>
//                           {row.eci_result === "Ok" ? "Passed" : row.eci_result === "Not Ok" ? "Not Passed" : row.eci_result || "—"}
//                         </Box>
//                       </td>
//                       {[row.actual_tare_wt, row.current_tare_wt, row.actual_tare_wt_aft_sol].map((val, i) => (
//                         <td key={i} style={{ padding: "8px 10px", fontSize: "12px", fontFamily: "'Inter'", color: "#2D3748", textAlign: "right" }}>{val}</td>
//                       ))}
//                       <td style={{ padding: "8px 10px", fontSize: "12px", fontFamily: "'Inter'", color: "#2D3748", textAlign: "right" }}>
//                         {Number(row.qty_solvent).toFixed(2)}
//                       </td>
//                       <td style={{ padding: "8px 10px", fontSize: "12px", fontFamily: "'Inter'", color: "#2D3748" }}>{row.acetone_drum_tag_no}</td>
//                       <td style={{ padding: "8px 10px", textAlign: "center" }} onClick={e => e.stopPropagation()}>
//                         <Box sx={{ display: "flex", justifyContent: "center", gap: 0.5 }}>
//                           <IconButton size="small" onClick={() => handleEditRow(controller.page * controller.rowsPerPage + index)} sx={{ color: "#2063b6", "&:hover": { background: "#EBF4FF" }, borderRadius: "6px" }}>
//                             <EditIcon sx={{ fontSize: "15px" }} />
//                           </IconButton>
//                           <IconButton size="small" onClick={e => { e.stopPropagation(); handleRemoveRow(controller.page * controller.rowsPerPage + index); }} sx={{ color: "#E53E3E", "&:hover": { background: "#FFF5F5" }, borderRadius: "6px" }}>
//                             <DeleteForeverIcon sx={{ fontSize: "16px" }} />
//                           </IconButton>
//                         </Box>
//                       </td>
//                     </tr>
//                   ))}
//                   {tableData.length === 0 && (
//                     <tr>
//                       <td colSpan={14} style={{ padding: "32px", textAlign: "center", color: "#A0AEC0", fontSize: "13px", fontFamily: "'Inter'" }}>
//                         No cylinders loaded yet. Cylinders will appear here.
//                       </td>
//                     </tr>
//                   )}
//                 </TableBody>
//               </Table>
//             </TableContainer>

//             <CustomPagination
//               page={controller.page}
//               rowsPerPage={controller.rowsPerPage}
//               totalCount={total_count || 0}
//               onPageChange={(newPage) => handleChangePage(null, newPage)}
//             />

//             <Box sx={formFooterSx}>
//               <Button sx={cancelBtnSx} onClick={() => navigate(-1)}>Cancel</Button>
//               <Button type="submit" sx={saveBtnSx}>
//                 <SaveIcon sx={{ fontSize: 18 }} />
//                 {editData ? "Update" : "Save"}
//               </Button>
//             </Box>
//           </Box>
//         </form>

//         {/* ── Inspection Dialog ─────────────────────────────────────── */}
//         <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth
//           PaperProps={{ sx: { borderRadius: "14px", border: "1px solid #E2E8F0" } }}>
//           <Box sx={{ background: "#1C3A5E", padding: "14px 22px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//             <Box>
//               {editIndex !== null ? (
//                 <Box sx={{ display: "flex", gap: 3 }}>
//                   {[["Cyl No", dialogData.cylinder_no], ["Tag No", dialogData.tag_no], ["Owner", dialogData.owner]].map(([label, val]) => (
//                     <Box key={label}>
//                       <Typography sx={{ fontSize: "10px", color: "rgba(255,255,255,0.6)", fontFamily: "'Inter'" }}>{label}</Typography>
//                       <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#fff", fontFamily: "'Inter'" }}>{val || "N/A"}</Typography>
//                     </Box>
//                   ))}
//                 </Box>
//               ) : (
//                 <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#fff", fontFamily: "'Inter'" }}>
//                   {isMultiDialog ? "Add Multiple Cylinders" : "Cylinder Inspection"}
//                 </Typography>
//               )}
//             </Box>
//             <CancelIcon onClick={handleCloseDialog} sx={{ color: "rgba(255,255,255,0.7)", cursor: "pointer", fontSize: 20, "&:hover": { color: "#fff" } }} />
//           </Box>

//           <DialogContent sx={{ pt: 3, pb: 1 }}>
//             {isMultiDialog ? (
//               <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                   <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
//                     <Typography sx={{ ...fieldLabelSx, mb: 0, minWidth: "120px" }}>Enter Cyl/Tag No</Typography>
//                     <TextField
//                       size="small" sx={{ ...inputSx, maxWidth: "200px" }}
//                       value={multiDialogData.cylinder_nos}
//                       onChange={e => setMultiDialogData({ cylinder_nos: e.target.value })}
//                       onBlur={e => addMultiCylinder(e.target.value)}
//                       onKeyDown={e => { if (e.key === "Enter") addMultiCylinder(e.target.value); }}
//                       placeholder="Scan or type"
//                     />
//                     <Button
//                       variant="contained"
//                       onClick={() => {
//                         setTableData(prev => [...prev, ...multiCylinders.map(cyl => ({
//                           cylinder_no: cyl.cylinder_no, cyl_id: cyl.cyl_id, tag_no: cyl.tag_no,
//                           valve_condition: "Ok", fusible_plug: "Ok", painting: "Ok", cyl_cap_avl: "Ok", eci_result: "",
//                           current_tare_wt: "", actual_tare_wt: "", actual_tare_wt_aft_sol: "", qty_solvent: "",
//                           acetone_drum_tag_no: "", from_plant: "", to_plant: "",
//                           shift_time: data.shift_time, shift: data.shift, done_by: data.done_by,
//                         }))]);
//                         setMultiCylinders([]); setOpenDialog(false); setScanResults([]);
//                       }}
//                       sx={{ ...saveBtnSx, height: "38px", px: 2 }}
//                     >
//                       OK
//                     </Button>
//                   </Box>
//                 </Grid>
//                 {isScannerOpen && (
//                   <Grid item xs={12}>
//                     <Box sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", p: 2, display: "flex", flexDirection: "column", alignItems: "center" }}>
//                       <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#1C3A5E", mb: 1 }}>QR Scanner</Typography>
//                       <div id={qrCodeRegionId} style={{ width: "100%", maxWidth: "380px", minHeight: "280px" }} />
//                     </Box>
//                   </Grid>
//                 )}
//                 {multiCylinders.length > 0 && (
//                   <Grid item xs={12}>
//                     <Box sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>
//                       <Box sx={{ background: "#F8FAFC", px: 2, py: 1.5, borderBottom: "1px solid #E2E8F0" }}>
//                         <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#2063b6" }}>{multiCylinders.length} Cylinders Ready</Typography>
//                       </Box>
//                       <Table size="small">
//                         <TableHead>
//                           <TableRow sx={{ background: "#1C3A5E" }}>
//                             {["#", "Cylinder No", "Tag No", ""].map(h => <TableCell key={h} sx={{ color: "#fff", fontSize: "11px", fontWeight: 600, py: 1 }}>{h}</TableCell>)}
//                           </TableRow>
//                         </TableHead>
//                         <TableBody>
//                           {multiCylinders.map((row, idx) => (
//                             <TableRow key={row.cyl_id} sx={{ "&:nth-of-type(even)": { background: "#F8FAFC" } }}>
//                               <TableCell sx={{ fontSize: "12px" }}>{idx + 1}</TableCell>
//                               <TableCell sx={{ fontSize: "12px" }}>{row.cylinder_no}</TableCell>
//                               <TableCell sx={{ fontSize: "12px" }}>{row.tag_no}</TableCell>
//                               <TableCell>
//                                 <IconButton size="small" onClick={() => setMultiCylinders(prev => prev.filter(c => c.cyl_id !== row.cyl_id))} sx={{ color: "#E53E3E" }}>
//                                   <DeleteForeverIcon sx={{ fontSize: "16px" }} />
//                                 </IconButton>
//                               </TableCell>
//                             </TableRow>
//                           ))}
//                         </TableBody>
//                       </Table>
//                     </Box>
//                   </Grid>
//                 )}
//               </Grid>
//             ) : (
//               <Grid container spacing={2.5}>
//                 {isScannerOpen && (
//                   <Grid item xs={12}>
//                     <Box sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", p: 2, display: "flex", flexDirection: "column", alignItems: "center" }}>
//                       <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#1C3A5E", mb: 1 }}>QR Scanner</Typography>
//                       <div id={qrCodeRegionId} style={{ width: "100%", maxWidth: "380px", minHeight: "280px" }} />
//                       {scanResults.map((result, idx) => {
//                         const mappedCylinder = tagMap[result?.trim()];
//                         return (
//                           <ListItem key={idx} sx={{ py: 0.5 }}>
//                             <ListItemText
//                               primary={`Tag: ${result}`}
//                               secondary={mappedCylinder ? `Cyl No: ${mappedCylinder.cylinder_no}` : "❌ Not found"}
//                               primaryTypographyProps={{ fontSize: "12px" }}
//                               secondaryTypographyProps={{ fontSize: "11px" }}
//                             />
//                           </ListItem>
//                         );
//                       })}
//                     </Box>
//                   </Grid>
//                 )}
//                 <Grid item xs={12}><Box sx={{ borderTop: "1px solid #E2E8F0" }} /></Grid>
//                 {[
//                   { key: "valve_condition", label: "Valve Condition" },
//                   { key: "fusible_plug", label: "Fusible Plug" },
//                   { key: "painting", label: "Painting" },
//                   { key: "cyl_cap_avl", label: "Cyl Cap Availability" },
//                 ].map(({ key, label }) => (
//                   <Grid item xs={12} sm={6} key={key}>
//                     <Typography sx={fieldLabelSx}>{label}</Typography>
//                     <TextField select size="small" fullWidth name={key} value={dialogData[key] || "Ok"} onChange={handleDialogChange} sx={getStatusSx(dialogData[key])}>
//                       <MenuItem value="Ok" sx={{ ...menuItemSx, color: "#2F855A" }}>Ok</MenuItem>
//                       <MenuItem value="Not Ok" sx={{ ...menuItemSx, color: "#E53E3E" }}>Not Ok</MenuItem>
//                     </TextField>
//                   </Grid>
//                 ))}
//                 <Grid item xs={12} sm={6}>
//                   <Typography sx={fieldLabelSx}>Result</Typography>
//                   <TextField
//                     select size="small" fullWidth name="eci_result"
//                     value={dialogData.eci_result || "Ok"}
//                     onChange={e => {
//                       const val = e.target.value;
//                       setDialogData(prev => ({
//                         ...prev, eci_result: val,
//                         ...(val === "Not Ok" && { current_tare_wt: "", actual_tare_wt_aft_sol: "", qty_solvent: "", acetone_drum_tag_no: "" }),
//                       }));
//                     }}
//                     sx={getStatusSx(dialogData.eci_result)}
//                   >
//                     <MenuItem value="Ok" sx={{ ...menuItemSx, color: "#2F855A", fontWeight: 600 }}>Passed</MenuItem>
//                     <MenuItem value="Not Ok" sx={{ ...menuItemSx, color: "#E53E3E", fontWeight: 600 }}>Not Passed</MenuItem>
//                   </TextField>
//                 </Grid>

//                 {/* Actual Tare Weight */}
//                 <Grid item xs={12} sm={6}>
//                   <Typography sx={fieldLabelSx}>Actual Tare Weight</Typography>
//                   <TextField
//                     size="small" fullWidth type="number" name="actual_tare_wt"
//                     value={dialogData.actual_tare_wt}
//                     onChange={handleDialogChange}
//                     sx={dialogData.eci_result === "Not Ok" ? readonlyInputSx : inputSx}
//                     InputProps={{ readOnly: dialogData.eci_result === "Not Ok" }}
//                     disabled={dialogData.eci_result === "Not Ok"}
//                   />
//                 </Grid>

//                 {/* Current Weight — validation */}
//                 <Grid item xs={12} sm={6}>
//                   <Typography sx={fieldLabelSx}>Current Weight</Typography>
//                   <TextField
//                     size="small" fullWidth type="number" name="current_tare_wt"
//                     value={dialogData.current_tare_wt}
//                     onChange={handleDialogChange}
//                     sx={dialogData.eci_result === "Not Ok" ? readonlyInputSx : validationErrors.current_tare_wt ? errorInputSx : inputSx}
//                     disabled={dialogData.eci_result === "Not Ok"}
//                     error={!!validationErrors.current_tare_wt}
//                     helperText={validationErrors.current_tare_wt}
//                     FormHelperTextProps={{ sx: { fontSize: "11px", color: "#E53E3E" } }}
//                   />
//                 </Grid>

//                 {/* Weight After Solvent — validation */}
//                 <Grid item xs={12} sm={6}>
//                   <Typography sx={fieldLabelSx}>Weight After Solvent</Typography>
//                   <TextField
//                     size="small" fullWidth type="number" name="actual_tare_wt_aft_sol"
//                     value={dialogData.actual_tare_wt_aft_sol}
//                     onChange={handleDialogChange}
//                     sx={dialogData.eci_result === "Not Ok" ? readonlyInputSx : validationErrors.actual_tare_wt_aft_sol ? errorInputSx : inputSx}
//                     disabled={dialogData.eci_result === "Not Ok"}
//                     error={!!validationErrors.actual_tare_wt_aft_sol}
//                     helperText={validationErrors.actual_tare_wt_aft_sol}
//                     FormHelperTextProps={{ sx: { fontSize: "11px", color: "#E53E3E" } }}
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={6}>
//                   <Typography sx={fieldLabelSx}>Qty of Solvent</Typography>
//                   <TextField size="small" fullWidth type="number" name="qty_solvent" value={Number(dialogData.qty_solvent).toFixed(2)} onChange={handleDialogChange} sx={readonlyInputSx} InputProps={{ readOnly: true }} disabled />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography sx={fieldLabelSx}>Acetone Drum Tag No</Typography>
//                   <TextField size="small" fullWidth type="text" name="acetone_drum_tag_no" value={dialogData.acetone_drum_tag_no} onChange={handleDialogChange} sx={dialogData.eci_result === "Not Ok" ? readonlyInputSx : inputSx} disabled={dialogData.eci_result === "Not Ok"} placeholder="Enter tag number" />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography sx={fieldLabelSx}>Remarks</Typography>
//                   <TextField type="text" size="small" fullWidth name="remarks" value={dialogData.remarks || ""} onChange={handleDialogChange} sx={inputSx} placeholder="Enter remarks" />
//                 </Grid>
//               </Grid>
//             )}
//           </DialogContent>

//           <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
//             <Button onClick={handleCloseDialog} sx={cancelBtnSx}>Cancel</Button>
//             <Button onClick={handleDialogSubmit} sx={saveBtnSx}>Done</Button>
//           </DialogActions>
//         </Dialog>

//         <ReusableSnackbar
//           open={openSnackbar}
//           onClose={(e, reason) => { if (reason !== "clickaway") setOpenSnackbar(false); }}
//           message={successMessage}
//           autoHideDuration={3000}
//           vertical="top"
//           horizontal="right"
//         />
//       </Box>
//     </LocalizationProvider>
//   );
// };

// export default EmptyCylinderInspectionAdd;

// import React, { useEffect, useRef, useState } from "react";
// import {
//   Box,
//   Button,
//   MenuItem,
//   Typography,
//   TableContainer,
//   Table,
//   TableHead,
//   TableBody,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   IconButton,
//   List,
//   ListItem,
//   ListItemText,
//   Autocomplete,
//   TableRow,
//   TableCell,
//   TextField,
//   Paper,
// } from "@mui/material";
// import Grid from "@mui/material/Grid";
// import { useForm } from "react-hook-form";
// import { useLocation, useNavigate } from "react-router-dom";
// import styles from "../../../styles.module.css";
// import {
//   Breadcrumb,
//   CTSinput,
// } from "../../reusableComponent/Reusables";
// import EditIcon from "@mui/icons-material/Edit";
// import SaveIcon from "@mui/icons-material/Save";
// import AddIcon from "@mui/icons-material/Add";
// import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import SearchIcon from "@mui/icons-material/Search";
// import CancelIcon from "@mui/icons-material/Cancel";
// import { useDispatch } from "react-redux";
// import dayjs from "dayjs";
// import emptyCylinderInspectionService from "../../../services/emptyCylinderInspection.Service";
// import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";
// import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
// import plantMasterService from "../../../services/masters/plantMaster.Service";
// import depotMasterService from "../../../services/masters/depotMaster.Service";
// import CameraAltSharpIcon from "@mui/icons-material/CameraAltSharp";
// import { Html5Qrcode } from "html5-qrcode";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import CustomPagination from "../../reusableComponent/CustomPagination";
// // ── Shared styles matching PlantAdd ──────────────────────────────────────────

// const pageSx = {
//   background: "#F4F7FB",
//   minHeight: "100vh",
//   padding: "20px 24px 40px",
//   fontFamily: "'Inter', Arial, sans-serif",
// };

// const breadcrumbSx = {
//   fontSize: "12px",
//   color: "#718096",
//   mb: 2,
//   display: "flex",
//   alignItems: "center",
//   gap: "6px",
// };

// const pageHeaderSx = {
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "space-between",
//   mb: 2.5,
// };

// const pageTitleSx = {
//   fontSize: "16px",
//   fontWeight: 700,
//   color: "#000000",
//   display: "flex",
//   alignItems: "center",
//   gap: "10px",
// };

// const backBtnSx = {
//   display: "flex",
//   alignItems: "center",
//   gap: "6px",
//   fontSize: "13px",
//   fontWeight: 600,
//   color: "#2B6CB0",
//   padding: "7px 14px",
//   border: "1.5px solid #2B6CB0",
//   borderRadius: "7px",
//   background: "#fff",
//   cursor: "pointer",
//   textTransform: "none",
//   "&:hover": { background: "#E6F1FB" },
// };

// const formCardSx = {
//   background: "#fff",
  
//   border: "1px solid #E2E8F0",
//   overflow: "hidden",
//   mb: 2,
// };

// const sectionHeaderSx = {
//   background: "#1C3A5E",
//   padding: "12px 22px",
//   display: "flex",
//   alignItems: "center",
//   gap: "10px",
// };

// const sectionHeaderTitleSx = {
//   fontSize: "13px",
//   fontWeight: 600,
//   color: "#fff",
//   letterSpacing: "0.3px",
// };

// const formBodySx = { padding: "22px 24px" };

// const fieldLabelSx = {
//   fontSize: "12px",
//   fontWeight: 600,
//   color: "#2063b6",
//   mb: "4px",
//   display: "flex",
//   alignItems: "center",
//   gap: "4px",
// };

// const inputSx = {
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "8px",
//     fontSize: "13px",
//     fontFamily: "'Inter', Arial, sans-serif",
//     background: "#fafafa",
//     height: "38px",
//     "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
//     "&:hover fieldset": { borderColor: "#CBD5E0" },
//     "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
//     "&.Mui-focused": { background: "#fff" },
//     "&.Mui-disabled": { background: "#F8FAFC" },
//   },
//   "& input": {
//     color: "#1A202C",
//     fontSize: "13px",
//     fontFamily: "'Inter', Arial, sans-serif",
//     "&::placeholder": { color: "#A0AEC0", opacity: 1 },
//   },
//   "& .MuiInputLabel-root": { display: "none" },
// };

// const readonlyInputSx = {
//   ...inputSx,
//   "& .MuiOutlinedInput-root": {
//     ...inputSx["& .MuiOutlinedInput-root"],
//     background: "#F0F4F8",
//   },
// };

// const okInputSx = {
//   ...inputSx,
//   "& .MuiOutlinedInput-root": {
//     ...inputSx["& .MuiOutlinedInput-root"],
//     "& fieldset": { borderColor: "#38A169", borderWidth: "1.5px" },
//     "&:hover fieldset": { borderColor: "#2F855A" },
//     "&.Mui-focused fieldset": { borderColor: "#2F855A", borderWidth: "2px" },
//   },
//   "& .MuiSelect-select": { color: "#2F855A !important" },
// };

// const notOkInputSx = {
//   ...inputSx,
//   "& .MuiOutlinedInput-root": {
//     ...inputSx["& .MuiOutlinedInput-root"],
//     "& fieldset": { borderColor: "#E53E3E", borderWidth: "1.5px" },
//     "&:hover fieldset": { borderColor: "#C53030" },
//     "&.Mui-focused fieldset": { borderColor: "#C53030", borderWidth: "2px" },
//   },
//   "& .MuiSelect-select": { color: "#E53E3E !important" },
// };

// const formFooterSx = {
//   padding: "18px 24px",
//   background: "#F8FAFC",
//   borderTop: "1px solid #E2E8F0",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-end",
//   gap: "10px",
// };

// const saveBtnSx = {
//   display: "flex",
//   alignItems: "center",
//   gap: "7px",
//   padding: "0 22px",
//   height: "40px",
//   background: "#4CAF50",
//   color: "#fff",
//   border: "none",
//   fontSize: "14px",
//   fontWeight: 600,
//   textTransform: "none",
//   borderRadius: "8px",
//   fontFamily: "'Inter', Arial, sans-serif",
//   "&:hover": { background: "#028b19", transform: "translateY(-1px)" },
//   "&:active": { transform: "translateY(0)" },
//   transition: "all 0.15s ease",
// };

// const cancelBtnSx = {
//   display: "flex",
//   alignItems: "center",
//   gap: "7px",
//   padding: "0 22px",
//   height: "40px",
//   background: "#E53E3E",
//   color: "#ffffff",
//   border: "none",
//   "&:hover": { background: "#971f16", transform: "translateY(-1px)" },
//   fontSize: "14px",
//   fontWeight: 600,
//   borderRadius: "8px",
//   textTransform: "none",
// };

// const menuItemSx = { fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" };

// // ── Helpers ───────────────────────────────────────────────────────────────────




// const getResultColor = (value) => {
//   if (value === "Ok") return "#2F855A";
//   if (value === "Not Ok") return "#E53E3E";
//   return "#A0AEC0";
// };

// const normalizeResult = (value) => {
//   if (!value) return "";
//   const v = value.trim().replace(/\s+/g, " ").toLowerCase();
//   if (v === "ok") return "Ok";
//   if (v === "not ok") return "Not Ok";
//   return value === "Ok" || value === "Not Ok" ? value : "";
// };

// const getStatusSx = (value) => (value === "Not Ok" ? notOkInputSx : okInputSx);

// // ─────────────────────────────────────────────────────────────────────────────

// const EmptyCylinderInspectionAdd = () => {
//   const dispatch = useDispatch();
//   const { handleSubmit } = useForm();
//   const urlLocation = useLocation();
//   const editInfo = urlLocation.state;
//   const editData = editInfo && editInfo;
//   const navigate = useNavigate();
//   const login_details = sessionStorage.getItem("loginUser");
//   const userD = JSON.parse(login_details);
//   const userInfo = userD.result.userInfo;
//   const depot_id = userInfo.depot_id;
//   const plant_id = userInfo.plant_id;
//   const unit_id = userInfo.depot_id || userInfo.plant_id;
//   const short_code = userInfo.depot_short_code || userInfo.plant_short_code;

//   const [data, setData] = useState({
//      acetone_used: editData ? editData.acetone_used : "0.00",
//     cyl_id: editData ? editData.cyl_id : "",
//     inspection_id: editData ? editData.inspection_id : "",
//     entry_no: editData ? editData.entry_no : "",
//     entry_date: editData?.entry_date ? dayjs(editData.entry_date).format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD"),
//     cylinder_no: editData ? editData.cylinder_no : "",
//     valve_condition: editData ? normalizeResult(editData.valve_condition) : "Ok",
//     fusible_plug: editData ? normalizeResult(editData.fusible_plug) : "Ok",
//     painting: editData ? normalizeResult(editData.painting) : "Ok",
//     cyl_cap_avl: editData ? normalizeResult(editData.cyl_cap_avl) : "Ok",
//     eci_result: editData ? normalizeResult(editData.eci_result) : "OK",
//     current_tare_wt: editData ? editData.current_tare_wt : "",
//     actual_tare_wt: editData ? editData.actual_tare_wt : "",
//     actual_tare_wt_aft_sol: editData ? editData.actual_tare_wt_aft_sol : "",
//     qty_solvent: editData ? editData.qty_solvent : "",
//     acetone_drum_tag_no: editData ? editData.acetone_drum_tag_no : "",
//     from_depot: editData ? editData.from_depot : "",
//     from_plant_id: unit_id,
//     to_plant_id: unit_id,
//     shift: editData ? editData.shift : "shift1",
//     shift_time: editData ? editData.shift_time : "08:00",
//     done_by: userInfo.plant_id || "",
//     fin_year: editData ? editData.fin_year : dayjs().month() >= 3 ? `${dayjs().year()}-${dayjs().year() + 1}` : `${dayjs().year() - 1}-${dayjs().year()}`,
//     unit_id: editData ? editData.unit_id : 1,
//     modified_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
//     modified_by: editData ? userInfo.user_id : null,
//     created_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
//     created_by: editData ? editData.created_by : userInfo.user_id,
//   });

//   const [cylinder, setCylinder] = useState([]);
//   const [plant, setPlant] = useState([]);
//   const [depot, setDepot] = useState([]);
//   const [ecimap, setEcimap] = useState([]);
//   const [tagMap, setTagMap] = useState({});
//   const [openDialog, setOpenDialog] = useState(false);
//   const [isMultiDialog, setIsMultiDialog] = useState(false);
//   const [tableData, setTableData] = useState([]);
//   const [dialogData, setDialogData] = useState({
//     cylinder_no: "", cyl_id: "", tag_no: "",
//     valve_condition: "Ok", fusible_plug: "Ok", painting: "Ok", cyl_cap_avl: "Ok", eci_result: "OK",
//     current_tare_wt: "", actual_tare_wt: "", actual_tare_wt_aft_sol: "", qty_solvent: "",
//     acetone_drum_tag_no: "", from_plant: "", to_plant: "", shift_time: "", shift: "", done_by: "",
//   });
//   const [multiDialogData, setMultiDialogData] = useState({ cylinder_nos: "" });
//   const [editIndex, setEditIndex] = useState(null);
//   const [successMessage, setSuccessMessage] = useState(null);
//   const [controller, setController] = useState({ page: 0, rowsPerPage: 10 });
// const total_count = tableData.length;

// const handleChangePage = (event, newPage) => {
//   setController(prev => ({ ...prev, page: newPage }));
// };

// const paginatedTableData = tableData.slice(
//   controller.page * controller.rowsPerPage,
//   controller.page * controller.rowsPerPage + controller.rowsPerPage
// );
//   const [isScannerOpen, setIsScannerOpen] = useState(false);
//   const [scanResults, setScanResults] = useState([]);
//   const [openSnackbar, setOpenSnackbar] = useState(false);
//   const qrCodeRegionId = "qr-reader";
//   const html5QrCodeRef = useRef(null);
//   const scannerStateRef = useRef({ isStarting: false, isStopping: false });
//   const lastScanTimeRef = useRef(0);
//   const debounceDelay = 500;
//   const [singleCylinderInput, setSingleCylinderInput] = useState("");
//   const [singleCylinderDetails, setSingleCylinderDetails] = useState(null);
//   const [multiCylinders, setMultiCylinders] = useState([]);

//   const handleChange = ({ target }) => {
//     const { name, value } = target;
//     if (name === "entry_date") {
//       const formattedDate = dayjs(value).isValid() ? dayjs(value).format("YYYY-MM-DD") : "";
//       const financialYear = formattedDate ? dayjs(formattedDate).month() >= 3 ? `${dayjs(formattedDate).year()}-${dayjs(formattedDate).year() + 1}` : `${dayjs(formattedDate).year() - 1}-${dayjs(formattedDate).year()}` : "";
//       setData(prev => ({ ...prev, entry_date: formattedDate, fin_year: financialYear }));
//     } else {
//       setData(prev => ({ ...prev, [name]: value }));
//     }
//   };

// useEffect(() => {
//   const total = tableData.reduce((sum, row) => {
//     return sum + (parseFloat(row.qty_solvent) || 0);
//   }, 0);
//   setData(prev => ({ ...prev, acetone_used: total > 0 ? total.toFixed(2) : "0.00" }));
// }, [tableData]);

//   const handleDialogChange = async ({ target }) => {
//     const { name, value } = target;
//     let normalizedValue = value;
//     if (["valve_condition", "fusible_plug", "painting", "cyl_cap_avl", "eci_result"].includes(name)) {
//       normalizedValue = normalizeResult(value);
//     }
//     let newDialogData = { ...dialogData };
//     if (["current_tare_wt", "actual_tare_wt", "actual_tare_wt_aft_sol"].includes(name)) {
//       normalizedValue = parseFloat(value) || 0;
//       newDialogData = { ...dialogData, [name]: normalizedValue };
//       const tare = name === "current_tare_wt" ? normalizedValue : parseFloat(dialogData.current_tare_wt);
//       const aftSol = name === "actual_tare_wt_aft_sol" ? normalizedValue : parseFloat(dialogData.actual_tare_wt_aft_sol);
//       newDialogData.qty_solvent = aftSol - tare;
//     } else if (name === "qty_solvent") {
//       normalizedValue = parseFloat(value);
//       newDialogData = { ...dialogData, qty_solvent: normalizedValue };
//     } else if (name === "cylinder_no") {
//       const selectedCylinder = cylinder.find(cyl => cyl.tag_no === value);
//       let cylinderCode = selectedCylinder ? selectedCylinder.cylinder_no : "";
//       if (!cylinderCode && value) {
//         try {
//           const cylinderData = await cylinderMasterService.getCylinderList(value);
//           cylinderCode = cylinderData.cylinder_no || "";
//         } catch (error) { console.error("Error fetching cylinder_no:", error); }
//       }
//       newDialogData = { ...dialogData, cylinder_no: value, cyl_id: selectedCylinder ? selectedCylinder.cyl_id : "", tag_no: selectedCylinder ? selectedCylinder.cylinder_no : "", eci_result: normalizeResult(selectedCylinder?.note) || dialogData.eci_result, actual_tare_wt: selectedCylinder?.tare_wt ? selectedCylinder.tare_wt : dialogData.actual_tare_wt };
//     } else {
//       newDialogData = { ...dialogData, [name]: normalizedValue };
//     }
//     setDialogData(newDialogData);
//   };

//   const handleMultiDialogChange = ({ target }) => setMultiDialogData({ cylinder_nos: target.value });

//   const handleOpenDialog = () => {
//     setDialogData({ cylinder_no: "", cyl_id: "", tag_no: "", valve_condition: "Ok", fusible_plug: "Ok", painting: "Ok", cyl_cap_avl: "Ok", eci_result: "OK", current_tare_wt: "", actual_tare_wt: "", actual_tare_wt_aft_sol: "", qty_solvent: "", acetone_drum_tag_no: "", from_plant: "", to_plant: "", done_by: "" });
//     setEditIndex(null); setIsMultiDialog(false); setOpenDialog(true); setScanResults([]);
//   };

//   const handleOpenmulDialog = () => {
//     setMultiDialogData({ cylinder_nos: "" });
//     setEditIndex(null); setIsMultiDialog(true); setOpenDialog(true); setScanResults([]);
//   };

//   const handleEditRow = (index) => {
//     setDialogData({ ...tableData[index], eci_result: normalizeResult(tableData[index].eci_result) || "Ok" });
//     setEditIndex(index); setIsMultiDialog(false); setOpenDialog(true); setScanResults([]);
//   };

//   const handleCloseDialog = () => { stopScanner(); setOpenDialog(false); setScanResults([]); };

//   const handleDialogSubmit = () => {
//     if (isMultiDialog) {
//       if (!multiCylinders.length) { setSuccessMessage("Please enter at least one valid cylinder"); setOpenSnackbar(true); return; }
//       const newRows = multiCylinders.filter(cyl => !tableData.some((row, idx) => idx !== editIndex && row.cyl_id === cyl.cyl_id)).map(cyl => ({ cylinder_no: cyl.cylinder_no, cyl_id: cyl.cyl_id, tag_no: cyl.tag_no, valve_condition: "Ok", fusible_plug: "Ok", painting: "Ok", cyl_cap_avl: "Ok", eci_result: "", current_tare_wt: 0, actual_tare_wt: cyl.tare_wt || 0, actual_tare_wt_aft_sol: 0, qty_solvent: 0, acetone_drum_tag_no: "", from_plant: "", to_plant: "", shift_time: data.shift_time, shift: data.shift, done_by: data.done_by }));
//       if (!newRows.length) { setSuccessMessage("All cylinders already added"); setOpenSnackbar(true); return; }
//       setTableData(prev => [...prev, ...newRows]);
//       setMultiCylinders([]); setMultiDialogData({ cylinder_nos: "" }); setOpenDialog(false); stopScanner();
//       setSuccessMessage("Cylinders added successfully"); setOpenSnackbar(true);
//     } else {
//       const requiredFields = [{ key: "cylinder_no", name: "Cylinder Number" }, { key: "valve_condition", name: "Valve Condition" }, { key: "fusible_plug", name: "Fusible Plug" }, { key: "painting", name: "Painting" }, { key: "cyl_cap_avl", name: "Cylinder Cap Availability" }, { key: "eci_result", name: "ECI Result" }];
//       const missingFields = requiredFields.filter(field => !dialogData[field.key]);
//       if (missingFields.length > 0) { setSuccessMessage(`Please fill: ${missingFields.map(f => f.name).join(", ")}`); setOpenSnackbar(true); return; }
//       if (tableData.some((row, idx) => idx !== editIndex && row.cyl_id === dialogData.cyl_id)) { setSuccessMessage("Cylinder already added"); setOpenSnackbar(true); return; }
//       const normalizedDialogData = { ...dialogData, valve_condition: normalizeResult(dialogData.valve_condition), fusible_plug: normalizeResult(dialogData.fusible_plug), painting: normalizeResult(dialogData.painting), cyl_cap_avl: normalizeResult(dialogData.cyl_cap_avl), eci_result: normalizeResult(dialogData.eci_result), remarks: dialogData.eci_result === "Not Ok" ? dialogData.remarks || "" : "", current_tare_wt: dialogData.current_tare_wt ? Number(dialogData.current_tare_wt) || 0 : 0, actual_tare_wt: dialogData.actual_tare_wt ? Number(dialogData.actual_tare_wt) || 0 : 0, actual_tare_wt_aft_sol: dialogData.actual_tare_wt_aft_sol ? Number(dialogData.actual_tare_wt_aft_sol) || 0 : 0, qty_solvent: dialogData.qty_solvent ? Number(dialogData.qty_solvent) || 0 : 0, acetone_drum_tag_no: dialogData.acetone_drum_tag_no || "" };
//       if (urlLocation.state?.openDialog) { setSuccessMessage("Inspection details saved"); setOpenSnackbar(true); setOpenDialog(false); stopScanner(); }
//       else {
//         if (editIndex !== null) setTableData(prev => { const n = [...prev]; n[editIndex] = normalizedDialogData; return n; });
//         else setTableData(prev => [...prev, normalizedDialogData]);
//         setSuccessMessage("Cylinder details saved"); setOpenSnackbar(true); setOpenDialog(false); stopScanner();
//       }
//     }
//   };

//   const handleRemoveRow = (index) => setTableData(prev => prev.filter((_, i) => i !== index));

//   const startScanner = () => {
//     if (scannerStateRef.current.isStarting || isScannerOpen) return;
//     scannerStateRef.current.isStarting = true;
//     setIsScannerOpen(true);
//   };

//   const stopScanner = () => {
//     if (scannerStateRef.current.isStopping || !html5QrCodeRef.current) { setIsScannerOpen(false); return; }
//     if (!html5QrCodeRef.current.isScanning) { setIsScannerOpen(false); return; }
//     scannerStateRef.current.isStopping = true;
//     html5QrCodeRef.current.stop().then(() => { html5QrCodeRef.current.clear(); setIsScannerOpen(false); scannerStateRef.current.isStopping = false; }).catch(err => { setIsScannerOpen(false); scannerStateRef.current.isStopping = false; });
//   };

//   const findCylinderByNoOrTag = (input, cylinderList) => {
//     if (!input) return null;
//     const val = input.trim().toLowerCase();
//     return cylinderList.find(cyl => (cyl.cylinder_no && cyl.cylinder_no.toLowerCase() === val) || (cyl.tag_no && cyl.tag_no.toLowerCase() === val));
//   };

//   const fetchSingleCylinderDetails = (input) => {
//     if (!input) { setSingleCylinderDetails(null); return; }
//     const match = findCylinderByNoOrTag(input, cylinder);
//     if (match) {
//       setSingleCylinderDetails(match);
//       setDialogData(prev => ({ ...prev, cylinder_no: match.tag_no, tag_no: match.cylinder_no, owner: match.owner, cyl_id: match.cyl_id, actual_tare_wt: match.tare_wt, eci_result: prev.eci_result }));
//       setSuccessMessage("Cylinder found"); setOpenSnackbar(true); setSingleCylinderInput("");
//     } else { setSingleCylinderDetails(null); setSuccessMessage("No cylinder found"); setOpenSnackbar(true); }
//   };

//   const addMultiCylinder = (input) => {
//     if (!input) return;
//     const match = findCylinderByNoOrTag(input, cylinder);
//     if (match) {
//       setMultiCylinders(prev => {
//         if (prev.some(c => c.cyl_id === match.cyl_id)) { setSuccessMessage("Already added"); setOpenSnackbar(true); return prev; }
//         setSuccessMessage("Cylinder added"); setOpenSnackbar(true);
//         return [...prev, match];
//       });
//     } else { setSuccessMessage("No cylinder found"); setOpenSnackbar(true); }
//   };

//   useEffect(() => {
//     async function fetchData() {
//       try {
//         const [cylinderData, plantData, depotData, ecimapData, RelatedCylinder] = await Promise.all([
          
//           cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: "" }),
//           plantMasterService.getPlantList({ page: 0, size: 999, searchKey: "" }),
//           depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
//           emptyCylinderInspectionService.getEciList({ page: 0, size: 999, searchKey: "" }),
//           emptyCylinderInspectionService.getCylinders(plant_id),
//         ]);
//         if (!Array.isArray(RelatedCylinder)) throw new Error("cylinderData is not an array");
//         setCylinder(RelatedCylinder); setPlant(plantData); setDepot(depotData); setEcimap(ecimapData);
//         if (!editData) {
//   const lastRaw = ecimapData?.[0]?.lastECIEntryNo ?? "";
//   const parts = String(lastRaw).split("/");
//   const lastSeq = parseInt(parts[parts.length - 1]) || 0;
//   const nextSeq = lastSeq + 1;

//   const yr = dayjs();
//   const finYear = yr.month() >= 3
//     ? `${yr.year()}-${String(yr.year() + 1).slice(-2)}`
//     : `${yr.year() - 1}-${String(yr.year()).slice(-2)}`;

//   const formattedEntryNo = `${short_code}/${finYear}/${String(nextSeq).padStart(4, "0")}`;
//   setData(prev => ({ ...prev, entry_no: formattedEntryNo }));
// }
//         const tagMapping = {};
//         cylinderData.forEach(item => {
//           if (!item.is_deleted) {
//             if (item.cylinder_no?.trim()) tagMapping[item.cylinder_no.trim().toLowerCase()] = { cylinder_no: item.tag_no, cyl_id: item.cyl_id, tag_no: item.cylinder_no };
//             if (item.tag_no?.trim()) tagMapping[item.tag_no.trim().toLowerCase()] = { cylinder_no: item.tag_no, cyl_id: item.cyl_id, tag_no: item.cylinder_no };
//           }
//         });
//         setTagMap(tagMapping);
//         const userPlant = plantData.find(p => p.plant_id === plant_id);
//         if (userPlant) { setData(prev => ({ ...prev, from_plant: userPlant.plant_name, done_by: userPlant.plant_name })); setDialogData(prev => ({ ...prev, from_plant: userPlant.plant_name, done_by: userPlant.plant_name })); }
//       } catch (error) { console.error("Error fetching data:", error); }
//     }
//     fetchData();
//   }, [plant_id]);

//   useEffect(() => {
//     if (editData && typeof editData.tableData === "string") {
//       try {
//         const parsed = JSON.parse(editData.tableData);
//         setTableData(parsed.map(row => ({ ...row, valve_condition: normalizeResult(row.valve_condition), fusible_plug: normalizeResult(row.fusible_plug), painting: normalizeResult(row.painting), cyl_cap_avl: normalizeResult(row.cyl_cap_avl), eci_result: normalizeResult(row.eci_result), actual_tare_wt: row.actual_tare_wt || "" })));
//       } catch (e) { setTableData([]); }
//     }
//   }, [editData]);

//   useEffect(() => {
//     if (!isScannerOpen || !openDialog) { if (html5QrCodeRef.current?.isScanning) stopScanner(); return; }
//     const element = document.getElementById(qrCodeRegionId);
//     if (!element) { setIsScannerOpen(false); scannerStateRef.current.isStarting = false; return; }
//     if (html5QrCodeRef.current?.isScanning) { scannerStateRef.current.isStarting = false; return; }
//     html5QrCodeRef.current = new Html5Qrcode(qrCodeRegionId);
//     const onQrScanSuccess = (decodedText) => {
//       const now = Date.now();
//       if (now - lastScanTimeRef.current < debounceDelay) return;
//       lastScanTimeRef.current = now;
//       if (isMultiDialog) { setMultiDialogData({ cylinder_nos: decodedText }); addMultiCylinder(decodedText); setTimeout(() => setMultiDialogData({ cylinder_nos: "" }), 1000); }
//       else { fetchSingleCylinderDetails(decodedText); stopScanner(); }
//       setScanResults(prev => [...prev, decodedText]);
//     };
//     html5QrCodeRef.current.start({ facingMode: "environment" }, { fps: 10, qrbox: 250 }, onQrScanSuccess, () => {}).then(() => { scannerStateRef.current.isStarting = false; }).catch(err => { setIsScannerOpen(false); scannerStateRef.current.isStarting = false; });
//     return () => { if (html5QrCodeRef.current?.isScanning && !scannerStateRef.current.isStopping) { try { html5QrCodeRef.current.stop(); html5QrCodeRef.current.clear(); } catch {} } };
//   }, [isScannerOpen, openDialog, isMultiDialog, tagMap, cylinder, depot, depot_id, tableData, editIndex]);

//   useEffect(() => {
//     if (urlLocation.state?.openDialog && urlLocation.state?.rowData) {
//       const row = urlLocation.state.rowData;
//       setSingleCylinderDetails({ cylinder_no: row.cylinder_no || "", tag_no: row.tag_no || "", cyl_id: row.cyl_id || "", owner: row.owner || "N/A", cust_name: row.cust_name || "" });
//       setDialogData({ cylinder_no: row.cylinder_no || "", cyl_id: row.cyl_id || "", tag_no: row.tag_no || "", owner: row.owner || "", valve_condition: normalizeResult(row.valve_condition) || "Ok", fusible_plug: normalizeResult(row.fusible_plug) || "Ok", painting: normalizeResult(row.painting) || "Ok", cyl_cap_avl: normalizeResult(row.cyl_cap_avl) || "Ok", eci_result: normalizeResult(row.eci_result) || "Ok", current_tare_wt: row.current_tare_wt || "", actual_tare_wt: row.actual_tare_wt || "", actual_tare_wt_aft_sol: row.actual_tare_wt_aft_sol || "", qty_solvent: row.qty_solvent || "", acetone_drum_tag_no: row.acetone_drum_tag_no || "", from_plant: row.from_plant || data.from_plant || "", to_plant: row.to_plant || "", shift_time: row.shift_time || data.shift_time || "08:00", shift: row.shift || data.shift || "shift1", done_by: row.done_by || data.done_by || "" });
//       setSingleCylinderInput(row.cylinder_no || ""); setEditIndex(null); setIsMultiDialog(false); setOpenDialog(true);
//     }
//   }, [urlLocation.state, data.from_plant, data.shift, data.shift_time, data.done_by]);

//   useEffect(() => {
//     async function fetchAndMapCylinders() {
//       try {
//         const cylinderData = await emptyCylinderInspectionService.getCylinders(plant_id);
//         if (!Array.isArray(cylinderData)) throw new Error("Not an array");
//         setTableData(cylinderData.map(cyl => ({ cylinder_no: cyl.cylinder_no || "", cyl_id: cyl.cyl_id || "", tag_no: cyl.tag_no || "", owner: cyl.owner || "", valve_condition: "Ok", fusible_plug: "Ok", painting: "Ok", cyl_cap_avl: "Ok", eci_result: "", current_tare_wt: "", actual_tare_wt: cyl.tare_wt ? Number(cyl.tare_wt) : "", actual_tare_wt_aft_sol: "", qty_solvent: "", acetone_drum_tag_no: "", from_plant: data.from_plant || "", to_plant: "", shift: data.shift || "shift1", shift_time: data.shift_time || "08:00", done_by: data.done_by || "" })));
//       } catch (error) { setTableData([]); }
//     }
//     fetchAndMapCylinders();
//   }, [plant_id, data.from_plant, data.shift, data.shift_time, data.done_by]);

//   const onSubmit = async () => {
//     if (!data || Object.keys(data).length === 0 || tableData.length === 0) { setSuccessMessage("Please fill required fields"); setOpenSnackbar(true); return; }
//     const validTableData = tableData.filter(row => row.eci_result === "Ok" || row.eci_result === "Not Ok");
//     if (validTableData.length === 0) { setSuccessMessage("No record to save"); setOpenSnackbar(true); return; }
//     const eciData = { ...data, entry_date: dayjs(data.entry_date).format("YYYY-MM-DD"), tableData: validTableData, modified_at: dayjs().format("YYYY-MM-DD HH:mm:ss"), created_at: dayjs().format("YYYY-MM-DD HH:mm:ss"), changedUpdatedValue: "edit", short_code, unit_id };
//     try {
//       if (editData) await emptyCylinderInspectionService.editDeleteEci(eciData);
//       else await emptyCylinderInspectionService.addEci(eciData);
//       setSuccessMessage(editData ? "Updated successfully" : "Saved successfully");
//       setOpenSnackbar(true);
//       setTimeout(() => { setOpenSnackbar(false); navigate(-1); }, 3000);
//     } catch (error) { setSuccessMessage("Error occurred during save"); setOpenSnackbar(true); }
//   };

//   const shiftOptions = [{ label: "Shift 1", value: "shift1" }, { label: "Shift 2", value: "shift2" }, { label: "Shift 3", value: "shift3" }];

//   // Status pill for table
//   const StatusPill = ({ value }) => {
//     const isOk = value === "Ok";
//     const isNotOk = value === "Not Ok";
//     const isPassed = value === "Ok";
//     return (
//       <Box sx={{ display: "inline-flex", alignItems: "center", px: 1.5, py: 0.3, borderRadius: "20px", fontSize: "11px", fontWeight: 600, background: isOk ? "#F0FFF4" : isNotOk ? "#FFF5F5" : "#F7FAFC", color: isOk ? "#2F855A" : isNotOk ? "#E53E3E" : "#A0AEC0" }}>
//         {value || "—"}
//       </Box>
//     );
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={pageSx}>
//         {/* Breadcrumb */}
//         <Box sx={breadcrumbSx}>
//           <span>Dashboard</span> / <span style={{ color: "#2B6CB0", fontWeight: 600 }}>Empty Cylinder Inspection</span>
//         </Box>

//         {/* Page Header */}
//         <Box sx={pageHeaderSx}>
//           <Box sx={pageTitleSx}>
//             <SearchIcon sx={{ fontSize: 20, color: "#1C3A5E" }} />
//             {editData ? "UPDATE" : "CREATE"} INSPECTION
//           </Box>
//           <Button onClick={() => navigate(-1)} sx={backBtnSx}>
//             <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
//           </Button>
//         </Box>

//         {/* Last Entry */}
//         {!editData && (
//           <Box sx={{ textAlign: "right", fontSize: "12px", color: "#718096", mb: 1.5 }}>
//             Last Entry No: {ecimap?.[0]?.lastScheduleEntryNo ?? 0}
//           </Box>
//         )}

//         <form onSubmit={handleSubmit(onSubmit)}>
//           {/* ── Section 1: Inspection Details ────────────────────────── */}
//           {/* ── Section 1: Inspection Details ────────────────────────── */}
// <Box sx={formCardSx}>
//   <Box sx={sectionHeaderSx}>
//     <SearchIcon sx={{ fontSize: 18, color: "#fff" }} />
//     <Typography sx={sectionHeaderTitleSx}>Inspection Details</Typography>
//   </Box>
//   <Box sx={formBodySx}>

//     {/* Two-column layout matching ProductionEntryAdd */}
//     <Grid container sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>

//       {/* LEFT COLUMN — empty / logo / decorative */}
//       <Grid
//         item xs={12} md={6}
//         sx={{
//           p: 2.5,
        
//           borderBottom: { xs: "2px dashed #CBD5E0", md: "none" },
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           minHeight: 200,
//         }}
//       >
//         {/* Aap yahan logo ya kuch aur rakh sakte ho, ya blank chhod do */}
//         {/* <Typography sx={{ fontSize: "13px", color: "#A0AEC0" }}>
//           — Inspection Summary —
//         </Typography> */}
//       </Grid>

//       {/* RIGHT COLUMN — all fields */}
//       <Grid item xs={12} md={6} sx={{ p: 2.5, background: "#FAFBFC", pl: 3.5 }}>
//         <Grid container spacing={1.5}>

//           {/* Entry No */}
//           <Grid item xs={12} sm={6}>
//             <Typography sx={fieldLabelSx}>Entry No</Typography>
//             <TextField
//               size="small" fullWidth name="entry_no"
//               value={data.entry_no} sx={readonlyInputSx}
//               InputProps={{ readOnly: true }} placeholder="Auto-generated"
//             />
//           </Grid>

//           {/* Entry Date */}
//           <Grid item xs={12} sm={6}>
//             <Typography sx={fieldLabelSx}>
//               Entry Date <span style={{ color: "#E53E3E" }}>*</span>
//             </Typography>
//             <DatePicker
//               format="DD/MM/YYYY"
//               value={data.entry_date ? dayjs(data.entry_date) : null}
//               onChange={nv => handleChange({ target: { name: "entry_date", value: nv ? nv.format("YYYY-MM-DD") : "" } })}
//               slotProps={{ textField: { size: "small", fullWidth: true, required: true, sx: inputSx } }}
//             />
//           </Grid>

//           {/* Shift */}
//           <Grid item xs={12} sm={6}>
//             <Typography sx={fieldLabelSx}>Shift</Typography>
//             <Autocomplete
//               options={shiftOptions} fullWidth
//               getOptionLabel={o => typeof o === "string" ? o : o.label}
//               value={shiftOptions.find(s => s.value === data.shift) || null}
//               onChange={(e, nv) => handleChange({ target: { name: "shift", value: nv ? nv.value : "" } })}
//               isOptionEqualToValue={(o, v) => o.value === v.value}
//               renderOption={(props, option) => <MenuItem {...props} sx={menuItemSx}>{option.label}</MenuItem>}
//               renderInput={(params) => <TextField {...params} size="small" fullWidth sx={inputSx} placeholder="Select shift" />}
//             />
//           </Grid>

//           {/* Shift Time */}
//           <Grid item xs={12} sm={6}>
//             <Typography sx={fieldLabelSx}>Shift Time</Typography>
//             <TextField
//               type="time" size="small" fullWidth
//               name="shift_time" value={data.shift_time}
//               onChange={handleChange} sx={inputSx}
//             />
//           </Grid>

//           {/* Done By */}
//           <Grid item xs={12} sm={6}>
//             <Typography sx={fieldLabelSx}>Inspection Done By</Typography>
//             <TextField
//               type="text" size="small" fullWidth
//               name="done_by" value={data.done_by}
//               onChange={handleChange} sx={inputSx}
//               placeholder="Enter name"
//             />
//           </Grid>
//           {/* Acetone Used (KG) */}
// <Grid item xs={12} sm={6}>
//   <Typography sx={fieldLabelSx}>Acetone Used (KG)</Typography>
//   <TextField
//     size="small" fullWidth
//     value={data.acetone_used}
//     sx={readonlyInputSx}
//     InputProps={{ readOnly: true }}
//     placeholder="Auto-calculated"
//   />
// </Grid>

//         </Grid>
//       </Grid>

//     </Grid>
//   </Box>
// </Box>
//           {/* ── Section 2: Cylinder Inspection Table ─────────────────── */}
//           <Box sx={formCardSx}>
//             {/* <Box sx={sectionHeaderSx}>
//               <SearchIcon sx={{ fontSize: 18, color: "#fff" }} />
//               <Typography sx={sectionHeaderTitleSx}>Cylinder Inspection List</Typography>
//             </Box> */}

//             <TableContainer>
//               <Table size="small" stickyHeader>
//                 <TableHead>
//                   <tr>
//                     {[
//   { label: "Sr No", align: "center" },
//   { label: "Cyl No", align: "left" },
//   { label: "Tag No", align: "left" },
//   { label: "Valve", align: "left" },
//   { label: "Fusible Plug", align: "left" },
//   { label: "Painting", align: "left" },
//   { label: "Cap Avl", align: "left" },
//   { label: "Result", align: "left" },
//   { label: "Actual Tare Wt", align: "right" },
//   { label: "Current Wt", align: "right" },
//   { label: "Wt After Solvent", align: "right" },
//   { label: "Qty Solvent", align: "right" },
//   { label: "Acetone Drum Tag", align: "left" },
//   { label: "Action", align: "center" },
// ].map(({ label, align }) => (
//   <th key={label} style={{
//     background: "#1C3A5E", color: "#fff", fontSize: "11px", fontWeight: 600,
//     fontFamily: "'Inter', Arial, sans-serif", padding: "10px 10px",
//     borderRight: "1px solid rgba(255,255,255,0.1)", whiteSpace: "nowrap",
//     textAlign: align,
//   }}>{label}</th>
// ))}
//                   </tr>
//                 </TableHead>
//                 <TableBody>
//                 {paginatedTableData.map((row, index) => (
//   <tr
//     key={index}
//     onClick={() => handleEditRow(controller.page * controller.rowsPerPage + index)}
//     style={{ background: index % 2 === 0 ? "#fff" : "#F8FAFC", cursor: "pointer", borderBottom: "1px solid #E2E8F0" }}
//     onMouseEnter={e => e.currentTarget.style.background = "#EBF4FF"}
//     onMouseLeave={e => e.currentTarget.style.background = index % 2 === 0 ? "#fff" : "#F8FAFC"}
//   >
//     {/* Sr No */}
//     <td style={{ padding: "8px 10px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", textAlign: "center" }}>
//       {controller.page * controller.rowsPerPage + index + 1}
//     </td>
//     {/* Cyl No */}
//     <td style={{ padding: "8px 10px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", textAlign: "left" }}>
//       {row.cylinder_no}
//     </td>
//     {/* Tag No */}
//     <td style={{ padding: "8px 10px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", textAlign: "left" }}>
//       {row.tag_no}
//     </td>
//     {/* Valve, Fusible Plug, Painting, Cap Avl */}
//     {["valve_condition", "fusible_plug", "painting", "cyl_cap_avl"].map(field => (
//       <td key={field} style={{ padding: "8px 10px", textAlign: "left" }}>
//         <StatusPill value={row[field]} />
//       </td>
//     ))}
//     {/* Result */}
//     <td style={{ padding: "8px 10px", textAlign: "left" }}>
//       <Box sx={{ display: "inline-flex", alignItems: "center", px: 1.5, py: 0.3, borderRadius: "20px", fontSize: "11px", fontWeight: 700, background: row.eci_result === "Ok" ? "#F0FFF4" : row.eci_result === "Not Ok" ? "#FFF5F5" : "#F7FAFC", color: row.eci_result === "Ok" ? "#2F855A" : row.eci_result === "Not Ok" ? "#E53E3E" : "#A0AEC0" }}>
//         {row.eci_result === "Ok" ? "Passed" : row.eci_result === "Not Ok" ? "Not Passed" : row.eci_result || "—"}
//       </Box>
//     </td>
//     {/* Actual Tare Wt, Current Wt, Wt After Solvent */}
//     {[row.actual_tare_wt, row.current_tare_wt, row.actual_tare_wt_aft_sol].map((val, i) => (
//       <td key={i} style={{ padding: "8px 10px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", textAlign: "right" }}>
//         {val}
//       </td>
//     ))}
//     {/* Qty Solvent */}
//     <td style={{ padding: "8px 10px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", textAlign: "right" }}>
//       {Number(row.qty_solvent).toFixed(2)}
//     </td>
//     {/* Acetone Drum Tag */}
//     <td style={{ padding: "8px 10px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", textAlign: "left" }}>
//       {row.acetone_drum_tag_no}
//     </td>
//     {/* Action */}
//     <td style={{ padding: "8px 10px", textAlign: "center" }} onClick={e => e.stopPropagation()}>
//       <Box sx={{ display: "flex", justifyContent: "center", gap: 0.5 }}>
//         <IconButton size="small" onClick={() => handleEditRow(controller.page * controller.rowsPerPage + index)} sx={{ color: "#2063b6", "&:hover": { background: "#EBF4FF" }, borderRadius: "6px" }}>
//           <EditIcon sx={{ fontSize: "15px" }} />
//         </IconButton>
//         <IconButton size="small" onClick={e => { e.stopPropagation(); handleRemoveRow(controller.page * controller.rowsPerPage + index); }} sx={{ color: "#E53E3E", "&:hover": { background: "#FFF5F5" }, borderRadius: "6px" }}>
//           <DeleteForeverIcon sx={{ fontSize: "16px" }} />
//         </IconButton>
//       </Box>
//     </td>
//   </tr>
// ))}
//                   {tableData.length === 0 && (
//                     <tr>
//                       <td colSpan={14} style={{ padding: "32px", textAlign: "center", color: "#A0AEC0", fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" }}>
//                         No cylinders loaded yet. Cylinders will appear here.
//                       </td>
//                     </tr>
//                   )}
//                 </TableBody>
//               </Table>
//             </TableContainer>

//               <CustomPagination
//   page={controller.page}
//   rowsPerPage={controller.rowsPerPage}
//   totalCount={total_count || 0}
//   onPageChange={(newPage) => handleChangePage(null, newPage)}
// />

//             {/* Footer Buttons */}
//             <Box sx={formFooterSx}>
//               <Button sx={cancelBtnSx} onClick={() => navigate(-1)}>Cancel</Button>
//               <Button type="submit" sx={saveBtnSx}>
//                 <SaveIcon sx={{ fontSize: 18 }} />
//                 {editData ? "Update" : "Save"}
//               </Button>
//             </Box>
//           </Box>
//         </form>

//         {/* ── Inspection Dialog ─────────────────────────────────────── */}
//         <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: "14px", border: "1px solid #E2E8F0" } }}>
//           {/* Dialog Header */}
//           <Box sx={{ background: "#1C3A5E", padding: "14px 22px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//             <Box>
//               {editIndex !== null ? (
//                 <Box sx={{ display: "flex", gap: 3 }}>
//                   {[["Cyl No", dialogData.cylinder_no], ["Tag No", dialogData.tag_no], ["Owner", dialogData.owner]].map(([label, val]) => (
//                     <Box key={label}>
//                       <Typography sx={{ fontSize: "10px", color: "rgba(255,255,255,0.6)", fontFamily: "'Inter', Arial, sans-serif" }}>{label}</Typography>
//                       <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#fff", fontFamily: "'Inter', Arial, sans-serif" }}>{val || "N/A"}</Typography>
//                     </Box>
//                   ))}
//                 </Box>
//               ) : (
//                 <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#fff", fontFamily: "'Inter', Arial, sans-serif" }}>
//                   {isMultiDialog ? "Add Multiple Cylinders" : "Cylinder Inspection"}
//                 </Typography>
//               )}
//             </Box>
//             <CancelIcon onClick={handleCloseDialog} sx={{ color: "rgba(255,255,255,0.7)", cursor: "pointer", fontSize: 20, "&:hover": { color: "#fff" } }} />
//           </Box>

//           <DialogContent sx={{ pt: 3, pb: 1 }}>
//             {isMultiDialog ? (
//               <Grid container spacing={2}>
//                 {/* Multi entry */}
//                 <Grid item xs={12}>
//                   <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
//                     <Typography sx={{ ...fieldLabelSx, mb: 0, minWidth: "120px" }}>Enter Cyl/Tag No</Typography>
//                     <TextField
//                       size="small" sx={{ ...inputSx, maxWidth: "200px" }}
//                       value={multiDialogData.cylinder_nos}
//                       onChange={e => setMultiDialogData({ cylinder_nos: e.target.value })}
//                       onBlur={e => addMultiCylinder(e.target.value)}
//                       onKeyDown={e => { if (e.key === "Enter") addMultiCylinder(e.target.value); }}
//                       placeholder="Scan or type"
//                     />
//                     <Button
//                       variant="contained"
//                       onClick={() => {
//                         setTableData(prev => [...prev, ...multiCylinders.map(cyl => ({ cylinder_no: cyl.cylinder_no, cyl_id: cyl.cyl_id, tag_no: cyl.tag_no, valve_condition: "Ok", fusible_plug: "Ok", painting: "Ok", cyl_cap_avl: "Ok", eci_result: "", current_tare_wt: "", actual_tare_wt: "", actual_tare_wt_aft_sol: "", qty_solvent: "", acetone_drum_tag_no: "", from_plant: "", to_plant: "", shift_time: data.shift_time, shift: data.shift, done_by: data.done_by }))]);
//                         setMultiCylinders([]); setOpenDialog(false); setScanResults([]);
//                       }}
//                       sx={{ ...saveBtnSx, height: "38px", px: 2 }}
//                     >
//                       OK
//                     </Button>
//                   </Box>
//                 </Grid>

//                 {/* Scanner region */}
//                 {isScannerOpen && (
//                   <Grid item xs={12}>
//                     <Box sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", p: 2, display: "flex", flexDirection: "column", alignItems: "center" }}>
//                       <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#1C3A5E", mb: 1 }}>QR Scanner</Typography>
//                       <div id={qrCodeRegionId} style={{ width: "100%", maxWidth: "380px", minHeight: "280px" }} />
//                     </Box>
//                   </Grid>
//                 )}

//                 {/* Added cylinders mini-table */}
//                 {multiCylinders.length > 0 && (
//                   <Grid item xs={12}>
//                     <Box sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>
//                       <Box sx={{ background: "#F8FAFC", px: 2, py: 1.5, borderBottom: "1px solid #E2E8F0" }}>
//                         <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#2063b6" }}>{multiCylinders.length} Cylinders Ready</Typography>
//                       </Box>
//                       <Table size="small">
//                         <TableHead>
//                           <TableRow sx={{ background: "#1C3A5E" }}>
//                             {["#", "Cylinder No", "Tag No", ""].map(h => <TableCell key={h} sx={{ color: "#fff", fontSize: "11px", fontWeight: 600, py: 1 }}>{h}</TableCell>)}
//                           </TableRow>
//                         </TableHead>
//                         <TableBody>
//                           {multiCylinders.map((row, idx) => (
//                             <TableRow key={row.cyl_id} sx={{ "&:nth-of-type(even)": { background: "#F8FAFC" } }}>
//                               <TableCell sx={{ fontSize: "12px" }}>{idx + 1}</TableCell>
//                               <TableCell sx={{ fontSize: "12px" }}>{row.cylinder_no}</TableCell>
//                               <TableCell sx={{ fontSize: "12px" }}>{row.tag_no}</TableCell>
//                               <TableCell>
//                                 <IconButton size="small" onClick={() => setMultiCylinders(prev => prev.filter(c => c.cyl_id !== row.cyl_id))} sx={{ color: "#E53E3E" }}>
//                                   <DeleteForeverIcon sx={{ fontSize: "16px" }} />
//                                 </IconButton>
//                               </TableCell>
//                             </TableRow>
//                           ))}
//                         </TableBody>
//                       </Table>
//                     </Box>
//                   </Grid>
//                 )}
//               </Grid>
//             ) : (
//               <Grid container spacing={2.5}>
//                 {/* QR scanner region */}
//                 {isScannerOpen && (
//                   <Grid item xs={12}>
//                     <Box sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", p: 2, display: "flex", flexDirection: "column", alignItems: "center" }}>
//                       <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#1C3A5E", mb: 1 }}>QR Scanner</Typography>
//                       <div id={qrCodeRegionId} style={{ width: "100%", maxWidth: "380px", minHeight: "280px" }} />
//                       {scanResults.map((result, idx) => {
//                         const mappedCylinder = tagMap[result?.trim()];
//                         return (
//                           <ListItem key={idx} sx={{ py: 0.5 }}>
//                             <ListItemText primary={`Tag: ${result}`} secondary={mappedCylinder ? `Cyl No: ${mappedCylinder.cylinder_no}` : "❌ Not found"} primaryTypographyProps={{ fontSize: "12px" }} secondaryTypographyProps={{ fontSize: "11px" }} />
//                           </ListItem>
//                         );
//                       })}
//                     </Box>
//                   </Grid>
//                 )}

//                 {/* Divider */}
//                 <Grid item xs={12}><Box sx={{ borderTop: "1px solid #E2E8F0" }} /></Grid>

//                 {/* Inspection dropdowns */}
//                 {[
//                   { key: "valve_condition", label: "Valve Condition" },
//                   { key: "fusible_plug", label: "Fusible Plug" },
//                   { key: "painting", label: "Painting" },
//                   { key: "cyl_cap_avl", label: "Cyl Cap Availability" },
//                 ].map(({ key, label }) => (
//                   <Grid item xs={12} sm={6} key={key}>
//                     <Typography sx={fieldLabelSx}>{label}</Typography>
//                     <TextField
//                       select size="small" fullWidth name={key}
//                       value={dialogData[key] || "Ok"}
//                       onChange={handleDialogChange}
//                       sx={getStatusSx(dialogData[key])}
//                     >
//                       <MenuItem value="Ok" sx={{ ...menuItemSx, color: "#2F855A" }}>Ok</MenuItem>
//                       <MenuItem value="Not Ok" sx={{ ...menuItemSx, color: "#E53E3E" }}>Not Ok</MenuItem>
//                     </TextField>
//                   </Grid>
//                 ))}

//                 {/* Result */}
//                 <Grid item xs={12} sm={6}>
//                   <Typography sx={fieldLabelSx}>Result</Typography>
//                   <TextField
//                     select size="small" fullWidth name="eci_result"
//                     value={dialogData.eci_result || "Ok"}
//                     onChange={e => {
//                       const val = e.target.value;
//                       setDialogData(prev => ({ ...prev, eci_result: val, ...(val === "Not Ok" && { current_tare_wt: "", actual_tare_wt_aft_sol: "", qty_solvent: "", acetone_drum_tag_no: "" }) }));
//                     }}
//                     sx={getStatusSx(dialogData.eci_result)}
//                   >
//                     <MenuItem value="Ok" sx={{ ...menuItemSx, color: "#2F855A", fontWeight: 600 }}>Passed</MenuItem>
//                     <MenuItem value="Not Ok" sx={{ ...menuItemSx, color: "#E53E3E", fontWeight: 600 }}>Not Passed</MenuItem>
//                   </TextField>
//                 </Grid>

//                 {/* Weight fields */}
//                 <Grid item xs={12} sm={6}>
//                   <Typography sx={fieldLabelSx}>Actual Tare Weight</Typography>
//                   <TextField size="small" fullWidth type="number" name="actual_tare_wt" value={dialogData.actual_tare_wt} onChange={handleDialogChange} sx={dialogData.eci_result === "Not Ok" ? readonlyInputSx : inputSx} InputProps={{ readOnly: dialogData.eci_result === "Not Ok" }} disabled={dialogData.eci_result === "Not Ok"} />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography sx={fieldLabelSx}>Current Weight</Typography>
//                   <TextField size="small" fullWidth type="number" name="current_tare_wt" value={dialogData.current_tare_wt} onChange={handleDialogChange} sx={dialogData.eci_result === "Not Ok" ? readonlyInputSx : inputSx} disabled={dialogData.eci_result === "Not Ok"} />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography sx={fieldLabelSx}>Weight After Solvent</Typography>
//                   <TextField size="small" fullWidth type="number" name="actual_tare_wt_aft_sol" value={dialogData.actual_tare_wt_aft_sol} onChange={handleDialogChange} sx={dialogData.eci_result === "Not Ok" ? readonlyInputSx : inputSx} disabled={dialogData.eci_result === "Not Ok"} />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography sx={fieldLabelSx}>Qty of Solvent</Typography>
//                   <TextField size="small" fullWidth type="number" name="qty_solvent" value={Number(dialogData.qty_solvent).toFixed(2)} onChange={handleDialogChange} sx={readonlyInputSx} InputProps={{ readOnly: true }} disabled />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography sx={fieldLabelSx}>Acetone Drum Tag No</Typography>
//                   <TextField size="small" fullWidth type="text" name="acetone_drum_tag_no" value={dialogData.acetone_drum_tag_no} onChange={handleDialogChange} sx={dialogData.eci_result === "Not Ok" ? readonlyInputSx : inputSx} disabled={dialogData.eci_result === "Not Ok"} placeholder="Enter tag number" />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography sx={fieldLabelSx}>Remarks</Typography>
//                   <TextField type="text" size="small" fullWidth name="remarks" value={dialogData.remarks || ""} onChange={handleDialogChange} sx={inputSx} placeholder="Enter remarks" />
//                 </Grid>
//               </Grid>
//             )}
//           </DialogContent>

//           <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
//             <Button onClick={handleCloseDialog} sx={cancelBtnSx}>Cancel</Button>
//             <Button onClick={handleDialogSubmit} sx={saveBtnSx}>Done</Button>
//           </DialogActions>
//         </Dialog>

//         <ReusableSnackbar
//           open={openSnackbar}
//           onClose={(e, reason) => { if (reason !== "clickaway") setOpenSnackbar(false); }}
//           message={successMessage}
//           autoHideDuration={3000}
//           vertical="top"
//           horizontal="right"
//         />
//       </Box>
//     </LocalizationProvider>
//   );
// };

// export default EmptyCylinderInspectionAdd;

import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  MenuItem,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Autocomplete,
  TableRow,
  TableCell,
  TextField,
  Alert,
  Paper,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "../../../styles.module.css";
import {
  Breadcrumb,
  CTSinput,
} from "../../reusableComponent/Reusables";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchIcon from "@mui/icons-material/Search";
import CancelIcon from "@mui/icons-material/Cancel";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import emptyCylinderInspectionService from "../../../services/emptyCylinderInspection.Service";
import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import plantMasterService from "../../../services/masters/plantMaster.Service";
import depotMasterService from "../../../services/masters/depotMaster.Service";
import operatorMasterService from "../../../services/masters/operatorMaster.Service";
import CameraAltSharpIcon from "@mui/icons-material/CameraAltSharp";
import { Html5Qrcode } from "html5-qrcode";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CustomPagination from "../../reusableComponent/CustomPagination";

// ── Shared styles ─────────────────────────────────────────────────────────────
const pageSx = {
  background: "#F4F7FB",
  minHeight: "100vh",
  padding: "20px 24px 40px",
  fontFamily: "'Inter', Arial, sans-serif",
};
const breadcrumbSx = {
  fontSize: "12px",
  color: "#718096",
  mb: 2,
  display: "flex",
  alignItems: "center",
  gap: "6px",
};
const pageHeaderSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  mb: 2.5,
};
const pageTitleSx = {
  fontSize: "16px",
  fontWeight: 700,
  color: "#000000",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};
const backBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  fontSize: "13px",
  fontWeight: 600,
  color: "#2B6CB0",
  padding: "7px 14px",
  border: "1.5px solid #2B6CB0",
  borderRadius: "7px",
  background: "#fff",
  cursor: "pointer",
  textTransform: "none",
  "&:hover": { background: "#E6F1FB" },
};
const formCardSx = {
  background: "#fff",
  border: "1px solid #E2E8F0",
  overflow: "hidden",
  mb: 2,
};
const sectionHeaderSx = {
  background: "#1C3A5E",
  padding: "12px 22px",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};
const sectionHeaderTitleSx = {
  fontSize: "13px",
  fontWeight: 600,
  color: "#fff",
  letterSpacing: "0.3px",
};
const formBodySx = { padding: "22px 24px" };
const fieldLabelSx = {
  fontSize: "12px",
  fontWeight: 600,
  color: "#2063b6",
  mb: "4px",
  display: "flex",
  alignItems: "center",
  gap: "4px",
};
const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    background: "#fafafa",
    height: "38px",
    "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
    "&:hover fieldset": { borderColor: "#CBD5E0" },
    "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
    "&.Mui-focused": { background: "#fff" },
    "&.Mui-disabled": { background: "#F8FAFC" },
  },
  "& input": {
    color: "#1A202C",
    fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    "&::placeholder": { color: "#A0AEC0", opacity: 1 },
  },
  "& .MuiInputLabel-root": { display: "none" },
};
const readonlyInputSx = {
  ...inputSx,
  "& .MuiOutlinedInput-root": {
    ...inputSx["& .MuiOutlinedInput-root"],
    background: "#F0F4F8",
  },
};
const errorInputSx = {
  ...inputSx,
  "& .MuiOutlinedInput-root": {
    ...inputSx["& .MuiOutlinedInput-root"],
    "& fieldset": { borderColor: "#E53E3E", borderWidth: "1.5px" },
    "&:hover fieldset": { borderColor: "#C53030" },
    "&.Mui-focused fieldset": { borderColor: "#C53030", borderWidth: "2px" },
  },
};
const okInputSx = {
  ...inputSx,
  "& .MuiOutlinedInput-root": {
    ...inputSx["& .MuiOutlinedInput-root"],
    "& fieldset": { borderColor: "#38A169", borderWidth: "1.5px" },
    "&:hover fieldset": { borderColor: "#2F855A" },
    "&.Mui-focused fieldset": { borderColor: "#2F855A", borderWidth: "2px" },
  },
  "& .MuiSelect-select": { color: "#2F855A !important" },
};
const notOkInputSx = {
  ...inputSx,
  "& .MuiOutlinedInput-root": {
    ...inputSx["& .MuiOutlinedInput-root"],
    "& fieldset": { borderColor: "#E53E3E", borderWidth: "1.5px" },
    "&:hover fieldset": { borderColor: "#C53030" },
    "&.Mui-focused fieldset": { borderColor: "#C53030", borderWidth: "2px" },
  },
  "& .MuiSelect-select": { color: "#E53E3E !important" },
};
const formFooterSx = {
  padding: "18px 24px",
  background: "#F8FAFC",
  borderTop: "1px solid #E2E8F0",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: "10px",
};
const saveBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "7px",
  padding: "0 22px",
  height: "40px",
  background: "#4CAF50",
  color: "#fff",
  border: "none",
  fontSize: "14px",
  fontWeight: 600,
  textTransform: "none",
  borderRadius: "8px",
  fontFamily: "'Inter', Arial, sans-serif",
  "&:hover": { background: "#028b19", transform: "translateY(-1px)" },
  "&:active": { transform: "translateY(0)" },
  transition: "all 0.15s ease",
};
const cancelBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "7px",
  padding: "0 22px",
  height: "40px",
  background: "#E53E3E",
  color: "#ffffff",
  border: "none",
  "&:hover": { background: "#971f16", transform: "translateY(-1px)" },
  fontSize: "14px",
  fontWeight: 600,
  borderRadius: "8px",
  textTransform: "none",
};
const menuItemSx = { fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" };

// ── Helpers ───────────────────────────────────────────────────────────────────
const getResultColor = (value) => {
  if (value === "Ok") return "#2F855A";
  if (value === "Not Ok") return "#E53E3E";
  return "#A0AEC0";
};
const normalizeResult = (value) => {
  if (!value) return "";
  const v = value.trim().replace(/\s+/g, " ").toLowerCase();
  if (v === "ok") return "Ok";
  if (v === "not ok") return "Not Ok";
  return value === "Ok" || value === "Not Ok" ? value : "";
};
const getStatusSx = (value) => (value === "Not Ok" ? notOkInputSx : okInputSx);



const getTestDueAlert = (cyl) => {
  const raw = cyl?.hydrotest_date;
  if (!raw) return "";
  const done = dayjs(raw);
  if (!done.isValid()) return "";
  const due = done.add(2, "year");
  const daysLeft = due.startOf("day").diff(dayjs().startOf("day"), "day");
  if (daysLeft >= 45) return "";
  const name = cyl.cylinder_no || cyl.tag_no || "";
  const dueStr = due.format("DD/MM/YYYY");
  return daysLeft < 0
    ? `Cylinder ${name}: hydrotest overdue! Due date was ${dueStr} (${Math.abs(daysLeft)} days ago).`
    : `Cylinder ${name}: hydrotest due on ${dueStr} (only ${daysLeft} days left).`;
};

// ─────────────────────────────────────────────────────────────────────────────

const EmptyCylinderInspectionAdd = () => {
  const dispatch = useDispatch();
  const { handleSubmit } = useForm();
  const urlLocation = useLocation();
  const editInfo = urlLocation.state;
  const editData = editInfo && editInfo;
  const navigate = useNavigate();
  const login_details = sessionStorage.getItem("loginUser");
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;
  const depot_id = userInfo.depot_id;
  const plant_id = userInfo.plant_id;
  const unit_id = userInfo.depot_id || userInfo.plant_id;
  const short_code = userInfo.depot_short_code || userInfo.plant_short_code;

  const [filteredTableData, setFilteredTableData] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});

  const [data, setData] = useState({
    acetone_used: editData ? editData.acetone_used : "0.00",
    inspection_done_by: editData ? editData.inspection_done_by : "",
    cyl_id: editData ? editData.cyl_id : "",
    inspection_id: editData ? editData.inspection_id : "",
    entry_no: editData ? editData.entry_no : "",
    entry_date: editData?.entry_date ? dayjs(editData.entry_date).format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD"),
    cylinder_no: editData ? editData.cylinder_no : "",
    valve_condition: editData ? normalizeResult(editData.valve_condition) : "Ok",
    fusible_plug: editData ? normalizeResult(editData.fusible_plug) : "Ok",
    painting: editData ? normalizeResult(editData.painting) : "Ok",
    cyl_cap_avl: editData ? normalizeResult(editData.cyl_cap_avl) : "Ok",
    eci_result: editData ? normalizeResult(editData.eci_result) : "OK",
    current_tare_wt: editData ? editData.current_tare_wt : "",
    actual_tare_wt: editData ? editData.actual_tare_wt : "",
    actual_tare_wt_aft_sol: editData ? editData.actual_tare_wt_aft_sol : "",
    qty_solvent: editData ? editData.qty_solvent : "",
    acetone_drum_tag_no: editData ? editData.acetone_drum_tag_no : "",
    from_depot: editData ? editData.from_depot : "",
    from_plant_id: unit_id,
    to_plant_id: unit_id,
    shift: editData ? editData.shift : "shift1",
    shift_time: editData ? editData.shift_time : "08:00",
    done_by: editData ? editData.done_by : "",
    fin_year: editData ? editData.fin_year : dayjs().month() >= 3 ? `${dayjs().year()}-${dayjs().year() + 1}` : `${dayjs().year() - 1}-${dayjs().year()}`,
    unit_id: editData ? editData.unit_id : unit_id,
    modified_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    modified_by: editData ? userInfo.user_id : null,
    created_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    created_by: editData ? editData.created_by : userInfo.user_id,
  });

  const [cylinder, setCylinder] = useState([]);
  const [plant, setPlant] = useState([]);
  const [depot, setDepot] = useState([]);
  const [ecimap, setEcimap] = useState([]);
  const [operatorList, setOperatorList] = useState([]);
  const [tagMap, setTagMap] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [isMultiDialog, setIsMultiDialog] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [dialogData, setDialogData] = useState({
    cylinder_no: "", cyl_id: "", tag_no: "",
    valve_condition: "Ok", fusible_plug: "Ok", painting: "Ok", cyl_cap_avl: "Ok", eci_result: "OK",
    current_tare_wt: "", actual_tare_wt: "", actual_tare_wt_aft_sol: "", qty_solvent: "",
    acetone_drum_tag_no: "", from_plant: "", to_plant: "", shift_time: "", shift: "", done_by: "",
  });
  const [multiDialogData, setMultiDialogData] = useState({ cylinder_nos: "" });
  const [editIndex, setEditIndex] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [controller, setController] = useState({ page: 0, rowsPerPage: 10 });
  const total_count = filteredTableData.length;

  const handleChangePage = (event, newPage) => {
    setController(prev => ({ ...prev, page: newPage }));
  };

  // const paginatedTableData = filteredTableData.slice(
  //   controller.page * controller.rowsPerPage,
  //   controller.page * controller.rowsPerPage + controller.rowsPerPage
  // );

  const paginatedTableData = filteredTableData;

  const [isScannerOpen, setIsScannerOpen] = useState(false);
  const [scanResults, setScanResults] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const qrCodeRegionId = "qr-reader";
  const html5QrCodeRef = useRef(null);
  const scannerStateRef = useRef({ isStarting: false, isStopping: false });
  const lastScanTimeRef = useRef(0);
  const debounceDelay = 500;
  const [singleCylinderInput, setSingleCylinderInput] = useState("");
  const [singleCylinderDetails, setSingleCylinderDetails] = useState(null);
  const [multiCylinders, setMultiCylinders] = useState([]);

  const handleChange = ({ target }) => {
    const { name, value } = target;
    if (name === "entry_date") {
      const formattedDate = dayjs(value).isValid() ? dayjs(value).format("YYYY-MM-DD") : "";
      const financialYear = formattedDate
        ? dayjs(formattedDate).month() >= 3
          ? `${dayjs(formattedDate).year()}-${dayjs(formattedDate).year() + 1}`
          : `${dayjs(formattedDate).year() - 1}-${dayjs(formattedDate).year()}`
        : "";
      setData(prev => ({ ...prev, entry_date: formattedDate, fin_year: financialYear }));
     } else {
      setData(prev => ({ ...prev, [name]: value }));
      if (name === "inspection_done_by" && value) {
        setValidationErrors(prev => {
          const { inspection_done_by, ...rest } = prev;
          return rest;
        });
      }
    }
  };

  useEffect(() => {
    const total = tableData.reduce((sum, row) => sum + (parseFloat(row.qty_solvent) || 0), 0);
    const totalFixed = total > 0 ? total.toFixed(2) : "0.00";
    setData(prev => ({ ...prev, acetone_used: totalFixed }));
  }, [tableData]);

  useEffect(() => {
    setFilteredTableData(tableData);
  }, [tableData]);
const [aftSolTouched, setAftSolTouched] = useState(false);
const [testDueAlert, setTestDueAlert] = useState("");
  const handleDialogChange = async ({ target }) => {
    const { name, value } = target;
    let normalizedValue = value;
    if (["valve_condition", "fusible_plug", "painting", "cyl_cap_avl", "eci_result"].includes(name)) {
      normalizedValue = normalizeResult(value);
    }
    let newDialogData = { ...dialogData };
 if (["current_tare_wt", "actual_tare_wt", "actual_tare_wt_aft_sol"].includes(name)) {
  normalizedValue = value;
  newDialogData = { ...dialogData, [name]: normalizedValue };

  if (name === "actual_tare_wt_aft_sol") {
    // user ne khud edit kiya — ab auto-sync band
    setAftSolTouched(true);
  }

  if (name === "current_tare_wt" && !aftSolTouched) {
    // jab tak user ne aft_sol manually edit nahi kiya, current wt ke sath sync rakho
    newDialogData.actual_tare_wt_aft_sol = normalizedValue;
  }

  const actualTare = name === "actual_tare_wt" ? (parseFloat(normalizedValue) || 0) : (parseFloat(dialogData.actual_tare_wt) || 0);
  const currentWt = name === "current_tare_wt" ? (parseFloat(normalizedValue) || 0) : (parseFloat(dialogData.current_tare_wt) || 0);
  const aftSol = parseFloat(newDialogData.actual_tare_wt_aft_sol) || 0;

  const errors = {};
  if (currentWt > 0 && actualTare > 0 && currentWt > actualTare) {
    errors.current_tare_wt = `Current Weight (${currentWt}) cannot be more than Actual Tare Weight (${actualTare})`;
  }
  if (aftSol > 0 && actualTare > 0 && aftSol > actualTare) {
    errors.actual_tare_wt_aft_sol = `Weight After Solvent (${aftSol}) cannot be more than Actual Tare Weight (${actualTare})`;
  } else if (aftSol > 0 && currentWt > 0 && aftSol < currentWt) {
    errors.actual_tare_wt_aft_sol = `Weight After Solvent (${aftSol}) should not be less than Current Weight (${currentWt})`;
  }
  setValidationErrors(errors);

  newDialogData.qty_solvent = (aftSol - currentWt).toFixed(2);
} else if (name === "qty_solvent") {
      normalizedValue = parseFloat(value);
      newDialogData = { ...dialogData, qty_solvent: normalizedValue };
    } else if (name === "cylinder_no") {
      const selectedCylinder = cylinder.find(cyl => cyl.tag_no === value);
      let cylinderCode = selectedCylinder ? selectedCylinder.cylinder_no : "";
      if (!cylinderCode && value) {
        try {
          const cylinderData = await cylinderMasterService.getCylinderList(value);
          cylinderCode = cylinderData.cylinder_no || "";
        } catch (error) { console.error("Error fetching cylinder_no:", error); }
      }
      setTestDueAlert(getTestDueAlert(selectedCylinder));
      newDialogData = {
        ...dialogData,
        cylinder_no: value,
        cyl_id: selectedCylinder ? selectedCylinder.cyl_id : "",
        tag_no: selectedCylinder ? selectedCylinder.cylinder_no : "",
        eci_result: normalizeResult(selectedCylinder?.level ?? selectedCylinder?.note) || dialogData.eci_result,
        actual_tare_wt: selectedCylinder?.tare_wt ? selectedCylinder.tare_wt : dialogData.actual_tare_wt,
      };
    } else {
      newDialogData = { ...dialogData, [name]: normalizedValue };
    }
    setDialogData(newDialogData);
  };

  const handleMultiDialogChange = ({ target }) => setMultiDialogData({ cylinder_nos: target.value });

  const resetValidation = () => setValidationErrors({});

  const handleOpenDialog = () => {
    setDialogData({
      cylinder_no: "", cyl_id: "", tag_no: "",
      valve_condition: "Ok", fusible_plug: "Ok", painting: "Ok", cyl_cap_avl: "Ok", eci_result: "OK",
      current_tare_wt: "", actual_tare_wt: "", actual_tare_wt_aft_sol: "", qty_solvent: "",
      acetone_drum_tag_no: "", from_plant: "", to_plant: "", done_by: "",
    });
    resetValidation();
    setTestDueAlert("");
     setAftSolTouched(false);  setEditIndex(null); setIsMultiDialog(false); setOpenDialog(true); setScanResults([]);
  };

  const handleOpenmulDialog = () => {
    setMultiDialogData({ cylinder_nos: "" });
    resetValidation();
    setTestDueAlert("");
    setEditIndex(null); setIsMultiDialog(true); setOpenDialog(true); setScanResults([]);
  };

  // const handleEditRow = (index) => {
  //   setDialogData({ ...tableData[index], eci_result: normalizeResult(tableData[index].eci_result) || "Ok" });
  //   resetValidation();
  //   setEditIndex(index); setIsMultiDialog(false); setOpenDialog(true); setScanResults([]);
  // };
  const handleEditRow = (rowData) => {
  const actualIndex = tableData.findIndex(row => row.cyl_id === rowData.cyl_id);
  if (actualIndex === -1) return;

  const fullCyl = cylinder.find(c => c.cyl_id === rowData.cyl_id);
  console.log("DEBUG fullCyl:", fullCyl, "hydrotest:", fullCyl?.hydrotest_date);

  setDialogData({ ...tableData[actualIndex], eci_result: normalizeResult(tableData[actualIndex].eci_result) || "Ok" });
  setTestDueAlert(getTestDueAlert(fullCyl || rowData));
  resetValidation();
  setEditIndex(actualIndex); setIsMultiDialog(false); setOpenDialog(true); setScanResults([]);
};
  const handleCloseDialog = () => {
    stopScanner();
    resetValidation();
    setTestDueAlert("");
    setOpenDialog(false);
    setScanResults([]);
  };

  const handleDialogSubmit = () => {
    if (isMultiDialog) {
      if (!multiCylinders.length) { setSuccessMessage("Please enter at least one valid cylinder"); setOpenSnackbar(true); return; }
      const newRows = multiCylinders
        .filter(cyl => !tableData.some((row, idx) => idx !== editIndex && row.cyl_id === cyl.cyl_id))
        .map(cyl => ({
          cylinder_no: cyl.cylinder_no, cyl_id: cyl.cyl_id, tag_no: cyl.tag_no,
          valve_condition: "Ok", fusible_plug: "Ok", painting: "Ok", cyl_cap_avl: "Ok", eci_result: "",
          current_tare_wt: 0, actual_tare_wt: cyl.tare_wt || 0, actual_tare_wt_aft_sol: 0,
          qty_solvent: 0, acetone_drum_tag_no: "", from_plant: "", to_plant: "",
          shift_time: data.shift_time, shift: data.shift, done_by: data.done_by,
        }));
      if (!newRows.length) { setSuccessMessage("All cylinders already added"); setOpenSnackbar(true); return; }
      setTableData(prev => [...prev, ...newRows]);
      setMultiCylinders([]); setMultiDialogData({ cylinder_nos: "" }); setOpenDialog(false); stopScanner();
      setSuccessMessage("Cylinders added successfully"); setOpenSnackbar(true);
    } else {
      // const requiredFields = [
      //   { key: "cylinder_no", name: "Cylinder Number" },
      //   { key: "valve_condition", name: "Valve Condition" },
      //   { key: "fusible_plug", name: "Fusible Plug" },
      //   { key: "painting", name: "Painting" },
      //   { key: "cyl_cap_avl", name: "Cylinder Cap Availability" },
      //   { key: "eci_result", name: "ECI Result" },
      // ];
      // const missingFields = requiredFields.filter(field => !dialogData[field.key]);
      // if (missingFields.length > 0) { setSuccessMessage(`Please fill: ${missingFields.map(f => f.name).join(", ")}`); setOpenSnackbar(true); return; }

      const requiredFields = [
  { key: "cylinder_no", name: "Cylinder Number" },
  { key: "valve_condition", name: "Valve Condition" },
  { key: "fusible_plug", name: "Fusible Plug" },
  { key: "painting", name: "Painting" },
  { key: "cyl_cap_avl", name: "Cylinder Cap Availability" },
  { key: "eci_result", name: "ECI Result" },
];
if (dialogData.eci_result === "Ok") {
  requiredFields.push(
    { key: "actual_tare_wt", name: "Actual Tare Weight" },
    { key: "current_tare_wt", name: "Current Weight" },
    { key: "actual_tare_wt_aft_sol", name: "Weight After Solvent" }
  );
}
const missingFields = requiredFields.filter(field => {
  const val = dialogData[field.key];
  return val === "" || val === null || val === undefined;
});
if (missingFields.length > 0) { setSuccessMessage(`Please fill: ${missingFields.map(f => f.name).join(", ")}`); setOpenSnackbar(true); return; }

      // Validation errors check
      if (Object.keys(validationErrors).length > 0) {
        setSuccessMessage(Object.values(validationErrors)[0]);
        setOpenSnackbar(true);
        return;
      }

      if (tableData.some((row, idx) => idx !== editIndex && row.cyl_id === dialogData.cyl_id)) { setSuccessMessage("Cylinder already added"); setOpenSnackbar(true); return; }
      const normalizedDialogData = {
        ...dialogData,
        valve_condition: normalizeResult(dialogData.valve_condition),
        fusible_plug: normalizeResult(dialogData.fusible_plug),
        painting: normalizeResult(dialogData.painting),
        cyl_cap_avl: normalizeResult(dialogData.cyl_cap_avl),
        eci_result: normalizeResult(dialogData.eci_result),
        remarks: dialogData.eci_result === "Not Ok" ? dialogData.remarks || "" : "",
        current_tare_wt: dialogData.current_tare_wt ? Number(dialogData.current_tare_wt) || 0 : 0,
        actual_tare_wt: dialogData.actual_tare_wt ? Number(dialogData.actual_tare_wt) || 0 : 0,
        actual_tare_wt_aft_sol: dialogData.actual_tare_wt_aft_sol ? Number(dialogData.actual_tare_wt_aft_sol) || 0 : 0,
        qty_solvent: dialogData.qty_solvent ? Number(dialogData.qty_solvent) || 0 : 0,
        acetone_drum_tag_no: dialogData.acetone_drum_tag_no || "",
      };
      if (urlLocation.state?.openDialog) {
        setSuccessMessage("Inspection details saved"); setOpenSnackbar(true); setOpenDialog(false); stopScanner();
      } else {
        if (editIndex !== null) setTableData(prev => { const n = [...prev]; n[editIndex] = normalizedDialogData; return n; });
        else setTableData(prev => [...prev, normalizedDialogData]);
        setSuccessMessage("Cylinder details saved"); setOpenSnackbar(true); setOpenDialog(false); stopScanner();
      }
    }
  };

const handleRemoveRow = (rowData) => setTableData(prev => prev.filter(row => row.cyl_id !== rowData.cyl_id));

  const startScanner = () => {
    if (scannerStateRef.current.isStarting || isScannerOpen) return;
    scannerStateRef.current.isStarting = true;
    setIsScannerOpen(true);
  };

  const stopScanner = () => {
    if (scannerStateRef.current.isStopping || !html5QrCodeRef.current) { setIsScannerOpen(false); return; }
    if (!html5QrCodeRef.current.isScanning) { setIsScannerOpen(false); return; }
    scannerStateRef.current.isStopping = true;
    html5QrCodeRef.current.stop()
      .then(() => { html5QrCodeRef.current.clear(); setIsScannerOpen(false); scannerStateRef.current.isStopping = false; })
      .catch(() => { setIsScannerOpen(false); scannerStateRef.current.isStopping = false; });
  };

  const findCylinderByNoOrTag = (input, cylinderList) => {
    if (!input) return null;
    const val = input.trim().toLowerCase();
    return cylinderList.find(cyl =>
      (cyl.cylinder_no && cyl.cylinder_no.toLowerCase() === val) ||
      (cyl.tag_no && cyl.tag_no.toLowerCase() === val)
    );
  };

  const fetchSingleCylinderDetails = (input) => {
    if (!input) { setSingleCylinderDetails(null); return; }
    const match = findCylinderByNoOrTag(input, cylinder);
    if (match) {
      setSingleCylinderDetails(match);
       setTestDueAlert(getTestDueAlert(match));
      setDialogData(prev => ({
        ...prev, cylinder_no: match.tag_no, tag_no: match.cylinder_no,
        owner: match.owner, cyl_id: match.cyl_id, actual_tare_wt: match.tare_wt, eci_result: prev.eci_result,
      }));
      setSuccessMessage("Cylinder found"); setOpenSnackbar(true); setSingleCylinderInput("");
    } else { setSingleCylinderDetails(null); setSuccessMessage("No cylinder found"); setOpenSnackbar(true); }
  };

  const addMultiCylinder = (input) => {
    if (!input) return;
    const match = findCylinderByNoOrTag(input, cylinder);
  if (match) {
      const dueMsg = getTestDueAlert(match);
      if (dueMsg) setTestDueAlert(dueMsg);
      setMultiCylinders(prev => {
        if (prev.some(c => c.cyl_id === match.cyl_id)) { setSuccessMessage("Already added"); setOpenSnackbar(true); return prev; }
        setSuccessMessage("Cylinder added"); setOpenSnackbar(true);
        return [...prev, match];
      });
    } else { setSuccessMessage("No cylinder found"); setOpenSnackbar(true); }
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const [cylinderData, plantData, depotData, ecimapData, RelatedCylinder, operatorData] =
          await Promise.all([
            cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: "" }),
            plantMasterService.getPlantList({ page: 0, size: 999, searchKey: "" }),
            depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
            emptyCylinderInspectionService.getEciList({ page: 0, size: 999, searchKey: "" }),
            emptyCylinderInspectionService.getCylinders(plant_id),
            operatorMasterService.getOperatorList({ page: 0, size: 999, searchKey: "" }),
          ]);

        if (!Array.isArray(RelatedCylinder)) throw new Error("cylinderData is not an array");

        setCylinder(RelatedCylinder);
        setPlant(plantData);
        setDepot(depotData);
        setEcimap(ecimapData);
        setOperatorList(Array.isArray(operatorData) ? operatorData : []);

        if (!editData) {
          const lastRaw = ecimapData?.[0]?.lastECIEntryNo ?? "";
          const parts = String(lastRaw).split("/");
          const lastSeq = parseInt(parts[parts.length - 1]) || 0;
          const nextSeq = lastSeq + 1;
          const yr = dayjs();
          const finYear = yr.month() >= 3
            ? `${yr.year()}-${String(yr.year() + 1).slice(-2)}`
            : `${yr.year() - 1}-${String(yr.year()).slice(-2)}`;
          const formattedEntryNo = `${short_code}/${finYear}/${String(nextSeq).padStart(4, "0")}`;
          setData(prev => ({ ...prev, entry_no: formattedEntryNo }));
        }

        const tagMapping = {};
        cylinderData.forEach(item => {
          if (!item.is_deleted) {
            if (item.cylinder_no?.trim()) tagMapping[item.cylinder_no.trim().toLowerCase()] = { cylinder_no: item.tag_no, cyl_id: item.cyl_id, tag_no: item.cylinder_no };
            if (item.tag_no?.trim()) tagMapping[item.tag_no.trim().toLowerCase()] = { cylinder_no: item.tag_no, cyl_id: item.cyl_id, tag_no: item.cylinder_no };
          }
        });
        setTagMap(tagMapping);

        const userPlant = plantData.find(p => p.plant_id === plant_id);
        if (userPlant) {
          setData(prev => ({ ...prev, from_plant: userPlant.plant_name }));
          setDialogData(prev => ({ ...prev, from_plant: userPlant.plant_name }));
        }
      } catch (error) { console.error("Error fetching data:", error); }
    }
    fetchData();
  }, [plant_id]);

  useEffect(() => {
    if (editData && typeof editData.tableData === "string") {
      try {
        const parsed = JSON.parse(editData.tableData);
        setTableData(parsed.map(row => ({
          ...row,
          valve_condition: normalizeResult(row.valve_condition),
          fusible_plug: normalizeResult(row.fusible_plug),
          painting: normalizeResult(row.painting),
          cyl_cap_avl: normalizeResult(row.cyl_cap_avl),
          eci_result: normalizeResult(row.eci_result),
          actual_tare_wt: row.actual_tare_wt || "",
        })));
      } catch (e) { setTableData([]); }
    }
    if (editData) {
      setData(prev => ({
        ...prev,
        inspection_done_by: editData.inspection_done_by || "",
      }));
    }
  }, [editData]);

  useEffect(() => {
    if (!isScannerOpen || !openDialog) { if (html5QrCodeRef.current?.isScanning) stopScanner(); return; }
    const element = document.getElementById(qrCodeRegionId);
    if (!element) { setIsScannerOpen(false); scannerStateRef.current.isStarting = false; return; }
    if (html5QrCodeRef.current?.isScanning) { scannerStateRef.current.isStarting = false; return; }
    html5QrCodeRef.current = new Html5Qrcode(qrCodeRegionId);
    const onQrScanSuccess = (decodedText) => {
      const now = Date.now();
      if (now - lastScanTimeRef.current < debounceDelay) return;
      lastScanTimeRef.current = now;
      if (isMultiDialog) {
        setMultiDialogData({ cylinder_nos: decodedText });
        addMultiCylinder(decodedText);
        setTimeout(() => setMultiDialogData({ cylinder_nos: "" }), 1000);
      } else { fetchSingleCylinderDetails(decodedText); stopScanner(); }
      setScanResults(prev => [...prev, decodedText]);
    };
    html5QrCodeRef.current
      .start({ facingMode: "environment" }, { fps: 10, qrbox: 250 }, onQrScanSuccess, () => {})
      .then(() => { scannerStateRef.current.isStarting = false; })
      .catch(() => { setIsScannerOpen(false); scannerStateRef.current.isStarting = false; });
    return () => {
      if (html5QrCodeRef.current?.isScanning && !scannerStateRef.current.isStopping) {
        try { html5QrCodeRef.current.stop(); html5QrCodeRef.current.clear(); } catch {}
      }
    };
  }, [isScannerOpen, openDialog, isMultiDialog, tagMap, cylinder, depot, depot_id, tableData, editIndex]);

  useEffect(() => {
    if (urlLocation.state?.openDialog && urlLocation.state?.rowData) {
      const row = urlLocation.state.rowData;
      setSingleCylinderDetails({
        cylinder_no: row.cylinder_no || "", tag_no: row.tag_no || "",
        cyl_id: row.cyl_id || "", owner: row.owner || "N/A", cust_name: row.cust_name || "",
      });
      setDialogData({
        cylinder_no: row.cylinder_no || "", cyl_id: row.cyl_id || "", tag_no: row.tag_no || "",
        owner: row.owner || "",
        valve_condition: normalizeResult(row.valve_condition) || "Ok",
        fusible_plug: normalizeResult(row.fusible_plug) || "Ok",
        painting: normalizeResult(row.painting) || "Ok",
        cyl_cap_avl: normalizeResult(row.cyl_cap_avl) || "Ok",
        eci_result: normalizeResult(row.eci_result) || "Ok",
        current_tare_wt: row.current_tare_wt || "", actual_tare_wt: row.actual_tare_wt || "",
        actual_tare_wt_aft_sol: row.actual_tare_wt_aft_sol || "", qty_solvent: row.qty_solvent || "",
        acetone_drum_tag_no: row.acetone_drum_tag_no || "",
        from_plant: row.from_plant || data.from_plant || "", to_plant: row.to_plant || "",
        shift_time: row.shift_time || data.shift_time || "08:00",
        shift: row.shift || data.shift || "shift1",
        done_by: row.done_by || data.done_by || "",
      });
      setSingleCylinderInput(row.cylinder_no || ""); setEditIndex(null); setIsMultiDialog(false); setOpenDialog(true);
      setTestDueAlert(getTestDueAlert(cylinder.find(c => c.cyl_id === row.cyl_id) || row));
    }
  }, [urlLocation.state, data.from_plant, data.shift, data.shift_time, data.done_by]);

  useEffect(() => {
    async function fetchAndMapCylinders() {
      try {
        const cylinderData = await emptyCylinderInspectionService.getCylinders(plant_id);
        if (!Array.isArray(cylinderData)) throw new Error("Not an array");
        setTableData(cylinderData.map(cyl => ({
          cylinder_no: cyl.cylinder_no || "", cyl_id: cyl.cyl_id || "",
          tag_no: cyl.tag_no || "", owner: cyl.owner || "",
          valve_condition: "Ok", fusible_plug: "Ok", painting: "Ok", cyl_cap_avl: "Ok", eci_result: "",
          current_tare_wt: "", actual_tare_wt: cyl.tare_wt ? Number(cyl.tare_wt) : "",
          actual_tare_wt_aft_sol: "", qty_solvent: "", acetone_drum_tag_no: "",
          from_plant: data.from_plant || "", to_plant: "",
          shift: data.shift || "shift1", shift_time: data.shift_time || "08:00",
          done_by: data.done_by || "",
        })));
      } catch (error) { setTableData([]); }
    }
    fetchAndMapCylinders();
  }, [plant_id, data.from_plant, data.shift, data.shift_time, data.done_by]);

  const [isSubmitting, setIsSubmitting] = useState(false);

 const onSubmit = async () => {
  if (isSubmitting) return; // block duplicate clicks

  if (!data.inspection_done_by || data.inspection_done_by.trim() === "") {
    setValidationErrors(prev => ({ ...prev, inspection_done_by: "Inspection Done By is required" }));
    setSuccessMessage("Please select Inspection Done By");
    setOpenSnackbar(true);
    return;
  }

  if (!data || Object.keys(data).length === 0 || tableData.length === 0) {
      setSuccessMessage("Please fill required fields"); setOpenSnackbar(true); return;
    }
    const validTableData = tableData.filter(row => row.eci_result === "Ok" || row.eci_result === "Not Ok");
    if (validTableData.length === 0) { setSuccessMessage("No record to save"); setOpenSnackbar(true); return; }

    setIsSubmitting(true);
    const entryDate = data.entry_date || dayjs().format("YYYY-MM-DD");
    const existingData = JSON.parse(localStorage.getItem("inspectionAcetoneByDate") || "{}");
    const previousValue = parseFloat(existingData[entryDate] || 0);
    const currentValue = parseFloat(data.acetone_used || 0);
    existingData[entryDate] = previousValue + currentValue;
    localStorage.setItem("inspectionAcetoneByDate", JSON.stringify(existingData));

    const eciData = {
      ...data, inspection_done_by: data.inspection_done_by || "", entry_date: dayjs(data.entry_date).format("YYYY-MM-DD"),
      tableData: validTableData, modified_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      created_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      changedUpdatedValue: "edit", short_code, unit_id,
    };
    try {
      if (editData) await emptyCylinderInspectionService.editDeleteEci(eciData);
      else await emptyCylinderInspectionService.addEci(eciData);
      setSuccessMessage(editData ? "Updated successfully" : "Saved successfully");
      setOpenSnackbar(true);
      setTimeout(() => { setOpenSnackbar(false); navigate(-1); }, 3000);
    } catch (error) { setSuccessMessage("Error occurred during save"); setOpenSnackbar(true); setIsSubmitting(false); }
  };

  const shiftOptions = [
    { label: "Shift 1", value: "shift1" },
    { label: "Shift 2", value: "shift2" },
    { label: "Shift 3", value: "shift3" },
  ];

  const StatusPill = ({ value }) => {
    const isOk = value === "Ok";
    const isNotOk = value === "Not Ok";
    return (
      <Box sx={{
        display: "inline-flex", alignItems: "center", px: 1.5, py: 0.3,
        borderRadius: "20px", fontSize: "11px", fontWeight: 600,
        background: isOk ? "#F0FFF4" : isNotOk ? "#FFF5F5" : "#F7FAFC",
        color: isOk ? "#2F855A" : isNotOk ? "#E53E3E" : "#A0AEC0",
      }}>
        {value || "—"}
      </Box>
    );
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={pageSx}>
        {/* Breadcrumb */}
        <Box sx={breadcrumbSx}>
          <span>Dashboard</span> / <span style={{ color: "#2B6CB0", fontWeight: 600 }}>Empty Cylinder Inspection</span>
        </Box>

        {/* Page Header */}
        <Box sx={pageHeaderSx}>
          <Box sx={pageTitleSx}>
            <SearchIcon sx={{ fontSize: 20, color: "#1C3A5E" }} />
            {editData ? "UPDATE" : "CREATE"} INSPECTION
          </Box>
          <Button onClick={() => navigate(-1)} sx={backBtnSx}>
            <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
          </Button>
        </Box>

        {/* Last Entry */}
        {!editData && (
          <Box sx={{ textAlign: "right", fontSize: "12px", color: "#718096", mb: 1.5 }}>
            Last Entry No: {ecimap?.[0]?.lastScheduleEntryNo ?? 0}
          </Box>
        )}

        <form onSubmit={handleSubmit(onSubmit)}>
          {/* ── Section 1: Inspection Details ────────────────────────── */}
          <Box sx={formCardSx}>
            <Box sx={sectionHeaderSx}>
              <SearchIcon sx={{ fontSize: 18, color: "#fff" }} />
              <Typography sx={sectionHeaderTitleSx}>Inspection Details</Typography>
            </Box>
            <Box sx={formBodySx}>
              <Grid container sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>

                {/* LEFT COLUMN - Search */}
                <Grid item xs={12} md={6} sx={{
                  p: 2.5,
                  borderBottom: { xs: "2px dashed #CBD5E0", md: "none" },
                  display: "flex", alignItems: "flex-end", justifyContent: "flex-start", minHeight: 200,
                }}>
                  <Box sx={{ width: "100%", maxWidth: "360px" }}>
                    <Typography sx={fieldLabelSx}>Search Cylinder</Typography>
                    <TextField
                      size="small"
                      fullWidth
                      placeholder="Search by Cyl No or Tag No"
                      sx={inputSx}
                      onChange={(e) => {
                        const val = e.target.value.trim().toLowerCase();
                        if (!val) { setFilteredTableData(tableData); return; }
                        setFilteredTableData(
                          tableData.filter(row =>
                            row.cylinder_no?.toLowerCase().includes(val) ||
                            row.tag_no?.toLowerCase().includes(val)
                          )
                        );
                      }}
                      InputProps={{
                        startAdornment: (
                          <Box sx={{
                            display: "flex", alignItems: "center", justifyContent: "center",
                            background: "#1C3A5E", borderRadius: "6px",
                            padding: "4px 8px", mr: 1, ml: "-8px",
                          }}>
                            <SearchIcon sx={{ fontSize: 16, color: "#fff" }} />
                          </Box>
                        ),
                      }}
                    />
                  </Box>
                </Grid>

                {/* RIGHT COLUMN */}
                <Grid item xs={12} md={6} sx={{ p: 2.5, background: "#FAFBFC", pl: 3.5 }}>
                  <Grid container spacing={1.5}>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={fieldLabelSx}>Entry No</Typography>
                      <TextField size="small" fullWidth name="entry_no" value={data.entry_no} sx={readonlyInputSx} InputProps={{ readOnly: true }} placeholder="Auto-generated" />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={fieldLabelSx}>Entry Date <span style={{ color: "#E53E3E" }}>*</span></Typography>
                      <DatePicker
                        format="DD/MM/YYYY"
                        value={data.entry_date ? dayjs(data.entry_date) : null}
                        onChange={nv => handleChange({ target: { name: "entry_date", value: nv ? nv.format("YYYY-MM-DD") : "" } })}
                        slotProps={{ textField: { size: "small", fullWidth: true, required: true, sx: inputSx } }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={fieldLabelSx}>Shift</Typography>
                      <Autocomplete
                        options={shiftOptions} fullWidth
                        getOptionLabel={o => typeof o === "string" ? o : o.label}
                        value={shiftOptions.find(s => s.value === data.shift) || null}
                        onChange={(e, nv) => handleChange({ target: { name: "shift", value: nv ? nv.value : "" } })}
                        isOptionEqualToValue={(o, v) => o.value === v.value}
                        renderOption={(props, option) => <MenuItem {...props} sx={menuItemSx}>{option.label}</MenuItem>}
                        renderInput={(params) => <TextField {...params} size="small" fullWidth sx={inputSx} placeholder="Select shift" />}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={fieldLabelSx}>Shift Time</Typography>
                      <TextField type="time" size="small" fullWidth name="shift_time" value={data.shift_time} onChange={handleChange} sx={inputSx} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={fieldLabelSx}>Inspection Done By <span style={{ color: "#E53E3E" }}>*</span></Typography>
                    <TextField
  select
  size="small"
  fullWidth
  name="inspection_done_by"
  value={data.inspection_done_by || ""}
  onChange={handleChange}
  sx={validationErrors.inspection_done_by ? errorInputSx : inputSx}
  displayEmpty
  error={!!validationErrors.inspection_done_by}
  helperText={validationErrors.inspection_done_by}
  FormHelperTextProps={{ sx: { fontSize: "11px", color: "#E53E3E" } }}
>
                        {/* <MenuItem value="" sx={menuItemSx}><em style={{ color: "#A0AEC0" }}>Select Operator</em></MenuItem> */}
                        {operatorList.map((op) => (
                          <MenuItem key={op.operator_id} value={op.operator_name} sx={menuItemSx}>{op.operator_name}</MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6}>
  <Typography sx={fieldLabelSx}>Acetone Used (KG) <span style={{ color: "#E53E3E" }}>*</span></Typography>
  <TextField size="small" fullWidth value={data.acetone_used} sx={readonlyInputSx} InputProps={{ readOnly: true }} placeholder="Auto-calculated" />
</Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Box>

          {/* ── Section 2: Cylinder Inspection Table ─────────────────── */}
          <Box sx={formCardSx}>
            <TableContainer>
              <Table size="small" stickyHeader>
                <TableHead>
                  <tr>
                    {[
                      { label: "Sr No", align: "center" },
                      { label: "Cyl No", align: "left" },
                      { label: "Tag No", align: "left" },
                      { label: "Valve", align: "left" },
                      { label: "Fusible Plug", align: "left" },
                      { label: "Painting", align: "left" },
                      { label: "Cap Avl", align: "left" },
                      { label: "Result", align: "left" },
                      { label: "Actual Tare Wt", align: "right" },
                      { label: "Current Wt", align: "right" },
                      { label: "Wt After Solvent", align: "right" },
                      { label: "Qty Solvent", align: "right" },
                      { label: "Acetone Drum Tag", align: "left" },
                      { label: "Action", align: "center" },
                    ].map(({ label, align }) => (
                      <th key={label} style={{
                        background: "#1C3A5E", color: "#fff", fontSize: "11px", fontWeight: 600,
                        fontFamily: "'Inter', Arial, sans-serif", padding: "10px 10px",
                        borderRight: "1px solid rgba(255,255,255,0.1)", whiteSpace: "nowrap", textAlign: align,
                      }}>{label}</th>
                    ))}
                  </tr>
                </TableHead>
                <TableBody>
                {paginatedTableData.map((row, index) => (
  <tr
    key={row.cyl_id || index}
    onClick={() => handleEditRow(row)}
    style={{ background: index % 2 === 0 ? "#fff" : "#F8FAFC", cursor: "pointer", borderBottom: "1px solid #E2E8F0" }}
    onMouseEnter={e => e.currentTarget.style.background = "#EBF4FF"}
    onMouseLeave={e => e.currentTarget.style.background = index % 2 === 0 ? "#fff" : "#F8FAFC"}
  >
                      <td style={{ padding: "8px 10px", fontSize: "12px", fontFamily: "'Inter'", color: "#2D3748", textAlign: "center" }}>
                    {index + 1}
                      </td>
                      <td style={{ padding: "8px 10px", fontSize: "12px", fontFamily: "'Inter'", color: "#2D3748" }}>{row.cylinder_no}</td>
                      <td style={{ padding: "8px 10px", fontSize: "12px", fontFamily: "'Inter'", color: "#2D3748" }}>{row.tag_no}</td>
                      {["valve_condition", "fusible_plug", "painting", "cyl_cap_avl"].map(field => (
                        <td key={field} style={{ padding: "8px 10px", textAlign: "left" }}>
                          <StatusPill value={row[field]} />
                        </td>
                      ))}
                      <td style={{ padding: "8px 10px", textAlign: "left" }}>
                        <Box sx={{
                          display: "inline-flex", alignItems: "center", px: 1.5, py: 0.3,
                          borderRadius: "20px", fontSize: "11px", fontWeight: 700,
                          background: row.eci_result === "Ok" ? "#F0FFF4" : row.eci_result === "Not Ok" ? "#FFF5F5" : "#F7FAFC",
                          color: row.eci_result === "Ok" ? "#2F855A" : row.eci_result === "Not Ok" ? "#E53E3E" : "#A0AEC0",
                        }}>
                          {row.eci_result === "Ok" ? "Passed" : row.eci_result === "Not Ok" ? "Not Passed" : row.eci_result || "—"}
                        </Box>
                      </td>
                      {[row.actual_tare_wt, row.current_tare_wt, row.actual_tare_wt_aft_sol].map((val, i) => (
                        <td key={i} style={{ padding: "8px 10px", fontSize: "12px", fontFamily: "'Inter'", color: "#2D3748", textAlign: "right" }}>{val}</td>
                      ))}
                      <td style={{ padding: "8px 10px", fontSize: "12px", fontFamily: "'Inter'", color: "#2D3748", textAlign: "right" }}>
                        {Number(row.qty_solvent).toFixed(2)}
                      </td>
                      <td style={{ padding: "8px 10px", fontSize: "12px", fontFamily: "'Inter'", color: "#2D3748" }}>{row.acetone_drum_tag_no}</td>
                     <td style={{ padding: "8px 10px", textAlign: "center" }} onClick={e => e.stopPropagation()}>
  <Box sx={{ display: "flex", justifyContent: "center", gap: 0.5 }}>
    <IconButton size="small" onClick={() => handleEditRow(row)} sx={{ color: "#2063b6", "&:hover": { background: "#EBF4FF" }, borderRadius: "6px" }}>
      <EditIcon sx={{ fontSize: "15px" }} />
    </IconButton>
    <IconButton size="small" onClick={e => { e.stopPropagation(); handleRemoveRow(row); }} sx={{ color: "#E53E3E", "&:hover": { background: "#FFF5F5" }, borderRadius: "6px" }}>
      <DeleteForeverIcon sx={{ fontSize: "16px" }} />
    </IconButton>
  </Box>
</td>
                    </tr>
                  ))}
                  {tableData.length === 0 && (
                    <tr>
                      <td colSpan={14} style={{ padding: "32px", textAlign: "center", color: "#A0AEC0", fontSize: "13px", fontFamily: "'Inter'" }}>
                        No cylinders loaded yet. Cylinders will appear here.
                      </td>
                    </tr>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

          

            <Box sx={formFooterSx}>
              <Button sx={cancelBtnSx} onClick={() => navigate(-1)}>Cancel</Button>
              <Button type="submit" sx={saveBtnSx} disabled={isSubmitting}>
                <SaveIcon sx={{ fontSize: 18 }} />
                {isSubmitting ? "Saving..." : editData ? "Update" : "Save"}
              </Button>
            </Box>
          </Box>
        </form>

        {/* ── Inspection Dialog ─────────────────────────────────────── */}
        <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth
          PaperProps={{ sx: { borderRadius: "14px", border: "1px solid #E2E8F0" } }}>
          <Box sx={{ background: "#1C3A5E", padding: "14px 22px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Box>
              {editIndex !== null ? (
                <Box sx={{ display: "flex", gap: 3 }}>
                  {[["Cyl No", dialogData.cylinder_no], ["Tag No", dialogData.tag_no], ["Owner", dialogData.owner]].map(([label, val]) => (
                    <Box key={label}>
                      <Typography sx={{ fontSize: "10px", color: "rgba(255,255,255,0.6)", fontFamily: "'Inter'" }}>{label}</Typography>
                      <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#fff", fontFamily: "'Inter'" }}>{val || "N/A"}</Typography>
                    </Box>
                  ))}
                </Box>
              ) : (
                <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#fff", fontFamily: "'Inter'" }}>
                  {isMultiDialog ? "Add Multiple Cylinders" : "Cylinder Inspection"}
                </Typography>
              )}
            </Box>
            <CancelIcon onClick={handleCloseDialog} sx={{ color: "rgba(255,255,255,0.7)", cursor: "pointer", fontSize: 20, "&:hover": { color: "#fff" } }} />
          </Box>

                    <DialogContent sx={{ pt: 3, pb: 1 }}>
{testDueAlert && (
  <Alert
    severity="error"
    variant="filled"
    onClose={() => setTestDueAlert("")}
    sx={{
      mb: 2,
      fontSize: "12.5px",
      fontWeight: 600,
      fontFamily: "'Inter', Arial, sans-serif",
      backgroundColor: "#B71C1C",
      color: "#fff",
      "& .MuiAlert-icon": { color: "#fff" },
      "& .MuiAlert-action": { color: "#fff" },
    }}
  >
    {testDueAlert}
  </Alert>
)}
            {isMultiDialog ? (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                    <Typography sx={{ ...fieldLabelSx, mb: 0, minWidth: "120px" }}>Enter Cyl/Tag No</Typography>
                    <TextField
                      size="small" sx={{ ...inputSx, maxWidth: "200px" }}
                      value={multiDialogData.cylinder_nos}
                      onChange={e => setMultiDialogData({ cylinder_nos: e.target.value })}
                      onBlur={e => addMultiCylinder(e.target.value)}
                      onKeyDown={e => { if (e.key === "Enter") addMultiCylinder(e.target.value); }}
                      placeholder="Scan or type"
                    />
                    <Button
                      variant="contained"
                      onClick={() => {
                        setTableData(prev => [...prev, ...multiCylinders.map(cyl => ({
                          cylinder_no: cyl.cylinder_no, cyl_id: cyl.cyl_id, tag_no: cyl.tag_no,
                          valve_condition: "Ok", fusible_plug: "Ok", painting: "Ok", cyl_cap_avl: "Ok", eci_result: "",
                          current_tare_wt: "", actual_tare_wt: "", actual_tare_wt_aft_sol: "", qty_solvent: "",
                          acetone_drum_tag_no: "", from_plant: "", to_plant: "",
                          shift_time: data.shift_time, shift: data.shift, done_by: data.done_by,
                        }))]);
                        setMultiCylinders([]); setOpenDialog(false); setScanResults([]);
                      }}
                      sx={{ ...saveBtnSx, height: "38px", px: 2 }}
                    >
                      OK
                    </Button>
                  </Box>
                </Grid>
                {isScannerOpen && (
                  <Grid item xs={12}>
                    <Box sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", p: 2, display: "flex", flexDirection: "column", alignItems: "center" }}>
                      <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#1C3A5E", mb: 1 }}>QR Scanner</Typography>
                      <div id={qrCodeRegionId} style={{ width: "100%", maxWidth: "380px", minHeight: "280px" }} />
                    </Box>
                  </Grid>
                )}
                {multiCylinders.length > 0 && (
                  <Grid item xs={12}>
                    <Box sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>
                      <Box sx={{ background: "#F8FAFC", px: 2, py: 1.5, borderBottom: "1px solid #E2E8F0" }}>
                        <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#2063b6" }}>{multiCylinders.length} Cylinders Ready</Typography>
                      </Box>
                      <Table size="small">
                        <TableHead>
                          <TableRow sx={{ background: "#1C3A5E" }}>
                            {["#", "Cylinder No", "Tag No", ""].map(h => <TableCell key={h} sx={{ color: "#fff", fontSize: "11px", fontWeight: 600, py: 1 }}>{h}</TableCell>)}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {multiCylinders.map((row, idx) => (
                            <TableRow key={row.cyl_id} sx={{ "&:nth-of-type(even)": { background: "#F8FAFC" } }}>
                              <TableCell sx={{ fontSize: "12px" }}>{idx + 1}</TableCell>
                              <TableCell sx={{ fontSize: "12px" }}>{row.cylinder_no}</TableCell>
                              <TableCell sx={{ fontSize: "12px" }}>{row.tag_no}</TableCell>
                              <TableCell>
                                <IconButton size="small" onClick={() => setMultiCylinders(prev => prev.filter(c => c.cyl_id !== row.cyl_id))} sx={{ color: "#E53E3E" }}>
                                  <DeleteForeverIcon sx={{ fontSize: "16px" }} />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </Box>
                  </Grid>
                )}
              </Grid>
            ) : (
              <Grid container spacing={2.5}>
                {isScannerOpen && (
                  <Grid item xs={12}>
                    <Box sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", p: 2, display: "flex", flexDirection: "column", alignItems: "center" }}>
                      <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#1C3A5E", mb: 1 }}>QR Scanner</Typography>
                      <div id={qrCodeRegionId} style={{ width: "100%", maxWidth: "380px", minHeight: "280px" }} />
                      {scanResults.map((result, idx) => {
                        const mappedCylinder = tagMap[result?.trim()];
                        return (
                          <ListItem key={idx} sx={{ py: 0.5 }}>
                            <ListItemText
                              primary={`Tag: ${result}`}
                              secondary={mappedCylinder ? `Cyl No: ${mappedCylinder.cylinder_no}` : "❌ Not found"}
                              primaryTypographyProps={{ fontSize: "12px" }}
                              secondaryTypographyProps={{ fontSize: "11px" }}
                            />
                          </ListItem>
                        );
                      })}
                    </Box>
                  </Grid>
                )}
                <Grid item xs={12}><Box sx={{ borderTop: "1px solid #E2E8F0" }} /></Grid>
                {[
                  { key: "valve_condition", label: "Valve Condition" },
                  { key: "fusible_plug", label: "Fusible Plug" },
                  { key: "painting", label: "Painting" },
                  { key: "cyl_cap_avl", label: "Cyl Cap Availability" },
                ].map(({ key, label }) => (
                  <Grid item xs={12} sm={6} key={key}>
                    <Typography sx={fieldLabelSx}>{label}</Typography>
                    <TextField select size="small" fullWidth name={key} value={dialogData[key] || "Ok"} onChange={handleDialogChange} sx={getStatusSx(dialogData[key])}>
                      <MenuItem value="Ok" sx={{ ...menuItemSx, color: "#2F855A" }}>Ok</MenuItem>
                      <MenuItem value="Not Ok" sx={{ ...menuItemSx, color: "#E53E3E" }}>Not Ok</MenuItem>
                    </TextField>
                  </Grid>
                ))}
                <Grid item xs={12} sm={6}>
                  <Typography sx={fieldLabelSx}>Result</Typography>
                  <TextField
                    select size="small" fullWidth name="eci_result"
                    value={dialogData.eci_result || "Ok"}
                    onChange={e => {
                      const val = e.target.value;
                      setDialogData(prev => ({
                        ...prev, eci_result: val,
                        ...(val === "Not Ok" && { current_tare_wt: "", actual_tare_wt_aft_sol: "", qty_solvent: "", acetone_drum_tag_no: "" }),
                      }));
                    }}
                    sx={getStatusSx(dialogData.eci_result)}
                  >
                    <MenuItem value="Ok" sx={{ ...menuItemSx, color: "#2F855A", fontWeight: 600 }}>Passed</MenuItem>
                    <MenuItem value="Not Ok" sx={{ ...menuItemSx, color: "#E53E3E", fontWeight: 600 }}>Not Passed</MenuItem>
                  </TextField>
                </Grid>

                {/* Actual Tare Weight */}
            <Grid item xs={12} sm={6}>
  <Typography sx={fieldLabelSx}>Actual Tare Weight {dialogData.eci_result === "Ok" && <span style={{ color: "#E53E3E" }}>*</span>}</Typography>
  <TextField
    size="small" fullWidth type="number" name="actual_tare_wt"
    value={dialogData.actual_tare_wt}
    onChange={handleDialogChange}
    sx={dialogData.eci_result === "Not Ok" ? readonlyInputSx : (dialogData.eci_result === "Ok" && !dialogData.actual_tare_wt) ? errorInputSx : inputSx}
    InputProps={{ readOnly: dialogData.eci_result === "Not Ok" }}
    disabled={dialogData.eci_result === "Not Ok"}
    error={dialogData.eci_result === "Ok" && !dialogData.actual_tare_wt}
    helperText={dialogData.eci_result === "Ok" && !dialogData.actual_tare_wt ? "Actual Tare Weight is required" : ""}
    FormHelperTextProps={{ sx: { fontSize: "11px", color: "#E53E3E" } }}
  />
</Grid>

                {/* Current Weight — validation */}
                <Grid item xs={12} sm={6}>
                  <Typography sx={fieldLabelSx}>Current Weight {dialogData.eci_result === "Ok" && <span style={{ color: "#E53E3E" }}>*</span>}</Typography>
                  <TextField
                    size="small" fullWidth type="number" name="current_tare_wt"
                    value={dialogData.current_tare_wt}
                    onChange={handleDialogChange}
                sx={dialogData.eci_result === "Not Ok" ? readonlyInputSx : (validationErrors.current_tare_wt || (dialogData.eci_result === "Ok" && !dialogData.current_tare_wt)) ? errorInputSx : inputSx}
disabled={dialogData.eci_result === "Not Ok"}
error={!!validationErrors.current_tare_wt || (dialogData.eci_result === "Ok" && !dialogData.current_tare_wt)}
helperText={validationErrors.current_tare_wt || (dialogData.eci_result === "Ok" && !dialogData.current_tare_wt ? "Current Weight is required" : "")}
                    FormHelperTextProps={{ sx: { fontSize: "11px", color: "#E53E3E" } }}
                  />
                </Grid>

                {/* Weight After Solvent — validation */}
                <Grid item xs={12} sm={6}>
                    <Typography sx={fieldLabelSx}>Weight After Solvent {dialogData.eci_result === "Ok" && <span style={{ color: "#E53E3E" }}>*</span>}</Typography>
                  <TextField
                    size="small" fullWidth type="number" name="actual_tare_wt_aft_sol"
                    value={dialogData.actual_tare_wt_aft_sol}
                    onChange={handleDialogChange}
                   sx={dialogData.eci_result === "Not Ok" ? readonlyInputSx : (validationErrors.actual_tare_wt_aft_sol || (dialogData.eci_result === "Ok" && !dialogData.actual_tare_wt_aft_sol)) ? errorInputSx : inputSx}
disabled={dialogData.eci_result === "Not Ok"}
error={!!validationErrors.actual_tare_wt_aft_sol || (dialogData.eci_result === "Ok" && !dialogData.actual_tare_wt_aft_sol)}
helperText={validationErrors.actual_tare_wt_aft_sol || (dialogData.eci_result === "Ok" && !dialogData.actual_tare_wt_aft_sol ? "Weight After Solvent is required" : "")}
                    FormHelperTextProps={{ sx: { fontSize: "11px", color: "#E53E3E" } }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography sx={fieldLabelSx}>Qty of Solvent</Typography>
                  <TextField size="small" fullWidth type="number" name="qty_solvent" value={Number(dialogData.qty_solvent).toFixed(2)} onChange={handleDialogChange} sx={readonlyInputSx} InputProps={{ readOnly: true }} disabled />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography sx={fieldLabelSx}>Acetone Drum Tag No</Typography>
                  <TextField size="small" fullWidth type="text" name="acetone_drum_tag_no" value={dialogData.acetone_drum_tag_no} onChange={handleDialogChange} sx={dialogData.eci_result === "Not Ok" ? readonlyInputSx : inputSx} disabled={dialogData.eci_result === "Not Ok"} placeholder="Enter tag number" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography sx={fieldLabelSx}>Remarks</Typography>
                  <TextField type="text" size="small" fullWidth name="remarks" value={dialogData.remarks || ""} onChange={handleDialogChange} sx={inputSx} placeholder="Enter remarks" />
                </Grid>
              </Grid>
            )}
          </DialogContent>

          <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
            <Button onClick={handleCloseDialog} sx={cancelBtnSx}>Cancel</Button>
            <Button onClick={handleDialogSubmit} sx={saveBtnSx}>Done</Button>
          </DialogActions>
        </Dialog>

        <ReusableSnackbar
          open={openSnackbar}
          onClose={(e, reason) => { if (reason !== "clickaway") setOpenSnackbar(false); }}
          message={successMessage}
          autoHideDuration={3000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </LocalizationProvider>
  );
};

export default EmptyCylinderInspectionAdd;